import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { PulseLoader } from "react-spinners";
import moment from "moment";
import arrowright from "../../../assets/svg/arrow-right.svg";
import ButtonCancelRequestIcon from "../../../assets/svg/buttoncancelrequestIcon.svg";
import FileIcon from "../documents/folder/FileIcon";
import dateIcon from "../../../assets/svg/calendar-inside.svg";
import arrowleft from "../../../assets/svg/arrow-left.svg";
import NewroleIcon from "../../../assets/svg/role.svg";
import Moment from "moment";
import Pagination from "react-js-pagination";
import calender from "../../../assets/svg/calender.svg";
import infoBlack from "../../../assets/svg/infoBlack.svg";
import file from "../../../assets/svg/File.svg";
import search from "../../../assets/svg/search.svg";
import Filter from "../../../assets/svg/filter.svg";
import LeftArrowIcon from "../../../assets/svg/LeftArrow.svg";
import RightArrowIcon from "../../../assets/svg/RightArrow.svg";
import SubCategoryIcon from "../../../assets/svg/smallcategory.svg";
import URLIcon from "../../../assets/svg/urlIcon.svg";
import URLworldIcon from "../../../assets/svg/urlworldIcon.svg";
import RemarkIcon from "../../../assets/svg/remark.svg";
import NotesIcon from "../../../assets/svg/notesIcon.svg";
import VersionIcon from "../../../assets/svg/versionlog.svg";
import PendingTaskIcon from "../../../assets/svg/mypendingmaxIcon.svg";
import DownArrowIcon from "../../../assets/svg/downarrow.svg";
import NewPropertiesIcon from "../../../assets/svg/propertiesicon.svg";
import DateIcon from "../../../assets/svg/date.svg";
import SearchFileIcon from "../../../assets/svg/Filesearch.svg";
import "react-datepicker/dist/react-datepicker.css";
import "date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Icon from "@material-ui/core/Icon";
import DateFnsUtils from "@date-io/date-fns";
import ButtonApproveIcon from "../../../assets/svg/buttonapproveIcon.svg";
import ButtonReworkIcon from "../../../assets/svg/sendforreworkbuttonIcon.svg";
import UpArrowIcon from "../../../assets/svg/uparrow.svg";
import CrossIcon from "../../../assets/svg/crossIcon.svg";
import AttchementIcon from "../../../assets/svg/AttchementIcon.svg";
import AttchCloseIcon from "../../../assets/svg/AttchCloseIcon.svg";
import RenewIcon from "../../../assets/svg/ButtonRenewIcon.svg";
import obsoleteIcon from "../../../assets/svg/ButtonObsolete.svg";
import ArchiveIcon from "../../../assets/svg/ButtonArchiveIcon.svg";
import ButtonBackIcon from "../../../assets/svg/ButtonBackIcon.svg";
import ButtonSubmitIcon from "../../../assets/svg/ButtonSubmitIcon.svg";
import AuthorIcon from "../../../assets/svg/AuthorIcon.svg";
import WarningIcon from "../../../assets/svg/warningIcon.svg";
import AssignIcon from "../../../assets/svg/assignedtoIcon.svg";
import pptIcon from "../../../assets/svg/ppt.svg";
import UploadURL from "../../../assets/svg/UploadURL.svg";
import UploadFile from "../../../assets/svg/UploadFile.svg";
import UploadURLActive from "../../../assets/svg/UploadURLActive.svg";
import UploadFileActive from "../../../assets/svg/UploadFileActive.svg";
import formats from "../../../helpers/MediaFormats";
import { makeStyles } from "@material-ui/core/styles";
import $, { data } from "jquery";
import API, {
  POST_INACTIVE_REVIEWER_DOCUMENT,
  POST_REVIEWER_DOCUMENT,
} from "../../../helpers/endpointService";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { POST_NEW_DOCUMENT } from "../../../helpers/endpointService";
import "react-toastify/dist/ReactToastify.css";
import role from "../../../helpers/role";
import { setPendingCountFn } from "../../../redux/action/Action";
import { logoutFunction, CheckPasswordValid } from "../../custom/commonFunction";
import lock from "../../../assets/svg/lock.svg";
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import UserRole from "../../../helpers/role";

const useStyles = makeStyles((theme) => ({
  inputfieldAlign: {
    "& fieldset": {
      top: "-1px !important",
    },
  },
  button: {
    background: "#FFFFFF",
    border: "none",
    boxSizing: "border-box",
    paddingLeft: "11px",
    paddingRight: "20px",
  },
}));

const toggleItems = [
  { name: UploadFile, name1: UploadFileActive, value: "1" },
  { name: UploadURL, name1: UploadURLActive, value: "2" },
];

var SelectedValue1 = false;
var SelectedValue2 = false;
var SelectedValueSearch = false;

var closeNewSearch = false;

let PaginationCount = false;
var ReviewerValue1 = false;
var ReviewerValue2 = false;
var authorError = false;
var adminError = false;
var category1Error = false;
var category2Error = false;
var approver1Error = false;
var approver2Error = false;
var checker1Error = false;
var checker2Error = false;
var consultant1Error = false;
var consultant2Error = false;

const MyPendingTask = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const dataFetchedRef = useRef(false);
  let pendingCommonSearchResult = useSelector(
    (state) => state.commonReducer.pendingCommonSearchResult
  );
  let pendingCommonSearch = useSelector(
    (state) => state.commonReducer.pendingCommonSearch
  );
  const [pendingreasontext, setpendingreasontext] = useState({
    remark: "",
  });
  let menuToggle = useSelector((state) => state.commonReducer.menuToggle);
  const [isMobile, setisMobile] = useState(false);
  const [isCancelMobile, setisCancelMobile] = useState(false);
  const [isRadioMobile, setisRadioMobile] = useState(false);
  const [isSmallMobile, setisSmallMobile] = useState(false);
  const [ispendingLoader, setispendingLoader] = useState(false);
  const [ispendingFailed, setispendingFailed] = useState(false);
  const [iswebMobile, setiswebMobile] = useState(false);
  const [pendingtaskList, setpendingtaskList] = useState(null);
  const [pendingSearchList, setpendingSearchList] = useState(null);
  const [approvedocumentsList, setapprovedocumentsList] = useState([]);
  const [versionLogList, setversionLogList] = useState([]);
  const [historyLogList, sethistoryLogList] = useState([]);
  const [userRole, setuserRole] = useState("");
  const [windowHeight, setwindowHeight] = useState(0);
  const [pendingCount, setpendingCount] = useState(0);
  const [perPage, setperPage] = useState(20);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [selected, setSelected] = useState(false);

  const [hasError, setHasError] = useState(false);
  const [hasError2, setHasError2] = useState(false);
  /*  const [order, setOrder] = useState("asc");
   const [orderBy, setOrderBy] = useState("reviewDate");  */

  const [sortName, setSortName] = useState("reviewDate");
  const [sortOrder, setSortOrder] = useState("asc");

  const [newPasswordValue, setNewPasswordValue] = useState("");
  const [confirmPasswordValue, setConfirmPasswordValue] = useState("");
  const [isPasswordProtected, setIsPasswordProtected] = useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [documentIsPasswordProtected, setDocumentIsPasswordProtected] = useState(false);
  const [documentPassword, setDocumentPassword] = useState(false);

  const paginglist = [
    { label: "5", value: 5 },
    { label: "10", value: 10 },
    { label: "20", value: 20 },
    { label: "50", value: 50 },
  ];
  const paginglistDefault = [{ label: "20", value: 20 }];

  const [hasNext, sethasNext] = useState(false);
  const [hasPrevious, sethasPrevious] = useState(false);
  const [today, setToday] = useState(() => {
    const today = new Date();
    today?.setDate(today.getDate() + 1);
    return today?.toISOString().split("T")[0];
  });

  const [openauthorList, setOpenAuthorList] = useState(false);
  const [openchecker1List, setOpenChecker1List] = useState(false);
  const [openchecker2List, setOpenChecker2List] = useState(false);
  const [openconsultant1List, setOpenConsultant1List] = useState(false);
  const [openconsultant2List, setOpenConsultant2List] = useState(false);
  const [opencategory1List, setOpencategory1List] = useState(false);
  const [opencategory2List, setOpencategory2List] = useState(false);
  const [Checker1ArrayList, setChecker1ArrayList] = useState([]);
  const [Checker2ArrayList, setChecker2ArrayList] = useState([]);
  const [Consultant1ArrayList, setConsultant1ArrayList] = useState([]);
  const [Consultant2ArrayList, setConsultant2ArrayList] = useState([]);
  const [Approver1ArrayList, setApprover1ArrayList] = useState([]);
  const [Approver2ArrayList, setApprover2ArrayList] = useState([]);
  const [AuthorArrayList, setAuthorArrayList] = useState([]);
  const [AdminArrayList, setAdminArrayList] = useState([]);
  const [selectcommonfield, setSelectcommonfield] = useState({
    dataAuthor: "",
    checker1: "",
    dataCategory1: "",
    dataCategory2: "",
    checker2: "",
    consultant1: "",
    consultant2: "",
    approver1: "",
    approver2: "",
  });

  const [checker1Id, setChecker1Id] = useState(0);
  const [checker2Id, setChecker2Id] = useState(0);
  const [consultant1Id, setConsultant1Id] = useState(0);
  const [consultant2Id, setConsultant2Id] = useState(0);
  const [approver1Id, setApprover1Id] = useState(0);
  const [approver2Id, setApprover2Id] = useState(0);
  const [expiryDate, setExpiryDate] = useState(null);
  const [reasonArchive, setReasonArchive] = useState("");
  const [reasonObsolete, setReasonObsolete] = useState("");
  const [renewNotes, setRenewNotes] = useState(null);
  const [userId, setUserId] = useState(localStorage.getItem("UserId") || "");

  const [dataDocumentId, setDataDocumentId] = useState("");
  const [dataDocumentNo, setDataDocumentNo] = useState("");
  const [DocumentNumber, setDocumentNumber] = useState("");
  const [dataDocumentName, setDataDocumentName] = useState("");
  const [dataDocumentNumber, setDataDocumentNumber] = useState("");
  const [dataRevisedDocumentNo, setDataRevisedDocumentNo] = useState("");
  const [dataRevisedId, setDataRevisedId] = useState("");

  const [dataAuthorId, setDataAuthorId] = useState(0);
  const [dataVersion, setDataVersion] = useState("");
  const [dataCategory1Id, setDataCategory1Id] = useState(0);
  const [dataCategory2Id, setDataCategory2Id] = useState(0);
  const [dataPublishedDate, setDataPublishedDate] = useState("");
  const [dataExpiryDate, setDataExpiryDate] = useState("");
  const [dataDocumentDate, setDataDocumentDate] = useState("");
  const [dataCreatedDate, setDataCreatedDate] = useState("");
  const [dataRemarks, setDataRemarks] = useState("");
  const [documentStatus, setDocumentStatus] = useState("");
  const [dataAssignedFor, setDataAssignedFor] = useState("");
  const [approvalStatus, setApprovalStatus] = useState("");
  const [reviewerdocumentStatus, setReviewerDocumentStatus] = useState("");
  const [reviewerRole, setReviewerRole] = useState("");
  const [isInActiveUser, setIsInActiveUser] = useState(false);
  const [isSecondReviewer, setIsSecondReviewer] = useState(false);

  const [erroReasonObsolete, setErroReasonObsolete] = useState(false);
  const [erroReasonArchive, setErroReasonArchive] = useState(false);
  const [expiryError, setExpiryError] = useState(false);
  let timeoutId;

  const [document1selected, setDocument1Selected] = useState("1");
  const [document2selected, setDocument2Selected] = useState("1");
  const [document3selected, setDocument3Selected] = useState("1");
  const [document4selected, setDocument4Selected] = useState("1");
  const [document5selected, setDocument5Selected] = useState("1");
  const [Document1fromData, setDocument1fromData] = useState("");
  const [Document2fromData, setDocument2fromData] = useState("");
  const [Document3fromData, setDocument3fromData] = useState("");
  const [Document4fromData, setDocument4fromData] = useState("");
  const [Document5fromData, setDocument5fromData] = useState("");

  const [category1List, setCategory1List] = useState([]);
  const [category2List, setCategory2List] = useState([]);
  const [reviewersList, setReviewersList] = useState([]);

  const [valueChanged, setValueChanged] = useState(false);
  const [reviewervalueChanged, setReviewerValueChanged] = useState(false);
  const [inactivereviewervalueChanged, setInactiveReviewerValueChanged] =
    useState(false);

  const [Document1Size, setDocument1Size] = useState(0);
  const [Document2Size, setDocument2Size] = useState(0);
  const [Document3Size, setDocument3Size] = useState(0);
  const [Document4Size, setDocument4Size] = useState(0);
  const [Document5Size, setDocument5Size] = useState(0);

  const [document1Name, setDocument1Name] = useState({
    isUrl: false,
    fileUrl: "",
    uniqueId: "",
    orderId: 1,
    IsSameFile: false,
    IsFileAdded: false,
    IsFilePresent: false,
    FileId: 0,
  });
  const [document2Name, setDocument2Name] = useState({
    isUrl: false,
    fileUrl: "",
    uniqueId: "",
    orderId: 2,
    IsSameFile: false,
    IsFileAdded: false,
    IsFilePresent: false,
    FileId: 0,
  });
  const [document3Name, setDocument3Name] = useState({
    isUrl: false,
    fileUrl: "",
    uniqueId: "",
    orderId: 3,
    IsSameFile: false,
    IsFileAdded: false,
    IsFilePresent: false,
    FileId: 0,
  });
  const [document4Name, setDocument4Name] = useState({
    isUrl: false,
    fileUrl: "",
    uniqueId: "",
    orderId: 4,
    IsSameFile: false,
    IsFileAdded: false,
    IsFilePresent: false,
    FileId: 0,
  });
  const [document5Name, setDocument5Name] = useState({
    isUrl: false,
    fileUrl: "",
    uniqueId: "",
    orderId: 5,
    IsSameFile: false,
    IsFileAdded: false,
    IsFilePresent: false,
    FileId: 0,
  });

  const [openReviewerAuthorList, setOpenReviewerAuthorList] = useState(false);
  const [openReviewerAdminList, setOpenReviewerAdminList] = useState(false);
  const [openReviewerChecker1List, setOpenReviewerChecker1List] =
    useState(false);
  const [openReviewerChecker2List, setOpenReviewerChecker2List] =
    useState(false);
  const [openReviewerconsultant1List, setOpenReviewerconsultant1List] =
    useState(false);
  const [openReviewerconsultant2List, setOpenReviewerconsultant2List] =
    useState(false);
  const [openReviewerApprover1List, setOpenReviewerApprover1List] =
    useState(false);
  const [openReviewerApprover2List, setOpenReviewerApprover2List] =
    useState(false);

  const [adminreviewersList, setAdminReviewersList] = useState([]);
  const [newreviewersList, setNewReviewersList] = useState([]);
  const [commonAdminArrayList, setCommonAdminArrayList] = useState([]);
  const [commonReviewerArrayList, setCommonReviewerArrayList] = useState([]);
  const [reviewerinputData, setReviewerInputData] = useState({
    reviewerId: 0,
    reviewer: "",
    adminName: "",
    adminCenterAdminId: 0,
    adminAuthorId: 0,
    authorName: "",
    adminChecker1Id: 0,
    adminChecker2Id: 0,
    checker1Name: "",
    checker2Name: "",
    adminConsultant1Id: 0,
    adminConsultant2Id: 0,
    consultant1Name: "",
    consultant2Name: "",
    adminApprover1Id: 0,
    adminApprover2Id: 0,
    approver1Name: "",
    approver2Name: "",
  });

  const [openInactiveReviewerAuthorList, setOpenInactiveReviewerAuthorList] =
    useState(false);
  const [openInactiveReviewerAdminList, setOpenInactiveReviewerAdminList] =
    useState(false);
  const [
    openInactiveReviewerChecker1List,
    setOpenInactiveReviewerChecker1List,
  ] = useState(false);
  const [
    openInactiveReviewerChecker2List,
    setOpenInactiveReviewerChecker2List,
  ] = useState(false);
  const [
    openInactiveReviewerconsultant1List,
    setOpenInactiveReviewerconsultant1List,
  ] = useState(false);
  const [
    openInactiveReviewerconsultant2List,
    setOpenInactiveReviewerconsultant2List,
  ] = useState(false);
  const [
    openInactiveReviewerApprover1List,
    setOpenInactiveReviewerApprover1List,
  ] = useState(false);
  const [
    openInactiveReviewerApprover2List,
    setOpenInactiveReviewerApprover2List,
  ] = useState(false);

  const [inactiveadminreviewersList, setInactiveAdminReviewersList] = useState(
    []
  );
  const [inactivenewreviewersList, setInactiveNewReviewersList] = useState([]);
  const [inactiveAuthorList, setInactiveAuthorList] = useState([]);
  const [inactiveChecker1ArrayList, setInactiveChecker1ArrayList] = useState(
    []
  );
  const [inactiveChecker2ArrayList, setInactiveChecker2ArrayList] = useState(
    []
  );
  const [inactiveConsultant1ArrayList, setInactiveConsultant1ArrayList] =
    useState([]);
  const [inactiveConsultant2ArrayList, setInactiveConsultant2ArrayList] =
    useState([]);
  const [inactiveApprover1ArrayList, setInactiveApprover1ArrayList] = useState(
    []
  );
  const [inactiveApprover2ArrayList, setInactiveApprover2ArrayList] = useState(
    []
  );
  const [inactivereviewerinputData, setInactiveReviewerInputData] = useState({
    reviewerId1: 0,
    reviewer1: "",
    reviewerId2: 0,
    reviewer2: "",
    adminName: "",
    adminCenterAdminId: 0,
    adminAuthorId: 0,
    authorName: "",
    adminChecker1Id: 0,
    adminChecker2Id: 0,
    checker1Name: "",
    checker2Name: "",
    adminConsultant1Id: 0,
    adminConsultant2Id: 0,
    consultant1Name: "",
    consultant2Name: "",
    adminApprover1Id: 0,
    adminApprover2Id: 0,
    approver1Name: "",
    approver2Name: "",
  });
  const [isFormValid, setIsFormValid] = useState(false);
  const [searchInputData, setSearchInputData] = useState({
    docNo: "",
    docName: "",
    category1: "",
    category1Id: 0,
    category2: "",
    category2Id: 0,
    author: "",
    authorId: 0,
    assignedFor: "",
    documentStatus: "",
    approvalStatus: "",
    expiryDate: "",
  });
  const [searchAuthorList, setSearchAuthorList] = useState([]);
  const [AtleastFieldMandatory, setAtleastFieldMandatory] = useState(false);
  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    PaginationCount = false;
    setuserRole(localStorage.getItem("Role"));
    setUserId(localStorage.getItem("UserId"));
    GetAuthorList();
    GetAdminList();
    GetCategory1();
  }, [userId, userRole]);

  useEffect(() => {
    setReviewersList(reviewersList);
    setApprover1ArrayList(reviewersList);
    setApprover2ArrayList(reviewersList);
    setChecker1ArrayList(reviewersList);
    setChecker2ArrayList(reviewersList);
    setConsultant1ArrayList(reviewersList);
    setConsultant2ArrayList(reviewersList);
  }, [reviewersList]);

  useEffect(() => {
    setAdminArrayList(AdminArrayList);
    setAuthorArrayList(AdminArrayList);
  }, [AdminArrayList]);

  const GetPendingTaskList = (
    sortingName,
    sortingOrder,
    newpaginationcount
  ) => {
    setispendingLoader(true);
    let order = sortingOrder === "asc" ? true : false;
    if (
      localStorage.getItem("Role") === role.REVIEWER &&
      sortingName === "reviewDate"
    ) {
      sortingName = "assignedDate";
      setSortName("assignedDate");
    } else {
      setSortName(sortingName);
      setSortOrder(sortingOrder);
    }
    let apiUrl = `${API.GET_ALL_PENDINGTASKS}?userId=${userId}&sortBy=${sortingName}&isSortAscending=${order}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: {
        pageNumber: newpaginationcount || currentPage,
        pagesize: perPage,
        documentId: 0,
        documentName: searchInputData.docName ? searchInputData.docName : null,
        documentNo: searchInputData.docNo ? searchInputData.docNo : null,
        category1Id: searchInputData.category1
          ? searchInputData.category1.value
          : 0,
        category1Name: searchInputData.category1
          ? searchInputData.category1.label
          : null,
        category2Id: searchInputData.category2
          ? searchInputData.category2.value
          : 0,
        category2Name: searchInputData.category2
          ? searchInputData.category2.label
          : null,
        documentStatus: searchInputData.documentStatus
          ? searchInputData.documentStatus
          : null,
        approvalStatus: searchInputData.approvalStatus
          ? searchInputData.approvalStatus
          : null,
        fileId: 0,
        fileName: null,
        fileType: null,
        authorId: searchInputData.author ? searchInputData.author.value : 0,
        authorName: searchInputData.author
          ? searchInputData.author.label
          : null,
        fromDate: null,
        toDate: null,
        publishedDate: null,
        expiryDate: searchInputData.expiryDate
          ? moment(searchInputData.expiryDate).format("YYYY-MM-DD")
          : null,
        assignedFor: searchInputData.assignedFor
          ? searchInputData.assignedFor
          : null,
        requestedDate: null,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          sethasPrevious(res.data.hasPrevious);
          sethasNext(res.data.hasNext);
          setPageCount(res.data?.totalCount);
          /*   setCurrentPage(res.data.currentPage) */
          setpendingCount(res.data?.totalCount);
          setpendingtaskList(res.data.values);
        }
        setispendingLoader(false);
      })
      .catch((error) => {
        setispendingLoader(false);
        logoutFunction(error?.response?.status);
      });
  };

  const handleReasonArchiveChange = (event) => {
    setReasonArchive(event.target.value);
  };

  const handleReasonObsoleteChange = (event) => {
    setReasonObsolete(event.target.value);
  };

  const handlenewDocumentName = (event) => {
    setDataDocumentName(event.target.value);
  };

  const handleRenewSelectChange = (value, field) => {
    SelectedValue1 = true;
    if (value) {
      setSelectcommonfield((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    } else {
      setSelectcommonfield((prevData) => ({
        ...prevData,
        [field]: "",
      }));
    }
    setValueChanged(!valueChanged);
  };

  const handleResubmitSelectChange = (value, field) => {
    SelectedValue1 = true;
    if (value) {
      setSelectcommonfield((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    } else {
      setSelectcommonfield((prevData) => ({
        ...prevData,
        [field]: "",
      }));
    }

    setValueChanged(!valueChanged);
  };

  const handleResubmitSelectCategoryChange = (value, field) => {
    if (field === "dataCategory1") {
      if (value) {
        setispendingLoader(true);
        setispendingFailed(false);
        setSelectcommonfield((prevData) => ({
          ...prevData,
          [field]: value,
          dataCategory2: "",
        }));
        setDataCategory2Id(0);
        GetCategory2(value.value);
        setispendingLoader(false);
        setispendingFailed(false);
      } else {
        setSelectcommonfield((prevData) => ({
          ...prevData,
          dataCategory1: "",
          dataCategory2: "",
        }));
        setDataCategory2Id(0);
      }
    } else if (field === "dataCategory2") {
      if (value) {
        setSelectcommonfield((prevData) => ({
          ...prevData,
          [field]: value,
        }));
        if (value.value !== 0) {
          fetchDocumentNo(value.value);
        }
      } else {
        setSelectcommonfield((prevData) => ({
          ...prevData,
          [field]: value,
        }));
      }
    }
  };

  const fetchDocumentNo = async (id) => {
    setispendingLoader(true);
    axios({
      method: "POST",
      url: POST_NEW_DOCUMENT,
      data: {
        id: 0,
        category1Name: "",
        category2Name: "",
        category1Id: selectcommonfield.dataCategory1
          ? selectcommonfield.dataCategory1.value
          : dataCategory1Id,
        category2Id: parseInt(id),
        documentId: 0,
        documentFormat: "",
        numberFormat: "",
      },
    })
      .then((response) => {
        setispendingLoader(false);
        if (response?.status === 200) {
          setDataDocumentNo(
            response.data.documentFormat +
            response.data.numberFormat +
            response.data.versionFormat +
            response.data.versionNumber
          );
          setDataVersion(response.data.versionNumber);
          setDataDocumentNumber(response.data.numberFormat);
          if (
            response.data?.documentFormat === null &&
            response.data?.numberFormat === null
          ) {
            toast.warning("Ledger is not created for this category", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((err) => {
        setDataDocumentNo("");
        logoutFunction(err?.response?.status);
      });
  };

  useEffect(() => {
    GetDropdownList();
  }, [AdminArrayList]);

  useEffect(() => {
    GetDropdownList();
  }, [valueChanged]);

  const GetDropdownList = () => {
    // let Array1 = reviewersList;
    let Array2 = AdminArrayList;
    let Selectedvalues = [];
    let AuthorValue = [];
    let Checker1Value = [];
    let Checker2Value = [];
    let Consultant1Value = [];
    let Consultant2Value = [];
    let Approver1Value = [];
    let Approver2Value = [];
    let ArrayResult = [];
    // let FilterArray = reviewersList;
    let NewFilterArray = AdminArrayList;
    ArrayResult.push(
      selectcommonfield.approver1,
      selectcommonfield.approver2,
      selectcommonfield.checker1,
      selectcommonfield.checker2,
      selectcommonfield.consultant1,
      selectcommonfield.consultant2,
      selectcommonfield.dataAuthor
    );
    if (ArrayResult?.length !== 0) {
      ArrayResult?.map((j) => {
        if (j) {
          Selectedvalues.push(j?.label);
        }
      });

      // Selectedvalues?.map((i) => {
      //   FilterArray = FilterArray.filter((j) => j?.label !== i);
      // });
      Selectedvalues?.map((i) => {
        NewFilterArray = NewFilterArray.filter((j) => j?.label !== i);
      });

      AuthorValue = Array2.filter(
        (i) => i?.label === selectcommonfield.dataAuthor?.label
      );
      Checker1Value = Array2.filter(
        (i) => i?.label === selectcommonfield.checker1?.label
      );
      Checker2Value = Array2.filter(
        (i) => i?.label === selectcommonfield.checker2?.label
      );
      Consultant1Value = Array2.filter(
        (i) => i?.label === selectcommonfield.consultant1?.label
      );
      Consultant2Value = Array2.filter(
        (i) => i?.label === selectcommonfield.consultant2?.label
      );
      Approver1Value = Array2.filter(
        (i) => i?.label === selectcommonfield.approver1?.label
      );
      Approver2Value = Array2.filter(
        (i) => i?.label === selectcommonfield.approver2?.label
      );

      let FinalAuthorResult = [...AuthorValue, ...NewFilterArray];
      let FinalApprover1Result = [...Approver1Value, ...NewFilterArray];
      let FinalApprover2Result = [...Approver2Value, ...NewFilterArray];
      let FinalChecker1Result = [...Checker1Value, ...NewFilterArray];
      let FinalChecker2Result = [...Checker2Value, ...NewFilterArray];
      let FinalConsultant1Result = [...Consultant1Value, ...NewFilterArray];
      let FinalConsultant2Result = [...Consultant2Value, ...NewFilterArray];

      setAuthorArrayList(FinalAuthorResult);
      setApprover1ArrayList(FinalApprover1Result);
      setApprover2ArrayList(FinalApprover2Result);
      setChecker1ArrayList(FinalChecker1Result);
      setChecker2ArrayList(FinalChecker2Result);
      setConsultant1ArrayList(FinalConsultant1Result);
      setConsultant2ArrayList(FinalConsultant2Result);
    }
  };
  const handlerenewNotesChange = (event) => {
    setRenewNotes(event.target.value);
  };

  const handleExpiryDateChange = (event) => {
    let dateFormat = event?.toISOString().split("T")[0];
    if (dateFormat >= today || event === "") {
      setExpiryError(false);
      const inputDate = event;
      setExpiryDate(inputDate);
      clearTimeout(timeoutId); // Clear the timeout
    } else {
      setExpiryError(true);
      clearTimeout(timeoutId); // Clear the previous timeout if exists
      timeoutId = setTimeout(() => {
        setExpiryError(false); // Reset expiryError to false after 3 seconds
      }, 5000);
    }
  };

  const upload_document1 = (e, field, type) => {
    let file = e.target.files;
    if (type === "Submit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document1");
        if (!isvalid && !isvalid1) {
          setDocument1Name({
            ...document1Name,
            [field]: file[0].name,
            orderId: 1,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
          setDocument1fromData(file[0]);
        }
      }
    } else if (type === "Resubmit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document1");
        if (!isvalid && !isvalid1) {
          if (document1Name.FileId !== 0) {
            setDocument1Name({
              ...document1Name,
              [field]: file[0].name,
              orderId: 1,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: true,
            });
          } else {
            setDocument1Name({
              ...document1Name,
              [field]: file[0].name,
              orderId: 1,
              IsSameFile: false,
              IsFileAdded: true,
              IsFilePresent: true,
            });
          }
          setDocument1fromData(file[0]);
        }
      }
    }
  };
  const upload_document2 = (e, field, type) => {
    let file = e.target.files;
    if (type === "Submit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document2");
        if (!isvalid && !isvalid1) {
          setDocument2Name({
            ...document2Name,
            [field]: file[0].name,
            orderId: 2,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
          setDocument2fromData(file[0]);
        }
      }
    } else if (type === "Resubmit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document2");
        if (!isvalid && !isvalid1) {
          if (document2Name.FileId !== 0) {
            setDocument2Name({
              ...document2Name,
              [field]: file[0].name,
              orderId: 2,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: true,
            });
          } else {
            setDocument2Name({
              ...document2Name,
              [field]: file[0].name,
              orderId: 2,
              IsSameFile: false,
              IsFileAdded: true,
              IsFilePresent: true,
            });
          }
          setDocument2fromData(file[0]);
        }
      }
    }
  };
  const upload_document3 = (e, field, type) => {
    let file = e.target.files;
    if (type === "Submit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document3");
        if (!isvalid && !isvalid1) {
          setDocument3Name({
            ...document3Name,
            [field]: file[0].name,
            orderId: 3,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
          setDocument3fromData(file[0]);
        }
      }
    } else if (type === "Resubmit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document3");
        if (!isvalid && !isvalid1) {
          if (document3Name.FileId !== 0) {
            setDocument3Name({
              ...document3Name,
              [field]: file[0].name,
              orderId: 3,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: true,
            });
          } else {
            setDocument3Name({
              ...document3Name,
              [field]: file[0].name,
              orderId: 3,
              IsSameFile: false,
              IsFileAdded: true,
              IsFilePresent: true,
            });
          }
          setDocument3fromData(file[0]);
        }
      }
    }
  };
  const upload_document4 = (e, field, type) => {
    let file = e.target.files;
    if (type === "Submit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document4");
        if (!isvalid && !isvalid1) {
          setDocument4Name({
            ...document4Name,
            [field]: file[0].name,
            orderId: 4,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
          setDocument4fromData(file[0]);
        }
      }
    } else if (type === "Resubmit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document4");
        if (!isvalid && !isvalid1) {
          if (document4Name.FileId !== 0) {
            setDocument4Name({
              ...document4Name,
              [field]: file[0].name,
              orderId: 4,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: true,
            });
          } else {
            setDocument4Name({
              ...document4Name,
              [field]: file[0].name,
              orderId: 4,
              IsSameFile: false,
              IsFileAdded: true,
              IsFilePresent: true,
            });
          }
          setDocument4fromData(file[0]);
        }
      }
    }
  };
  const upload_document5 = (e, field, type) => {
    let file = e.target.files;
    if (type === "Submit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document5");
        if (!isvalid && !isvalid1) {
          setDocument5Name({
            ...document5Name,
            [field]: file[0].name,
            orderId: 5,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
          setDocument5fromData(file[0]);
        }
      }
    } else if (type === "Resubmit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document5");
        if (!isvalid && !isvalid1) {
          if (document5Name.FileId !== 0) {
            setDocument5Name({
              ...document5Name,
              [field]: file[0].name,
              orderId: 5,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: true,
            });
          } else {
            setDocument5Name({
              ...document5Name,
              [field]: file[0].name,
              orderId: 5,
              IsSameFile: false,
              IsFileAdded: true,
              IsFilePresent: true,
            });
          }
          setDocument5fromData(file[0]);
        }
      }
    }
  };
  function handleUrlTextchanges(e, type, field, Author) {
    if (Author === "Submit") {
      if (type === "document1") {
        setDocument1Name({
          ...document1Name,
          [field]: e.target.value,
          IsSameFile: false,
          IsFileAdded: true,
          IsFilePresent: true,
        });
      } else if (type === "document2") {
        setDocument2Name({
          ...document2Name,
          [field]: e.target.value,
          IsSameFile: false,
          IsFileAdded: true,
          IsFilePresent: true,
        });
      } else if (type === "document3") {
        setDocument3Name({
          ...document3Name,
          [field]: e.target.value,
          IsSameFile: false,
          IsFileAdded: true,
          IsFilePresent: true,
        });
      } else if (type === "document4") {
        setDocument4Name({
          ...document4Name,
          [field]: e.target.value,
          IsSameFile: false,
          IsFileAdded: true,
          IsFilePresent: true,
        });
      } else if (type === "document5") {
        setDocument5Name({
          ...document5Name,
          [field]: e.target.value,
          IsSameFile: false,
          IsFileAdded: true,
          IsFilePresent: true,
        });
      }
    } else if (Author === "Resubmit") {
      if (type === "document1") {
        if (document1Name.FileId !== 0) {
          setDocument1Name({
            ...document1Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: false,
            IsFilePresent: true,
          });
        } else {
          setDocument1Name({
            ...document1Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
        }
      } else if (type === "document2") {
        if (document2Name.FileId !== 0) {
          setDocument2Name({
            ...document2Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: false,
            IsFilePresent: true,
          });
        } else {
          setDocument2Name({
            ...document2Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
        }
      } else if (type === "document3") {
        if (document3Name.FileId !== 0) {
          setDocument3Name({
            ...document3Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: false,
            IsFilePresent: true,
          });
        } else {
          setDocument3Name({
            ...document3Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
        }
      } else if (type === "document4") {
        if (document4Name.FileId !== 0) {
          setDocument4Name({
            ...document4Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: false,
            IsFilePresent: true,
          });
        } else {
          setDocument4Name({
            ...document4Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
        }
      } else if (type === "document5") {
        if (document5Name.FileId !== 0) {
          setDocument5Name({
            ...document5Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: false,
            IsFilePresent: true,
          });
        } else {
          setDocument5Name({
            ...document5Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
        }
      }
    }
  }
  const deletefiles1 = () => {
    if (document1selected == "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 1,
        FileId: document1Name.FileId ? document1Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile1").val("");
      setDocument1Name(data);
      setDocument1fromData("");
      setDocument1Size(0);
    }
  };
  const deletefiles2 = () => {
    if (document2selected == "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 2,
        FileId: document2Name.FileId ? document2Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile2").val("");
      setDocument2Name(data);
      setDocument2fromData("");
      setDocument2Size(0);
    }
  };
  const deletefiles3 = () => {
    if (document3selected == "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 3,
        FileId: document3Name.FileId ? document3Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile3").val("");
      setDocument3Name(data);
      setDocument3fromData("");
      setDocument3Size(0);
    }
  };
  const deletefiles4 = () => {
    if (document4selected == "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 4,
        FileId: document4Name.FileId ? document4Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile4").val("");
      setDocument4Name(data);
      setDocument4fromData("");
      setDocument4Size(0);
    }
  };
  const deletefiles5 = () => {
    if (document5selected == "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 5,
        FileId: document5Name.FileId ? document5Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile5").val("");
      setDocument5Name(data);
      setDocument5fromData("");
      setDocument5Size(0);
    }
  };
  const handleToggle = (e) => {
    setDocument1Selected(e.currentTarget.value);
    if (e.currentTarget.value === "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 1,
        FileId: document1Name.FileId ? document1Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile1").val("");
      setDocument1Name(data);
      setDocument1fromData("");
      setDocument1Size(0);
    } else if (e.currentTarget.value === "2") {
      let data = {
        isUrl: true,
        fileUrl: "",
        uniqueId: "",
        orderId: 1,
        FileId: document1Name.FileId ? document1Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile1").val("");
      setDocument1Name(data);
      setDocument1fromData("");
      setDocument1Size(0);
    }
  };
  const handleToggle1 = (e) => {
    setDocument2Selected(e.currentTarget.value);
    if (e.currentTarget.value === "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 2,
        FileId: document2Name.FileId ? document2Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile2").val("");
      setDocument2Name(data);
      setDocument2fromData("");
      setDocument2Size(0);
    } else if (e.currentTarget.value === "2") {
      let data = {
        isUrl: true,
        fileUrl: "",
        uniqueId: "",
        orderId: 2,
        FileId: document2Name.FileId ? document2Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile2").val("");
      setDocument2Name(data);
      setDocument2fromData("");
      setDocument2Size(0);
    }
  };
  const handleToggle2 = (e) => {
    setDocument3Selected(e.currentTarget.value);
    if (e.currentTarget.value === "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 3,
        FileId: document3Name.FileId ? document3Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile3").val("");
      setDocument3Name(data);
      setDocument3fromData("");
      setDocument3Size(0);
    } else if (e.currentTarget.value === "2") {
      let data = {
        isUrl: true,
        fileUrl: "",
        uniqueId: "",
        orderId: 3,
        FileId: document3Name.FileId ? document3Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile3").val("");
      setDocument3Name(data);
      setDocument3fromData("");
      setDocument3Size(0);
    }
  };
  const handleToggle3 = (e) => {
    setDocument4Selected(e.currentTarget.value);
    if (e.currentTarget.value === "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 4,
        FileId: document4Name.FileId ? document4Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile4").val("");
      setDocument4Name(data);
      setDocument4fromData("");
      setDocument4Size(0);
    } else if (e.currentTarget.value === "2") {
      let data = {
        isUrl: true,
        fileUrl: "",
        uniqueId: "",
        orderId: 4,
        FileId: document4Name.FileId ? document4Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile4").val("");
      setDocument4Name(data);
      setDocument4fromData("");
      setDocument4Size(0);
    }
  };
  const handleToggle4 = (e) => {
    setDocument5Selected(e.currentTarget.value);
    if (e.currentTarget.value === "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 5,
        FileId: document5Name.FileId ? document5Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile5").val("");
      setDocument5Name(data);
      setDocument5fromData("");
      setDocument5Size(0);
    } else if (e.currentTarget.value === "2") {
      let data = {
        isUrl: true,
        fileUrl: "",
        uniqueId: "",
        orderId: 5,
        FileId: document5Name.FileId ? document5Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile5").val("");
      setDocument5Name(data);
      setDocument5fromData("");
      setDocument5Size(0);
    }
  };

  // author role save upload document
  const uploadSubmitMessage = () => {
    /*   if (pendingreasontext.remark !== '') { */
    let sendBack = document.getElementById("authorSendBack");
    sendBack.style.borderColor = "";
    setispendingLoader(true);
    const FileAttachment = [];
    if (document1Name.fileUrl !== "" || document1Name.uniqueId !== "") {
      FileAttachment.push(document1Name);
    }
    if (document2Name.fileUrl !== "" || document2Name.uniqueId !== "") {
      FileAttachment.push(document2Name);
    }
    if (document3Name.fileUrl !== "" || document3Name.uniqueId !== "") {
      FileAttachment.push(document3Name);
    }
    if (document4Name.fileUrl !== "" || document4Name.uniqueId !== "") {
      FileAttachment.push(document4Name);
    }
    if (document5Name.fileUrl !== "" || document5Name.uniqueId !== "") {
      FileAttachment.push(document5Name);
    }

    let UploadformData = new FormData();
    if (Document1fromData !== "") {
      UploadformData.append("files", Document1fromData);
    }
    if (Document2fromData !== "") {
      UploadformData.append("files", Document2fromData);
    }
    if (Document3fromData !== "") {
      UploadformData.append("files", Document3fromData);
    }
    if (Document4fromData !== "") {
      UploadformData.append("files", Document4fromData);
    }
    if (Document5fromData !== "") {
      UploadformData.append("files", Document5fromData);
    }
    UploadformData.append("dataitem", JSON.stringify(FileAttachment));
    if (FileAttachment?.length > 0) {
      var FileAttachmentLength = 0;
      if (Document1fromData !== "") {
        FileAttachmentLength = Document1fromData.size;
      }
      if (Document2fromData !== "") {
        FileAttachmentLength = FileAttachmentLength
          ? FileAttachmentLength + Document2fromData.size
          : Document2fromData.size;
      }
      if (Document3fromData !== "") {
        FileAttachmentLength = FileAttachmentLength
          ? FileAttachmentLength + Document3fromData.size
          : Document3fromData.size;
      }
      if (Document4fromData !== "") {
        FileAttachmentLength = FileAttachmentLength
          ? FileAttachmentLength + Document4fromData.size
          : Document4fromData.size;
      }
      if (Document5fromData !== "") {
        FileAttachmentLength = FileAttachmentLength
          ? FileAttachmentLength + Document5fromData.size
          : Document5fromData.size;
      }
      if (FileAttachmentLength < 30000000) {
        let apiUrl = `${API.POST_UPLOAD_FILES}?docId=${dataDocumentId}&userId=${userId}&comments=${pendingreasontext?.remark}`;
        axios({
          method: "POST",
          url: apiUrl,
          headers: {
            "content-type": "multipart/form-data",
          },
          data: UploadformData,
        })
          .then((res) => {
            if (res.status === 200) {
              toast.success("Submitted successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "colored",
              });
              clearfiles();
              $("#AuthorSubmissionScreen").removeClass("show");
              $("body").removeClass("scrollhide");
              GetPendingTaskList("reviewDate", "asc");
            }
            setispendingLoader(false);
          })
          .catch((err) => {
            setispendingLoader(false);
            logoutFunction(err?.response?.status);
          });
      } else {
        setispendingLoader(false);
        toast.error("Please upload the files below 30MB.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "colored",
        });
      }
    } else {
      setispendingLoader(false);
      toast.warning("Upload atleast one file", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
      });
    }
    /*  } else {
       let sendBack = document.getElementById("authorSendBack")
       sendBack.style.borderColor = 'red';
       sendBack.addEventListener('input', () => {
         if (sendBack.value !== '') {
           sendBack.style.borderColor = '';
         }
       });
     } */
  };

  // author role save resubmit document
  const uploadReSubmitMessage = () => {
    /*   if (pendingreasontext.remark !== '') { */
    let sendBack = document.getElementById("AuthorResubmit");
    sendBack.style.borderColor = "";
    setispendingLoader(true);
    const FileAttachment = [];
    if (
      document1Name.fileUrl !== "" ||
      document1Name.uniqueId !== "" ||
      (document1Name.fileUrl === "" &&
        document1Name.uniqueId === "" &&
        document1Name.FileId !== 0)
    ) {
      FileAttachment.push(document1Name);
    }
    if (
      document2Name.fileUrl !== "" ||
      document2Name.uniqueId !== "" ||
      (document2Name.fileUrl === "" &&
        document2Name.uniqueId === "" &&
        document2Name.FileId !== 0)
    ) {
      FileAttachment.push(document2Name);
    }
    if (
      document3Name.fileUrl !== "" ||
      document3Name.uniqueId !== "" ||
      (document3Name.fileUrl === "" &&
        document3Name.uniqueId === "" &&
        document3Name.FileId !== 0)
    ) {
      FileAttachment.push(document3Name);
    }
    if (
      document4Name.fileUrl !== "" ||
      document4Name.uniqueId !== "" ||
      (document4Name.fileUrl === "" &&
        document4Name.uniqueId === "" &&
        document4Name.FileId !== 0)
    ) {
      FileAttachment.push(document4Name);
    }
    if (
      document5Name.fileUrl !== "" ||
      document5Name.uniqueId !== "" ||
      (document5Name.fileUrl === "" &&
        document5Name.uniqueId === "" &&
        document5Name.FileId !== 0)
    ) {
      FileAttachment.push(document5Name);
    }

    let UploadformData = new FormData();
    if (Document1fromData !== "") {
      UploadformData.append("files", Document1fromData);
    }
    if (Document2fromData !== "") {
      UploadformData.append("files", Document2fromData);
    }
    if (Document3fromData !== "") {
      UploadformData.append("files", Document3fromData);
    }
    if (Document4fromData !== "") {
      UploadformData.append("files", Document4fromData);
    }
    if (Document5fromData !== "") {
      UploadformData.append("files", Document5fromData);
    }
    var FileAttachmentLength = 0;
    if (Document1fromData !== "") {
      FileAttachmentLength = Document1fromData.size;
    }
    if (Document2fromData !== "") {
      FileAttachmentLength = FileAttachmentLength
        ? FileAttachmentLength + Document2fromData.size
        : Document2fromData.size;
    }
    if (Document3fromData !== "") {
      FileAttachmentLength = FileAttachmentLength
        ? FileAttachmentLength + Document3fromData.size
        : Document3fromData.size;
    }
    if (Document4fromData !== "") {
      FileAttachmentLength = FileAttachmentLength
        ? FileAttachmentLength + Document4fromData.size
        : Document4fromData.size;
    }
    if (Document5fromData !== "") {
      FileAttachmentLength = FileAttachmentLength
        ? FileAttachmentLength + Document5fromData.size
        : Document5fromData.size;
    }
    if (Document1Size !== 0) {
      FileAttachmentLength = FileAttachmentLength
        ? FileAttachmentLength + Document1Size
        : Document1Size;
    }
    if (Document2Size !== 0) {
      FileAttachmentLength = FileAttachmentLength
        ? FileAttachmentLength + Document2Size
        : Document2Size;
    }
    if (Document3Size !== 0) {
      FileAttachmentLength = FileAttachmentLength
        ? FileAttachmentLength + Document3Size
        : Document3Size;
    }
    if (Document4Size !== 0) {
      FileAttachmentLength = FileAttachmentLength
        ? FileAttachmentLength + Document4Size
        : Document4Size;
    }
    if (Document5Size !== 0) {
      FileAttachmentLength = FileAttachmentLength
        ? FileAttachmentLength + Document5Size
        : Document5Size;
    }

    UploadformData.append("dataitem", JSON.stringify(FileAttachment));
    let apiUrl = `${API.POST_UPLOAD_FILES}?docId=${dataDocumentId}&userId=${userId}&comments=${pendingreasontext?.remark}`;
    if (FileAttachment?.length > 0) {
      let ResultArray = [];
      ResultArray = FileAttachment.filter(
        (i) => i.fileUrl !== "" || i.uniqueId !== ""
      );
      if (ResultArray?.length > 0) {
        if (FileAttachmentLength < 30000000) {
          axios({
            method: "POST",
            url: apiUrl,
            headers: {
              "content-type": "multipart/form-data",
            },
            data: UploadformData,
          })
            .then((res) => {
              if (res.status === 200) {
                toast.success("Resubmitted successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
                clearfiles();
                $("#AuthorReSubmissionScreen").removeClass("show");
                $("body").removeClass("scrollhide");
                GetPendingTaskList("reviewDate", "asc");
              }
              setispendingLoader(false);
            })
            .catch((err) => {
              setispendingLoader(false);
              logoutFunction(err?.response?.status);
            });
        } else {
          setispendingLoader(false);
          toast.error("Please upload the files below 30MB.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
        }
      } else {
        setispendingLoader(false);
        toast.warning("Upload atleast one file", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "colored",
        });
      }
    } else {
      setispendingLoader(false);
      toast.warning("Upload atleast one file", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
      });
    }
    /*   }
      else {
        let sendBack = document.getElementById("AuthorResubmit")
        sendBack.style.borderColor = 'red';
        sendBack.addEventListener('input', () => {
          if (sendBack.value !== '') {
            sendBack.style.borderColor = '';
          }
        });
      } */
  };

  useEffect(() => {
    dispatch(setPendingCountFn(pendingCount));
  }, [pendingCount]);

  //admin role renew modal open modal

  const SubmitDocumentValidate = () => {
    const checkPassword = CheckPasswordValid(isPasswordProtected, newPasswordValue, confirmPasswordValue);
    var isValid;
    if (
      selectcommonfield.approver1 !== "" &&
      selectcommonfield.dataAuthor !== "" &&
      selectcommonfield.checker1 !== "" &&
      checkPassword
    ) {
      isValid = true;
    } else {
      isValid = false;
    }

    if (isValid) {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("RenewPopupScreen")
      );
      cancelPopup.show();
    } else {
      if (
        selectcommonfield.approver1 === "" &&
        selectcommonfield.dataAuthor === "" &&
        selectcommonfield.checker1 === ""
      ) {
        adminError = false;
        authorError = true;
        checker1Error = true;
        checker2Error = false;
        approver1Error = true;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (
        selectcommonfield.approver1 === "" &&
        selectcommonfield.dataAuthor === ""
      ) {
        adminError = false;
        authorError = true;
        checker1Error = false;
        checker2Error -= false;
        approver1Error = true;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (
        selectcommonfield.dataAuthor === "" &&
        selectcommonfield.checker1 === ""
      ) {
        adminError = false;
        authorError = true;
        checker1Error = true;
        checker2Error = false;
        approver1Error = false;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (
        selectcommonfield.approver1 === "" &&
        selectcommonfield.checker1 === ""
      ) {
        adminError = false;
        authorError = false;
        approver1Error = true;
        checker1Error = true;
        checker2Error = false;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (selectcommonfield.approver1 === "") {
        adminError = false;
        authorError = false;
        approver1Error = true;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
        checker1Error = false;
        checker2Error = false;
      } else if (selectcommonfield.dataAuthor === "") {
        adminError = false;
        authorError = true;
        approver1Error = false;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
        checker1Error = false;
        checker2Error = false;
      } else if (selectcommonfield.checker1 === "") {
        adminError = false;
        authorError = false;
        checker1Error = true;
        approver1Error = false;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;

        checker2Error = false;
      }
    }
  };
  //admin role save renew panel

  const SubmitRenewDocument = () => {
    let myDateUTC;
    if (expiryDate) {
      let current = new Date();
      let h = current.getHours();
      let m = current.getMinutes();
      let s = current.getSeconds();
      let formattedTime = `${h.toString().padStart(2, "0")}:${m
        .toString()
        .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
      let Newdate = moment(expiryDate).format("YYYY-MM-DD");
      var dataDate = Newdate + " " + formattedTime;
      myDateUTC = new Date(dataDate).toISOString();
      /*   let myDate = expiryDate + "T" + formattedTime;
        myDateUTC = new Date(myDate).toISOString(); */
    }
    setispendingLoader(true);

    let data = {
      id: 0,
      documentName: dataDocumentName,
      revisedDocumentId: dataDocumentId,
      documentNo: dataDocumentNumber,
      version: dataVersion,
      category1Name: selectcommonfield.dataCategory1
        ? selectcommonfield.dataCategory1.label
        : null,
      category2Name: selectcommonfield.dataCategory2
        ? selectcommonfield.dataCategory2.label
        : null,
      category1Id: selectcommonfield.dataCategory1
        ? selectcommonfield.dataCategory1.value
        : 0,
      category2Id: selectcommonfield.dataCategory2
        ? selectcommonfield.dataCategory2.value
        : 0,
      authorId: selectcommonfield.dataAuthor
        ? selectcommonfield.dataAuthor.value
        : 0,
      authorName: selectcommonfield.dataAuthor
        ? selectcommonfield.dataAuthor.label
        : null,
      checker1Id: selectcommonfield.checker1
        ? selectcommonfield.checker1.value
        : 0,
      checker2Id: selectcommonfield.checker2
        ? selectcommonfield.checker2.value
        : 0,
      checker1Name: selectcommonfield.checker1
        ? selectcommonfield.checker1.label
        : null,
      checker2Name: selectcommonfield.checker2
        ? selectcommonfield.checker2.label
        : null,
      consultant1Id: selectcommonfield.consultant1
        ? selectcommonfield.consultant1.value
        : 0,
      consultant2Id: selectcommonfield.consultant2
        ? selectcommonfield.consultant2.value
        : 0,
      consultant1Name: selectcommonfield.consultant1
        ? selectcommonfield.consultant1.label
        : null,
      consultant2Name: selectcommonfield.consultant2
        ? selectcommonfield.consultant2.label
        : null,
      approver1Id: selectcommonfield.approver1
        ? selectcommonfield.approver1.value
        : 0,
      approver2Id: selectcommonfield.approver2
        ? selectcommonfield.approver2.value
        : 0,
      approver1Name: selectcommonfield.approver1
        ? selectcommonfield.approver1.label
        : null,
      approver2Name: selectcommonfield.approver2
        ? selectcommonfield.approver2.label
        : null,
      documentDate: null,
      documentStatus: documentStatus,
      approvalStatus: approvalStatus,
      reviewDate: myDateUTC || null,
      remarks: renewNotes,
      reason: renewNotes,
      isResubmission: false,
      isPasswordProtected: isPasswordProtected,
      password: window.btoa(newPasswordValue)
    };
    let apiUrl = `${API.SAVE_RENEW_DOCUMENT}?userId=${userId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((res) => {
        if (res.status === 200) {
          if (userId) {
            let apiUrl1 = `${API.GET_NOTIFICATION_COUNT}?userId=${userId}`;
            axios({
              method: "GET",
              url: apiUrl1,
            })
              .then((response) => {
                if (response?.status === 200) {
                  dispatch({ type: "NOTIFICATIONCOUNT", data: response.data });
                }
                setispendingLoader(false);
              })
              .catch((err) => {
                setispendingLoader(false);
                logoutFunction(err?.response?.status);
              });
          } else {
            setispendingLoader(false);
          }
          renewedMessage();
          ClearDataList();
          $("#renewScreen").removeClass("show");
          $("body").removeClass("scrollhide");
          GetPendingTaskList("reviewDate", "asc");
        } else {
          setispendingLoader(false);
        }
      })
      .catch((error) => {
        setispendingLoader(false);
        logoutFunction(error?.response?.status);
      });
  };

  //admin role save archive panel
  const SubmitArchiveDocument = () => {
    if (reasonArchive !== "") {
      setispendingLoader(true);
      setErroReasonArchive(false);
      let data = {
        id: dataDocumentId,
        documentName: dataDocumentName,
        documentNo: dataDocumentNumber,
        reason: reasonArchive,
      };
      let apiUrl = `${API.SAVE_ARCHIVE_DOCUMENT}?userId=${userId}`;
      axios({
        method: "PUT",
        url: apiUrl,
        data: data,
      }).then((res) => {
        if (res.status === 200) {
          if (res?.data === "document is not published") {
            documentIssueMessage();
            ClearDataList();
            $("#archiveScreen").removeClass("show");
            $("body").removeClass("scrollhide");
          } else {
            archivedMessage();
            ClearDataList();
            $("#archiveScreen").removeClass("show");
            $("body").removeClass("scrollhide");
            GetPendingTaskList("reviewDate", "asc");
          }
        }
        setispendingLoader(false);
      });
    } else {
    }
  };

  //admin role save obsolete panel
  const SubmitObsoleteDocument = () => {
    if (reasonObsolete !== "") {
      setispendingLoader(true);
      setErroReasonObsolete(false);
      let data = {
        id: dataDocumentId,
        documentName: dataDocumentName,
        documentNo: dataDocumentNumber,
        reason: reasonObsolete,
      };
      let apiUrl = `${API.SAVE_OBSOLETE_DOCUMENT}?userId=${userId}`;
      axios({
        method: "PUT",
        url: apiUrl,
        data: data,
      }).then((res) => {
        if (res.status === 200) {
          if (res?.data === "document is not published") {
            documentIssueMessage();
            ClearDataList();
            $("#obsoleteScreen").removeClass("show");
            $("body").removeClass("scrollhide");
          } else {
            obsoletedMessage();
            ClearDataList();
            $("#obsoleteScreen").removeClass("show");
            $("body").removeClass("scrollhide");
            GetPendingTaskList("reviewDate", "asc");
          }
        }
        setispendingLoader(false);
      });
    } else {
      setispendingLoader(false);
      setErroReasonObsolete(true);
    }
  };

  //admin role save resubmit modal open
  const ResubmitDocumentValidate = () => {
    var isValid;
    const inputs = document.querySelectorAll(".resubmit-input-class[required]");
    let checkPassword = false;
    if (isChangePassword == true) {
      checkPassword = CheckPasswordValid(isPasswordProtected, newPasswordValue, confirmPasswordValue);
    } else {
      checkPassword = true;
    }
    const isValid1 = Array.from(inputs).every((input) => input.value !== "");
    if (
      selectcommonfield.dataCategory1 !== "" &&
      selectcommonfield.dataCategory2 !== "" &&
      selectcommonfield.approver1 !== "" &&
      selectcommonfield.dataAuthor !== "" &&
      selectcommonfield.checker1 !== "" &&
      checkPassword
    ) {
      isValid = true;
    } else {
      isValid = false;
    }
    const removeBorderInputs = Array.from(inputs).filter(
      (input) => input.value != ""
    );

    removeBorderInputs?.forEach((input) => {
      input.style.borderColor = "";
    });
    authorError = false;
    adminError = false;
    category1Error = false;
    category2Error = false;
    approver1Error = false;
    approver2Error = false;
    checker1Error = false;
    checker2Error = false;
    consultant1Error = false;
    consultant2Error = false;

    if (isValid && isValid1) {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("ResubmitPopupScreen")
      );
      cancelPopup.show();
    } else {
      const emptyInputs = Array.from(inputs).filter(
        (input) => input.value === ""
      );
      emptyInputs.forEach((input) => {
        input.style.borderColor = "red";
        input.addEventListener("input", () => {
          if (input.value !== "") {
            input.style.borderColor = "";
          }
        });
      });
      if (selectcommonfield.dataCategory1 === "") {
        category1Error = true;
      } else {
        category1Error = false;
      }
      if (selectcommonfield.dataCategory2 === "") {
        category2Error = true;
      } else {
        category2Error = false;
      }
      if (
        selectcommonfield.approver1 === "" &&
        selectcommonfield.dataAuthor === "" &&
        selectcommonfield.checker1 === ""
      ) {
        adminError = false;
        authorError = true;
        checker1Error = true;
        checker2Error = false;
        approver1Error = true;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (
        selectcommonfield.approver1 === "" &&
        selectcommonfield.dataAuthor === ""
      ) {
        adminError = false;
        authorError = true;
        checker1Error = false;
        checker2Error -= false;
        approver1Error = true;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (
        selectcommonfield.dataAuthor === "" &&
        selectcommonfield.checker1 === ""
      ) {
        adminError = false;
        authorError = true;
        checker1Error = true;
        checker2Error = false;
        approver1Error = false;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (
        selectcommonfield.approver1 === "" &&
        selectcommonfield.checker1 === ""
      ) {
        adminError = false;
        authorError = false;
        approver1Error = true;
        checker1Error = true;
        checker2Error = false;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (selectcommonfield.approver1 === "") {
        adminError = false;
        authorError = false;
        approver1Error = true;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
        checker1Error = false;
        checker2Error = false;
      } else if (selectcommonfield.dataAuthor === "") {
        adminError = false;
        authorError = true;
        approver1Error = false;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;
        checker1Error = false;
        checker2Error = false;
      } else if (selectcommonfield.checker1 === "") {
        adminError = false;
        authorError = false;
        checker1Error = true;
        approver1Error = false;
        approver2Error = false;
        consultant1Error = false;
        consultant2Error = false;

        checker2Error = false;
      }
    }
  };

  //admin role save resubmit pane
  const ResubmitDocument = () => {
    let myDateUTC;
    if (expiryDate) {
      let current = new Date();
      let h = current.getHours();
      let m = current.getMinutes();
      let s = current.getSeconds();
      let formattedTime = `${h.toString().padStart(2, "0")}:${m
        .toString()
        .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
      let Newdate = moment(expiryDate).format("YYYY-MM-DD");
      var dataDate = Newdate + " " + formattedTime;
      myDateUTC = new Date(dataDate).toISOString();
      /*   let myDate = expiryDate + "T" + formattedTime;
        myDateUTC = new Date(myDate).toISOString(); */
    }
    setispendingLoader(true);
    let data = {
      id: dataDocumentId,
      documentName: dataDocumentName,
      revisedDocumentId: dataRevisedDocumentNo,
      documentNo: dataDocumentNumber,
      version: dataVersion,
      category1Name: selectcommonfield.dataCategory1
        ? selectcommonfield.dataCategory1.label
        : null,
      category2Name: selectcommonfield.dataCategory2
        ? selectcommonfield.dataCategory2.label
        : null,
      category1Id: selectcommonfield.dataCategory1
        ? selectcommonfield.dataCategory1.value
        : 0,
      category2Id: selectcommonfield.dataCategory2
        ? selectcommonfield.dataCategory2.value
        : 0,
      authorId: selectcommonfield.dataAuthor
        ? selectcommonfield.dataAuthor.value
        : 0,
      authorName: selectcommonfield.dataAuthor
        ? selectcommonfield.dataAuthor.label
        : null,
      checker1Id: selectcommonfield.checker1
        ? selectcommonfield.checker1.value
        : 0,
      checker2Id: selectcommonfield.checker2
        ? selectcommonfield.checker2.value
        : 0,
      checker1Name: selectcommonfield.checker1
        ? selectcommonfield.checker1.label
        : null,
      checker2Name: selectcommonfield.checker2
        ? selectcommonfield.checker2.label
        : null,
      consultant1Id: selectcommonfield.consultant1
        ? selectcommonfield.consultant1.value
        : 0,
      consultant2Id: selectcommonfield.consultant2
        ? selectcommonfield.consultant2.value
        : 0,
      consultant1Name: selectcommonfield.consultant1
        ? selectcommonfield.consultant1.label
        : null,
      consultant2Name: selectcommonfield.consultant2
        ? selectcommonfield.consultant2.label
        : null,
      approver1Id: selectcommonfield.approver1
        ? selectcommonfield.approver1.value
        : 0,
      approver2Id: selectcommonfield.approver2
        ? selectcommonfield.approver2.value
        : 0,
      approver1Name: selectcommonfield.approver1
        ? selectcommonfield.approver1.label
        : null,
      approver2Name: selectcommonfield.approver2
        ? selectcommonfield.approver2.label
        : null,
      documentDate: null,
      documentStatus: documentStatus,
      approvalStatus: approvalStatus,
      reviewDate: myDateUTC || null,
      remarks: dataRemarks,
      reason: renewNotes,
      isResubmission: true,
    };

    let apiUrl = `${API.SAVE_RESUBMIT_DOCUMENT}?userId=${userId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((res) => {
        setispendingLoader(false);
        if (res.status === 200) {
          if (userId) {
            let apiUrl1 = `${API.GET_NOTIFICATION_COUNT}?userId=${userId}`;
            axios({
              method: "GET",
              url: apiUrl1,
            })
              .then((response) => {
                if (response?.status === 200) {
                  dispatch({ type: "NOTIFICATIONCOUNT", data: response.data });
                }
              })
              .catch((err) => {
                logoutFunction(err?.response?.status);
              });
          }
          resumittedMessage();
          ClearDataList();
          $("#resubmitScreen").removeClass("show");
          $("body").removeClass("scrollhide");
          GetPendingTaskList("reviewDate", "asc");
        }
        setispendingLoader(false);
      })
      .catch((err) => {
        setispendingLoader(false);
        setispendingLoader(false);
        logoutFunction(err?.response?.status);
      });
    if (isChangePassword == true) {
      let obj = {
        "documentId": dataDocumentId,
        "isPasswordProtected": isPasswordProtected,
        "password": isPasswordProtected == true ? window.btoa(newPasswordValue) : "",
        "userId": userId
      }
      axios
        .patch(API.POST_UPDATE_DOC_PASSWORD, obj)
        .then((response) => {
          if (response?.status === 200) {
            // toast.success("Document password updated successfully", {
            //   position: "top-right",
            //   autoClose: 5000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   theme: "colored",
            // });
          }
          else {
          }
        })
        .catch((err) => {
          logoutFunction(err?.response?.status);
        });
    }
  };

  // checker/approver/consultant role save approve documnet
  const openCheckerSendBack = (role) => {
    if (pendingreasontext.remark !== "") {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("SendbackPopupScreen")
      );
      cancelPopup.show();
      $("body").addClass("scrollhide");
    } else {
      let sendBack = document.getElementById("checkerSendBack");
      sendBack.style.borderColor = "red";
      sendBack.addEventListener("input", () => {
        if (sendBack.value !== "") {
          sendBack.style.borderColor = "";
        }
      });
    }
  };

  const UpdateApprovePendingtask = () => {
    // var current = new Date();
    // var h = current.getHours();
    // var m = current.getMinutes();
    // var s = current.getSeconds();
    // let myDate = expiryDate+" "+h+":"+m+":"+s;
    // let myDateUTC = new Date(myDate).toISOString();
    /*   if (pendingreasontext.remark !== '') {
        dispatch({ type: "REMARKCHANGE", data: true }); */
    let sendBack = document.getElementById("checkerSendBack");
    sendBack.style.borderColor = "";
    setispendingLoader(true);
    let data = {
      id: dataDocumentId,
      documentName: dataDocumentName,
      revisedDocumentId: dataRevisedDocumentNo,
      documentNo: dataDocumentNumber,
      version: dataVersion,
      category1Name: selectcommonfield.dataCategory1
        ? selectcommonfield.dataCategory1.label
        : null,
      category2Name: selectcommonfield.dataCategory2
        ? selectcommonfield.dataCategory2.label
        : null,
      category1Id: selectcommonfield.dataCategory1
        ? selectcommonfield.dataCategory1.value
        : 0,
      category2Id: selectcommonfield.dataCategory2
        ? selectcommonfield.dataCategory2.value
        : 0,
      authorId: selectcommonfield.dataAuthor
        ? selectcommonfield.dataAuthor.value
        : 0,
      authorName: selectcommonfield.dataAuthor
        ? selectcommonfield.dataAuthor.label
        : null,
      checker1Id: selectcommonfield.checker1
        ? selectcommonfield.checker1.value
        : 0,
      checker2Id: selectcommonfield.checker2
        ? selectcommonfield.checker2.value
        : 0,
      checker1Name: selectcommonfield.checker1
        ? selectcommonfield.checker1.label
        : null,
      checker2Name: selectcommonfield.checker2
        ? selectcommonfield.checker2.label
        : null,
      consultant1Id: selectcommonfield.consultant1
        ? selectcommonfield.consultant1.value
        : 0,
      consultant2Id: selectcommonfield.consultant2
        ? selectcommonfield.consultant2.value
        : 0,
      consultant1Name: selectcommonfield.consultant1
        ? selectcommonfield.consultant1.label
        : null,
      consultant2Name: selectcommonfield.consultant2
        ? selectcommonfield.consultant2.label
        : null,
      approver1Id: selectcommonfield.approver1
        ? selectcommonfield.approver1.value
        : 0,
      approver2Id: selectcommonfield.approver2
        ? selectcommonfield.approver2.value
        : 0,
      approver1Name: selectcommonfield.approver1
        ? selectcommonfield.approver1.label
        : null,
      approver2Name: selectcommonfield.approver2
        ? selectcommonfield.approver2.label
        : null,
      documentDate: dataPublishedDate,
      documentStatus: documentStatus,
      approvalStatus: approvalStatus,
      reviewDate: expiryDate,
      remarks: dataRemarks,
      reason: pendingreasontext.remark,
    };
    let apiUrl = `${API.PUT_APPROVER_DOCUMENT}?userId=${userId}`;
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    }).then((res) => {
      if (res.status === 200) {
        toast.success("Approved successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "colored",
        });
        $("#pendingCheckerScreen").removeClass("show");
        $("body").removeClass("scrollhide");
        GetPendingTaskList("reviewDate", "asc");
      }
      setispendingLoader(false);
    });
    /*   }
      else {
        let sendBack = document.getElementById("checkerSendBack")
        sendBack.style.borderColor = 'red';
        sendBack.addEventListener('input', () => {
          if (sendBack.value !== '') {
            sendBack.style.borderColor = '';
          }
        });
      }
      dispatch({ type: "REMARKCHANGE", data: false }); */
  };

  // checker/approver/consultant role save send back documnet
  const UpdateSendforReworkDocument = () => {
    if (pendingreasontext.remark !== "") {
      dispatch({ type: "REMARKCHANGE", data: true });
      setispendingLoader(true);
      let data = {
        id: dataDocumentId,
        documentName: dataDocumentName,
        documentNo: dataDocumentNumber,
        reason: pendingreasontext.remark,
      };
      let apiUrl = `${API.PUT_SENDBACKDOCUMENT}?userId=${userId}`;
      axios({
        method: "PUT",
        url: apiUrl,
        data: data,
      }).then((res) => {
        if (res.status === 200) {
          if (userId) {
            let apiUrl1 = `${API.GET_NOTIFICATION_COUNT}?userId=${userId}`;
            axios({
              method: "GET",
              url: apiUrl1,
            })
              .then((response) => {
                if (response?.status === 200) {
                  dispatch({ type: "NOTIFICATIONCOUNT", data: response.data });
                }
              })
              .catch((err) => {
                logoutFunction(err?.response?.status);
              });
          }
          toast.success("Sent back successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
          $("#pendingCheckerScreen").removeClass("show");
          $("#AuthorSubmissionScreen").removeClass("show");
          $("#AuthorReSubmissionScreen").removeClass("show");
          $("body").removeClass("scrollhide");
          GetPendingTaskList("reviewDate", "asc");
          ClearDataList();
        }
        setispendingLoader(false);
      });
    } else {
      dispatch({ type: "REMARKCHANGE", data: false });
    }
  };

  const GetDocumentByIDDetails = async (Id, assignedfor, documentstatus) => {
    //setispendingLoader(true);
    var IsCheck = false;
    let apiUrl = `${API.GET_MY_COMPLETED_TASK_PROPERTIES}?docId=${Id}`;
    await axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      setispendingLoader(false);
      if (res.status === 200) {
        setIsChangePassword(false);
        setIsPasswordProtected(res.data?.isPasswordProtected);
        setDocumentIsPasswordProtected(res.data?.isPasswordProtected);
        setDocumentPassword(res.data?.password);
        setDataDocumentId(res.data.id);
        setDataDocumentNo(res.data.documentNo);
        setDataDocumentName(res.data.documentName);
        setDataDocumentNumber(res.data.documentNumber);
        setDataRevisedDocumentNo(res.data.revisedDocumentId);
        setDataVersion(res.data.version);
        setSelectcommonfield({
          dataCategory1: res.data.category1Name
            ? { value: res.data.category1Id, label: res.data.category1Name }
            : "",
          dataCategory2: res.data.category2Name
            ? { value: res.data.category2Id, label: res.data.category2Name }
            : "",
          dataAuthor: res.data.authorName
            ? {
              label: res.data.authorName,
              value: res.data.adminAuthorId ? res.data.adminAuthorId : 0,
            }
            : "",
          checker1: res.data.checker1Name
            ? {
              label: res.data.checker1Name,
              value: res.data.adminChecker1Id ? res.data.adminChecker1Id : 0,
            }
            : "",
          checker2: res.data.checker2Name
            ? {
              label: res.data.checker2Name,
              value: res.data.adminChecker2Id ? res.data.adminChecker2Id : 0,
            }
            : "",
          consultant1: res.data.consultant1Name
            ? {
              label: res.data.consultant1Name,
              value: res.data.adminConsultant1Id
                ? res.data.adminConsultant1Id
                : 0,
            }
            : "",
          consultant2: res.data.consultant2Name
            ? {
              label: res.data.consultant2Name,
              value: res.data.adminConsultant2Id
                ? res.data.adminConsultant2Id
                : 0,
            }
            : "",
          approver1: res.data.approver1Name
            ? {
              label: res.data.approver1Name,
              value: res.data.adminApprover1Id
                ? res.data.adminApprover1Id
                : 0,
            }
            : "",
          approver2: res.data.approver2Name
            ? {
              label: res.data.approver2Name,
              value: res.data.adminApprover2Id
                ? res.data.adminApprover2Id
                : 0,
            }
            : "",
        });
        setDataCategory1Id(res.data.category1Id);
        setDataCategory2Id(res.data.category2Id);
        res.data.authorId
          ? setDataAuthorId(res.data.adminAuthorId)
          : setDataAuthorId(0);
        res.data.checker1Id
          ? setChecker1Id(res.data.adminChecker1Id)
          : setChecker1Id(0);
        res.data.checker2Id
          ? setChecker2Id(res.data.adminChecker2Id)
          : setChecker2Id(0);
        res.data.consultant1Id
          ? setConsultant1Id(res.data.adminConsultant1Id)
          : setConsultant1Id(0);
        res.data.consultant2Id
          ? setConsultant2Id(res.data.adminConsultant2Id)
          : setConsultant2Id(0);
        res.data.approver1Id
          ? setApprover1Id(res.data.adminApprover1Id)
          : setApprover1Id(0);
        res.data.approver2Id
          ? setApprover2Id(res.data.adminApprover2Id)
          : setApprover2Id(0);
        setDataCreatedDate(
          res.data.createdDate
            ? Moment(res.data.createdDate).format("DD-MMM-YYYY")
            : ""
        );
        setDataDocumentDate(
          res.data.documentDate
            ? Moment(res.data.documentDate).format("DD-MMM-YYYY")
            : ""
        );
        setDataPublishedDate(
          res.data.publishedDate
            ? Moment(res.data.publishedDate).format("DD-MMM-YYYY")
            : ""
        );
        setDataExpiryDate(
          res.data.reviewDate
            ? Moment(res.data.reviewDate).format("DD-MMM-YYYY")
            : ""
        );
        setDataRemarks(res.data.remarks);
        setApprovalStatus(res.data.approvalStatus);
        setReviewerDocumentStatus(res.data.documentStatus);
        setReviewerRole(res.data.role);
        setIsInActiveUser(res.data.isInActiveUser);
        setIsSecondReviewer(res.data.isSecondReviewer);
        setValueChanged(!valueChanged);
        setReviewerValueChanged(!reviewervalueChanged);
        setInactiveReviewerValueChanged(!inactivereviewervalueChanged);
        setReviewerInputData({
          reviewerId: 0,
          reviewer: "",
          adminName: res.data.adminName
            ? {
              label: res.data.adminName,
              value: res.data.adminCenterAdminId
                ? res.data.adminCenterAdminId
                : 0,
            }
            : "",
          adminCenterAdminId: res.data.adminCenterAdminId
            ? res.data.adminCenterAdminId
            : 0,
          adminAuthorId: res.data.adminAuthorId ? res.data.adminAuthorId : 0,
          authorName: res.data.authorName
            ? {
              label: res.data.authorName,
              value: res.data.adminAuthorId ? res.data.adminAuthorId : 0,
            }
            : "",
          adminChecker1Id: res.data.adminChecker1Id
            ? res.data.adminChecker1Id
            : 0,
          adminChecker2Id: res.data.adminChecker2Id
            ? res.data.adminChecker2Id
            : 0,
          checker1Name: res.data.checker1Name
            ? {
              label: res.data.checker1Name,
              value: res.data.adminChecker1Id ? res.data.adminChecker1Id : 0,
            }
            : "",
          checker2Name: res.data.checker2Name
            ? {
              label: res.data.checker2Name,
              value: res.data.adminChecker2Id ? res.data.adminChecker2Id : 0,
            }
            : "",
          adminConsultant1Id: res.data.adminConsultant1Id
            ? res.data.adminConsultant1Id
            : 0,
          adminConsultant2Id: res.data.adminConsultant2Id
            ? res.data.adminConsultant2Id
            : 0,
          consultant1Name: res.data.consultant1Name
            ? {
              label: res.data.consultant1Name,
              value: res.data.adminConsultant1Id
                ? res.data.adminConsultant1Id
                : 0,
            }
            : "",
          consultant2Name: res.data.consultant2Name
            ? {
              label: res.data.consultant2Name,
              value: res.data.adminConsultant2Id
                ? res.data.adminConsultant2Id
                : 0,
            }
            : "",
          adminApprover1Id: res.data.adminApprover1Id
            ? res.data.adminApprover1Id
            : 0,
          adminApprover2Id: res.data.adminApprover2Id
            ? res.data.adminApprover2Id
            : 0,
          approver1Name: res.data.approver1Name
            ? {
              label: res.data.approver1Name,
              value: res.data.adminApprover1Id
                ? res.data.adminApprover1Id
                : 0,
            }
            : "",
          approver2Name: res.data.approver2Name
            ? {
              label: res.data.approver2Name,
              value: res.data.adminApprover2Id
                ? res.data.adminApprover2Id
                : 0,
            }
            : "",
        });
        setInactiveReviewerInputData({
          reviewerId1: 0,
          reviewer1: "",
          reviewerId2: 0,
          reviewer2: "",
          adminName: res.data.adminName
            ? {
              label: res.data.adminName,
              value: res.data.adminCenterAdminId
                ? res.data.adminCenterAdminId
                : 0,
            }
            : "",
          adminCenterAdminId: res.data.adminCenterAdminId
            ? res.data.adminCenterAdminId
            : 0,
          adminAuthorId: res.data.adminAuthorId ? res.data.adminAuthorId : 0,
          authorName: res.data.authorName
            ? {
              label: res.data.authorName,
              value: res.data.adminAuthorId ? res.data.adminAuthorId : 0,
            }
            : "",
          adminChecker1Id: res.data.adminChecker1Id
            ? res.data.adminChecker1Id
            : 0,
          adminChecker2Id: res.data.adminChecker2Id
            ? res.data.adminChecker2Id
            : 0,
          checker1Name: res.data.checker1Name
            ? {
              label: res.data.checker1Name,
              value: res.data.adminChecker1Id ? res.data.adminChecker1Id : 0,
            }
            : "",
          checker2Name: res.data.checker2Name
            ? {
              label: res.data.checker2Name,
              value: res.data.adminChecker2Id ? res.data.adminChecker2Id : 0,
            }
            : "",
          adminConsultant1Id: res.data.adminConsultant1Id
            ? res.data.adminConsultant1Id
            : 0,
          adminConsultant2Id: res.data.adminConsultant2Id
            ? res.data.adminConsultant2Id
            : 0,
          consultant1Name: res.data.consultant1Name
            ? {
              label: res.data.consultant1Name,
              value: res.data.adminConsultant1Id
                ? res.data.adminConsultant1Id
                : 0,
            }
            : "",
          consultant2Name: res.data.consultant2Name
            ? {
              label: res.data.consultant2Name,
              value: res.data.adminConsultant2Id
                ? res.data.adminConsultant2Id
                : 0,
            }
            : "",
          adminApprover1Id: res.data.adminApprover1Id
            ? res.data.adminApprover1Id
            : 0,
          adminApprover2Id: res.data.adminApprover2Id
            ? res.data.adminApprover2Id
            : 0,
          approver1Name: res.data.approver1Name
            ? {
              label: res.data.approver1Name,
              value: res.data.adminApprover1Id
                ? res.data.adminApprover1Id
                : 0,
            }
            : "",
          approver2Name: res.data.approver2Name
            ? {
              label: res.data.approver2Name,
              value: res.data.adminApprover2Id
                ? res.data.adminApprover2Id
                : 0,
            }
            : "",
        });
      }
    });
    GetVersionLogList(Id);
    GetHistoryLogList(Id);
    if (userRole === role.ADMIN) {
      if (
        assignedfor === "Submission"
        &&
        documentstatus === "Pending with Author"
      ) {
        IsCheck = true;
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("AuthorSubmissionScreen")
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        const viewbar = document.getElementById("viewbar1");
        viewbar?.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      } if (
        assignedfor === "Resubmission"
        &&
        documentstatus === "Pending with Author"
      ) {
        IsCheck = true;
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("AuthorReSubmissionScreen")
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        const viewbar = document.getElementById("viewbar2");
        viewbar?.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      } if (assignedfor === "Approval") {
        let myOffcanvas = new window.bootstrap.Offcanvas(
          //document.getElementById("pendingAdminScreen")
          document.getElementById("pendingCheckerScreen")
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        const viewbar = document.getElementById("viewbar3");
        viewbar?.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      } else if (!IsCheck) {
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("pendingAdminScreen")
          //document.getElementById("pendingCheckerScreen")
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        const viewbar = document.getElementById("viewbar3");
        viewbar?.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
    }
    if (userRole === role.REVIEWER) {
      if (assignedfor === "Submission") {
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("AuthorSubmissionScreen")
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        const viewbar = document.getElementById("viewbar1");
        viewbar?.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
      if (assignedfor === "Resubmission") {
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("AuthorReSubmissionScreen")
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        const viewbar = document.getElementById("viewbar2");
        viewbar?.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
      if (assignedfor === "Approval") {
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("pendingCheckerScreen")
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        const viewbar = document.getElementById("viewbar");
        viewbar?.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
      // setispendingLoader(false);
    }
  };

  const clearfiles = () => {
    deletefiles1();
    deletefiles2();
    deletefiles3();
    deletefiles4();
    deletefiles5();
  };

  const ClearDataList = () => {
    if ($("#pendingCheckerScreen").hasClass("show")) {
      $("#pendingCheckerScreen").removeClass("show");
    }
    if ($("#AuthorSubmissionScreen").hasClass("show")) {
      $("#AuthorSubmissionScreen").removeClass("show");
    }
    if ($("#AuthorReSubmissionScreen").hasClass("show")) {
      $("#AuthorReSubmissionScreen").removeClass("show");
    }
    if ($("#pendingAdminScreen").hasClass("show")) {
      $("#pendingAdminScreen").removeClass("show");
    }
    if ($("#resubmitScreen").hasClass("show")) {
      $("#resubmitScreen").removeClass("show");
    }
    if ($("#obsoleteScreen").hasClass("show")) {
      $("#obsoleteScreen").removeClass("show");
    }
    if ($("#archiveScreen").hasClass("show")) {
      $("#archiveScreen").removeClass("show");
    }
    if ($("#renewScreen").hasClass("show")) {
      $("#renewScreen").removeClass("show");
    }
    $("#closeCanvas").removeClass("viewbar-overlay");
    $("body").removeClass("scrollhide");
    setDataDocumentId("");
    setDataDocumentNo("");
    setDataDocumentName("");
    setDataRevisedDocumentNo("");
    setDataVersion("");
    setDataCategory1Id("");
    setDataCategory2Id("");
    setDataAuthorId("");
    setChecker1Id("");
    setChecker2Id("");
    setConsultant1Id("");
    setConsultant2Id("");
    setApprover1Id("");
    setApprover2Id("");
    setDataCreatedDate("");
    setDataDocumentDate("");
    setDataPublishedDate("");
    setDataExpiryDate("");
    setExpiryDate(null);
    setDataRemarks("");
    setApprovalStatus("");
    setReviewerDocumentStatus("");
    setReviewerRole("");
    setIsInActiveUser(false);
    setIsSecondReviewer(false);
    setSelectcommonfield({
      dataAuthor: "",
      checker1: "",
      dataCategory1: "",
      dataCategory2: "",
      checker2: "",
      consultant1: "",
      consultant2: "",
      approver1: "",
      approver2: "",
    });
    setReviewerInputData({
      reviewerId: 0,
      reviewer: "",
      adminCenterAdminId: 0,
      adminName: "",
      adminAuthorId: 0,
      authorName: "",
      adminChecker1Id: 0,
      adminChecker2Id: 0,
      checker1Name: "",
      checker2Name: "",
      adminConsultant1Id: 0,
      adminConsultant2Id: 0,
      consultant1Name: "",
      consultant2Name: "",
      adminApprover1Id: 0,
      adminApprover2Id: 0,
      approver1Name: "",
      approver2Name: "",
    });
    setInactiveReviewerInputData({
      reviewerId1: 0,
      reviewer1: "",
      reviewerId2: 0,
      reviewer2: "",
      adminCenterAdminId: 0,
      adminName: "",
      adminAuthorId: 0,
      authorName: "",
      adminChecker1Id: 0,
      adminChecker2Id: 0,
      checker1Name: "",
      checker2Name: "",
      adminConsultant1Id: 0,
      adminConsultant2Id: 0,
      consultant1Name: "",
      consultant2Name: "",
      adminApprover1Id: 0,
      adminApprover2Id: 0,
      approver1Name: "",
      approver2Name: "",
    });
    setRenewNotes("");
    setReasonArchive("");
    setReasonObsolete("");
    setpendingreasontext({ remark: "" });
    clearfiles();
    category1Error = false;
    category2Error = false;
    authorError = false;
    adminError = false;
    category1Error = false;
    category2Error = false;
    approver1Error = false;
    approver2Error = false;
    checker1Error = false;
    checker2Error = false;
    consultant1Error = false;
    consultant2Error = false;

    const input1 = document.querySelectorAll(".renew-input-class[required]");
    const emptyInput1 = Array.from(input1).filter(
      (input) => input.value === ""
    );
    emptyInput1.forEach((input) => {
      input.style.borderColor = "";
    });

    const inputs = document.querySelectorAll(".resubmit-input-class[required]");
    const emptyInputs = Array.from(inputs).filter(
      (input) => input.value === ""
    );
    emptyInputs.forEach((input) => {
      input.style.borderColor = "";
    });
  };

  const GetDocumentFormat = () => {
    setispendingLoader(true);
    let data = {
      id: 0,
      category1Name: "",
      category2Name: "",
      category1Id: dataCategory1Id
        ? dataCategory1Id
        : selectcommonfield.dataCategory1
          ? selectcommonfield.dataCategory1.value
          : 0,
      category2Id: dataCategory2Id
        ? dataCategory1Id
        : selectcommonfield.dataCategory2
          ? selectcommonfield.dataCategory2.value
          : 0,
      documentId: 0,
      documentFormat: "",
      numberFormat: "",
    };

    let apiUrl = `${API.GET_DOCUMENTFORMAT}?docId=${dataDocumentId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((res) => {
        if (res.status === 200) {
          setDataRevisedId(res.data.numberFormat);
          // setDataDocumentNo(dataDocumentNo);
          setDocumentNumber(res.data.numberFormat);
          setDataRevisedDocumentNo(
            res.data.documentFormat +
            dataDocumentNumber +
            " " +
            res.data.versionFormat +
            " " +
            res.data.versionNumber
          );
        }
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("renewScreen")
        );
        myOffcanvas.show();
        $('.password-checkbox').prop('checked', false);
        setDocumentPassword("");
        setDocumentIsPasswordProtected(false);
        setIsChangePassword(false);
        setIsPasswordProtected(false);
        setNewPasswordValue("");
        setConfirmPasswordValue("");
        $("body").addClass("scrollhide");
        const viewbar = document.getElementById("viewbar7");
        viewbar?.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
        setispendingLoader(false);
      })
      .catch((err) => {
        setispendingLoader(false);
        logoutFunction(err?.response?.status);
      });
  };

  const GetAuthorList = () => {
    let apiUrl = `${API.GET_ALL_USERS}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        var FinalArray = res.data?.map((res) => {
          return {
            value: res.id,
            label: res.userName,
          };
        });
        setCommonReviewerArrayList(FinalArray);
        setReviewersList(FinalArray);
        setChecker1ArrayList(FinalArray);
        setChecker2ArrayList(FinalArray);
        setConsultant1ArrayList(FinalArray);
        setConsultant2ArrayList(FinalArray);
        setApprover1ArrayList(FinalArray);
        setApprover2ArrayList(FinalArray);
        setNewReviewersList(FinalArray);
        setInactiveNewReviewersList(FinalArray);
        setInactiveChecker1ArrayList(FinalArray);
        setInactiveChecker2ArrayList(FinalArray);
        setInactiveApprover1ArrayList(FinalArray);
        setInactiveApprover2ArrayList(FinalArray);
        setInactiveConsultant1ArrayList(FinalArray);
        setInactiveConsultant2ArrayList(FinalArray);
      }
    });
  };

  const GetAdminList = () => {
    let apiUrl = `${API.GET_ALL_USERS}?includeAdmin=true`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        var FinalArray1 = res.data?.map((res) => {
          return {
            value: res.id,
            label: res.userName,
          };
        });
        setCommonAdminArrayList(FinalArray1);
        setAuthorArrayList(FinalArray1);
        setSearchAuthorList(FinalArray1);
        setAdminArrayList(FinalArray1);
        setAdminReviewersList(FinalArray1);
        setInactiveAdminReviewersList(FinalArray1);
        setInactiveAuthorList(FinalArray1);
      }
    });
  };

  const GetCategory1 = () => {
    let apiUrl = `${API.GET_CATAGORY_DROPDOWN}?type=category1&isLedger=false`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        setCategory1List(
          res.data?.map((res) => {
            return {
              value: res.categoryId,
              label: res.categoryName,
            };
          })
        );
      }
    });
  };

  const GetCategory2 = (id) => {
    let data = {
      pageNumber: currentPage,
      pagesize: perPage,
    };

    let apiUrl = `${API.GET_CATAGORY2}?category1Id=${id}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    }).then((res) => {
      if (res.status === 200) {
        setCategory2List(
          res.data.values?.map((res) => {
            return {
              value: res.category2Id,
              label: res.category2Name,
            };
          })
        );
      }
    });
  };

  const GetHistoryLogList = (id) => {
    let apiUrl = `${API.GET_HISTORY_LOG}?docId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        sethistoryLogList(res.data);
      }
    });
  };

  const GetApproveDocumentsList = (id) => {
    let data = {
      pageNumber: 1,
      pagesize: 20,
    };
    setispendingLoader(true);
    let apiUrl = `${API.GET_ALL_FILES_URL}?docId=${id}&userId=${userId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((res) => {
        if (res.status === 200) {
          setapprovedocumentsList(res.data.values);
          if (res.data.values?.length > 0) {
            res.data.values?.map((val, i) => {
              if (val.fileOrder == 1) {
                if (val.fileType === "url") {
                  setDocument1Selected("2");
                } else {
                  setDocument1Selected("1");
                }
                setDocument1Name({
                  isUrl: val.isFavourite,
                  fileUrl: val.fileName,
                  uniqueId: val.fileName,
                  FileId: val.id ? val.id : 0,
                  IsSameFile: true,
                });
                setDocument1Size(val?.fileSize ? val?.fileSize : 0);
              } else if (val.fileOrder == 2) {
                if (val.fileType === "url") {
                  setDocument2Selected("2");
                } else {
                  setDocument2Selected("1");
                }
                setDocument2Name({
                  isUrl: val.isFavourite,
                  fileUrl: val.fileName,
                  uniqueId: val.fileName,
                  FileId: val.id ? val.id : 0,
                  IsSameFile: true,
                });
                setDocument2Size(val?.fileSize ? val?.fileSize : 0);
              } else if (val.fileOrder == 3) {
                if (val.fileType === "url") {
                  setDocument3Selected("2");
                } else {
                  setDocument3Selected("1");
                }
                setDocument3Name({
                  isUrl: val.isFavourite,
                  fileUrl: val.fileName,
                  uniqueId: val.fileName,
                  FileId: val.id ? val.id : 0,
                  IsSameFile: true,
                });
                setDocument3Size(val?.fileSize ? val?.fileSize : 0);
              } else if (val.fileOrder == 4) {
                if (val.fileType === "url") {
                  setDocument4Selected("2");
                } else {
                  setDocument4Selected("1");
                }
                setDocument4Name({
                  isUrl: val.isFavourite,
                  fileUrl: val.fileName,
                  uniqueId: val.fileName,
                  FileId: val.id ? val.id : 0,
                  IsSameFile: true,
                });
                setDocument4Size(val?.fileSize ? val?.fileSize : 0);
              } else if (val.fileOrder == 5) {
                if (val.fileType === "url") {
                  setDocument5Selected("2");
                } else {
                  setDocument5Selected("1");
                }
                setDocument5Name({
                  isUrl: val.isFavourite,
                  fileUrl: val.fileName,
                  uniqueId: val.fileName,
                  FileId: val.id ? val.id : 0,
                  IsSameFile: true,
                });
                setDocument5Size(val?.fileSize ? val?.fileSize : 0);
              }
            });
          } else {
            setDocument1Name({
              isUrl: false,
              fileUrl: "",
              uniqueId: "",
              orderId: 1,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: false,
              FileId: 0,
            });
            setDocument2Name({
              isUrl: false,
              fileUrl: "",
              uniqueId: "",
              orderId: 2,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: false,
              FileId: 0,
            });
            setDocument3Name({
              isUrl: false,
              fileUrl: "",
              uniqueId: "",
              orderId: 3,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: false,
              FileId: 0,
            });
            setDocument4Name({
              isUrl: false,
              fileUrl: "",
              uniqueId: "",
              orderId: 4,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: false,
              FileId: 0,
            });
            setDocument5Name({
              isUrl: false,
              fileUrl: "",
              uniqueId: "",
              orderId: 5,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: false,
              FileId: 0,
            });
            setDocument1Selected("1");
            setDocument2Selected("1");
            setDocument3Selected("1");
            setDocument4Selected("1");
            setDocument5Selected("1");
            setDocument1Size(0);
            setDocument2Size(0);
            setDocument3Size(0);
            setDocument4Size(0);
            setDocument5Size(0);
          }
        }
        // setispendingLoader(false);
      })
      .catch((error) => {
        setispendingLoader(false);
        logoutFunction(error?.response?.status);
      });
  };

  const GetVersionLogList = (id) => {
    let apiUrl = `${API.GET_VERSION_LOG}?docId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        setversionLogList(res.data);
      }
    });
  };

  const resize = () => {
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }
    if (window.innerWidth < 500) {
      setisRadioMobile(true);
    } else {
      setisRadioMobile(false);
    }
    if (window.innerWidth < 350) {
      setiswebMobile(true);
    } else {
      setiswebMobile(false);
    }

    if (window.innerWidth < 315) {
      setisCancelMobile(true);
    } else {
      setisCancelMobile(false);
    }
    if (window.innerWidth < 300) {
      setisSmallMobile(true);
    } else {
      setisSmallMobile(false);
    }
    setwindowHeight(window.innerHeight);
  };

  const handleRemorkInputChange = (e) => {
    dispatch({ type: "REMARKCHANGE", data: true });
    if (pendingreasontext.remark === "") {
      dispatch({ type: "REMARKCHANGE", data: false });
    }
    setpendingreasontext({
      remark: e.target.value,
    });
  };

  const checkvalidfile = (fileName) => {
    if (fileName) {
      const fileType = fileName?.split(".").pop().toLowerCase();
      const supportedFormats = Object.values(formats).flat();
      if (
        supportedFormats.includes(fileType) ||
        fileType === "heic" ||
        fileType === "mov"
      ) {
        return false;
      } else {
        toast.error(
          "The selected file format is not applicable. Please ensure the format and submit again",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          }
        );
        return true;
      }
    }
  };

  const CheckAlreadyExist = (filename, documentType) => {
    const FileAttachment = [];
    if (document1Name.fileUrl !== "" || document1Name.uniqueId !== "") {
      FileAttachment.push(document1Name);
    }
    if (document2Name.fileUrl !== "" || document2Name.uniqueId !== "") {
      FileAttachment.push(document2Name);
    }
    if (document3Name.fileUrl !== "" || document3Name.uniqueId !== "") {
      FileAttachment.push(document3Name);
    }
    if (document4Name.fileUrl !== "" || document4Name.uniqueId !== "") {
      FileAttachment.push(document4Name);
    }
    if (document5Name.fileUrl !== "" || document5Name.uniqueId !== "") {
      FileAttachment.push(document5Name);
    }
    if (filename) {
      const fileType = filename;
      if (FileAttachment?.length !== 0) {
        let Result = FileAttachment?.filter(
          (item) => item.uniqueId === fileType
        );
        if (Result?.length === 0) {
          return false;
        } else {
          if (documentType === "document1") {
            deletefiles1();
          }
          if (documentType === "document2") {
            deletefiles2();
          }
          if (documentType === "document3") {
            deletefiles3();
          }
          if (documentType === "document4") {
            deletefiles4();
          }
          if (documentType === "document5") {
            deletefiles5();
          }
          toast.warning(
            "The selected file is already uploaded. Please upload another file.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            }
          );
          return true;
        }
      } else {
        return false;
      }
    }
  };
  const handleDcocumentNo = (
    e,
    id,
    assignedfor,
    status,
    Role,
    documentstatus
  ) => {
    setispendingLoader(true);
    setispendingFailed(false);
    GetDocumentByIDDetails(id, assignedfor, documentstatus);
    setDataDocumentId(id);
    setDocumentStatus(status);
    setDataAssignedFor(assignedfor);
    GetApproveDocumentsList(id);
    setpendingreasontext({ remark: "" });
    let sendBack = document.getElementById("checkerSendBack");
    sendBack.style.borderColor = "";
    let sendBackAuthor = document.getElementById("authorSendBack");
    sendBackAuthor.style.borderColor = "";
    let sendBackAuthor1 = document.getElementById("AuthorResubmit");
    sendBackAuthor1.style.borderColor = "";
  };

  const renewedMessage = () => {
    toast.success("Renewed successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });
  };

  const archivedMessage = () => {
    toast.success("Archived successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });
  };
  const documentIssueMessage = () => {
    toast.error("Document is not published", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });
  };
  const obsoletedMessage = () => {
    toast.success("Obsoleted successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });
  };

  const resumittedMessage = () => {
    toast.success("Resubmitted successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });
  };
  const find = (e) => {
    setperPage(parseInt(e.value));
    const selectedPage = 1;
    setCurrentPage(selectedPage);
    PaginationCount = false;
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    PaginationCount = false;
  };

  ////////////////////////// Sort table ////////////////////////////////

  const sortTable = (name) => {
    if (pendingtaskList?.length !== 0) {
      var order = sortOrder;
      if (sortName === name) {
        setSortName(name);
        if (sortOrder === "asc") {
          order = "desc";
          setSortOrder(order);
        } else {
          order = "asc";
          setSortOrder(order);
        }
      } else {
        order = "asc";
        setSortName(name);
        setSortOrder(order);
      }
      PaginationCount = true;
      setCurrentPage(1);
      GetPendingTaskList(name, order, 1);
    }
  };

  /* pagination code */

  useEffect(() => {
    if (PaginationCount === false) {
      GetPendingTaskList(sortName, sortOrder);
    } else {
      PaginationCount = false;
    }

    // return () => clearInterval(intervals);
  }, [currentPage, perPage]);

  useEffect(() => {
    const intervals = setInterval(() => {
      resize();
    }, 0);
  }, []);

  const handleOpenAdminScreen = () => {
    setIsPasswordProtected(documentIsPasswordProtected);
    setIsChangePassword(false);
    if ($("#resubmitScreen").hasClass("show")) {
      $("#resubmitScreen").removeClass("show");
    }
    if ($("#obsoleteScreen").hasClass("show")) {
      $("#obsoleteScreen").removeClass("show");
    }
    if ($("#archiveScreen").hasClass("show")) {
      $("#archiveScreen").removeClass("show");
    }
    if ($("#renewScreen").hasClass("show")) {
      $("#renewScreen").removeClass("show");
    }
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("pendingAdminScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    const viewbar = document.getElementById("viewbar3");
    viewbar?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const openFileDocument = (id) => {
    setispendingLoader(true);
    setispendingFailed(false);
    let apiUrl = `${API.GET_PARTICULAR_FILE_URL}?fileId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        setispendingLoader(false);
        setispendingFailed(false);
        window.open(res.data);
      }
    });
  };
  const openURL = (url) => {
    window.open(url);
  };
  const handleOpenSubmitScreen = () => {
    $('.password-checkbox').prop('checked', false);
    $('.newPasswordErrorText').text("");
    $('.confirmPasswordErrorText').text("");
    $('.newdoc-newpassword').removeClass('password-input-valid');
    $('.newdoc-confirmpassword').removeClass('password-input-valid');
    setIsPasswordProtected(isPasswordProtected);
    setNewPasswordValue("");
    setConfirmPasswordValue("");
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("resubmitScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    GetCategory2(dataCategory1Id);
    const viewbar = document.getElementById("viewbar4");
    viewbar?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  const handleOpenArchieveScreen = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("archiveScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    const viewbar = document.getElementById("viewbar6");
    viewbar?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  const handleOpenObsoleteScreen = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("obsoleteScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    const viewbar = document.getElementById("viewbar5");
    viewbar?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  const handleArchiveModalOpen = () => {
    if (reasonArchive !== "") {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("ArchivePopupScreen")
      );
      cancelPopup.show();
      $("body").addClass("scrollhide");
    } else {
      let archive = document.getElementById("archviveMessage");
      archive.style.borderColor = "red";
      archive.addEventListener("input", () => {
        if (archive.value !== "") {
          archive.style.borderColor = "";
        }
      });
    }
  };
  const handleObsoleteModalOpen = () => {
    if (reasonObsolete !== "") {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("ObsoletePopupScreen")
      );
      cancelPopup.show();
      $("body").addClass("scrollhide");
    } else {
      let archive = document.getElementById("obsoleteMessage");
      archive.style.borderColor = "red";
      archive.addEventListener("input", () => {
        if (archive.value !== "") {
          archive.style.borderColor = "";
        }
      });
    }
  };
  /* Reviewer changes */

  const handleReviewerSelectChange = (value, field) => {
    ReviewerValue1 = true;
    if (value) {
      setReviewerInputData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
      setReviewerValueChanged(!reviewervalueChanged);
    } else {
      setReviewerInputData((prevData) => ({
        ...prevData,
        [field]: "",
      }));
      setReviewerValueChanged(!reviewervalueChanged);
    }
  };

  const openAuthorSubmitSendBack = (role) => {
    if (pendingreasontext.remark !== "") {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("SendbackPopupScreen")
      );
      cancelPopup.show();
      $("body").addClass("scrollhide");
    } else {
      let sendBack = document.getElementById("authorSendBack");
      sendBack.style.borderColor = "red";
      sendBack.addEventListener("input", () => {
        if (sendBack.value !== "") {
          sendBack.style.borderColor = "";
        }
      });
    }
  };

  const openAuthorResubmitSendBack = () => {
    if (pendingreasontext.remark !== "") {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("SendbackPopupScreen")
      );
      cancelPopup.show();
      $("body").addClass("scrollhide");
    } else {
      let sendBack = document.getElementById("AuthorResubmit");
      sendBack.style.borderColor = "red";
      sendBack.addEventListener("input", () => {
        if (sendBack.value !== "") {
          sendBack.style.borderColor = "";
        }
      });
    }
  };

  const ReviewerSubmitRequest = () => {
    let inputs;
    if (approvalStatus?.toLowerCase() === "pending with admin") {
      inputs = reviewerinputData.reviewer ? true : false;
    } else if (approvalStatus?.toLowerCase() === "pending with author") {
      inputs = reviewerinputData.reviewer ? true : false;
    } else if (
      approvalStatus?.toLowerCase() === "pending with checker" &&
      reviewerRole === "checker1"
    ) {
      inputs = reviewerinputData.reviewer ? true : false;
    } else if (
      approvalStatus?.toLowerCase() === "pending with checker" &&
      reviewerRole === "checker2"
    ) {
      inputs = reviewerinputData.reviewer ? true : false;
    } else if (
      approvalStatus?.toLowerCase() === "pending with approver" &&
      reviewerRole === "approver1"
    ) {
      inputs = reviewerinputData.reviewer ? true : false;
    } else if (
      approvalStatus?.toLowerCase() === "pending with approver" &&
      reviewerRole === "approver2"
    ) {
      inputs = reviewerinputData.reviewer ? true : false;
    } else if (
      approvalStatus?.toLowerCase() === "pending with consultant" &&
      reviewerRole === "consultant1"
    ) {
      inputs = reviewerinputData.reviewer ? true : false;
    } else if (
      approvalStatus?.toLowerCase() === "pending with consultant" &&
      reviewerRole === "consultant2"
    ) {
      inputs = reviewerinputData.reviewer ? true : false;
    }

    if (inputs) {
      setispendingLoader(true);
      let ReviewerDetails = {
        id: dataDocumentId,
        documentName: dataDocumentName,
        documentNo: dataDocumentNumber,
        reviewerId: reviewerinputData.reviewer.value,
        reason: " ",
      };
      let apiUrl = `${POST_REVIEWER_DOCUMENT}?userId=${userId}`;
      axios({
        method: "POST",
        url: apiUrl,
        data: ReviewerDetails,
      })
        .then((response) => {
          if (response?.status === 200) {
            setispendingLoader(false);
            ClearDataList();
            toast.success("Reassigned successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            });
            GetPendingTaskList("reviewDate", "asc");
          }
        })
        .catch((err) => {
          setispendingLoader(false);
          logoutFunction(err?.response?.status);
        });
    } else {
      if (approvalStatus?.toLowerCase() === "pending with admin") {
        authorError = false;
        adminError = true;
        category1Error = false;
        category2Error = false;
        approver1Error = false;
        approver2Error = false;
        checker1Error = false;
        checker2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (approvalStatus?.toLowerCase() === "pending with author") {
        authorError = true;
        adminError = false;
        category1Error = false;
        category2Error = false;
        approver1Error = false;
        approver2Error = false;
        checker1Error = false;
        checker2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (
        approvalStatus?.toLowerCase() === "pending with checker" &&
        reviewerRole === "checker1"
      ) {
        authorError = false;
        adminError = false;
        category1Error = false;
        category2Error = false;
        approver1Error = false;
        approver2Error = false;
        checker1Error = true;
        checker2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (
        approvalStatus?.toLowerCase() === "pending with checker" &&
        reviewerRole === "checker2"
      ) {
        authorError = false;
        adminError = false;
        category1Error = false;
        category2Error = false;
        approver1Error = false;
        approver2Error = false;
        checker1Error = false;
        checker2Error = true;
        consultant1Error = false;
        consultant2Error = false;
      } else if (
        approvalStatus?.toLowerCase() === "pending with approver" &&
        reviewerRole === "approver1"
      ) {
        authorError = false;
        adminError = false;
        category1Error = false;
        category2Error = false;
        approver1Error = true;
        approver2Error = false;
        checker1Error = false;
        checker2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (
        approvalStatus?.toLowerCase() === "pending with approver" &&
        reviewerRole === "approver2"
      ) {
        authorError = false;
        adminError = false;
        category1Error = false;
        category2Error = false;
        approver1Error = false;
        approver2Error = true;
        checker1Error = false;
        checker2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (
        approvalStatus?.toLowerCase() === "pending with consultant" &&
        reviewerRole === "consultant1"
      ) {
        authorError = false;
        adminError = false;
        category1Error = false;
        category2Error = false;
        approver1Error = false;
        approver2Error = false;
        checker1Error = false;
        checker2Error = false;
        consultant1Error = true;
        consultant2Error = false;
      } else if (
        approvalStatus?.toLowerCase() === "pending with consultant" &&
        reviewerRole === "consultant2"
      ) {
        authorError = false;
        adminError = false;
        category1Error = false;
        category2Error = false;
        approver1Error = false;
        approver2Error = false;
        checker1Error = false;
        checker2Error = false;
        consultant1Error = false;
        consultant2Error = true;
      }
    }
  };

  const CancelReviewerrequest = () => {
    setispendingLoader(true);
    let data = {
      id: dataDocumentId,
      documentName: dataDocumentName,
      documentNo: dataDocumentNumber,
      reason: "",
    };

    let apiUrl = `${API.CANCEL_REQUEST}?userId=${userId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((res) => {
        if (res.status === 200) {
          setispendingLoader(false);
          ClearDataList();
          toast.success("Request cancelled successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
          GetPendingTaskList("reviewDate", "asc");
        }
      })
      .catch((error) => {
        setispendingLoader(false);
        logoutFunction(error?.response?.status);
      });
  };

  const CancelrequestAgain = () => {
    let cancelPopup = new window.bootstrap.Modal(
      document.getElementById("CancelRequestScreen")
    );
    cancelPopup.show();
    $("body").addClass("scrollhide");
  };

  useEffect(() => {
    setNewReviewersList(newreviewersList);
  }, [newreviewersList]);

  useEffect(() => {
    setAdminReviewersList(adminreviewersList);
  }, [adminreviewersList]);

  useEffect(() => {
    GetReviewerDropdownList();
  }, [reviewervalueChanged]);

  const GetReviewerDropdownList = () => {
    let Array1 = newreviewersList;
    let Array2 = adminreviewersList;
    let Selectedvalues = [];
    let Selectedvalues1 = [];
    let ArrayResult = [];
    let ArrayResult1 = [];
    let FilterArray = newreviewersList;
    let NewFilterArray = adminreviewersList;
    ArrayResult.push(
      reviewerinputData.approver1Name,
      reviewerinputData.approver2Name,
      reviewerinputData.consultant1Name,
      reviewerinputData.consultant2Name,
      reviewerinputData.checker1Name,
      reviewerinputData.checker2Name,
      reviewerinputData.authorName,
      reviewerinputData.adminName
    );
    ArrayResult1.push(
      reviewerinputData.approver1Name,
      reviewerinputData.approver2Name,
      reviewerinputData.consultant1Name,
      reviewerinputData.consultant2Name,
      reviewerinputData.checker1Name,
      reviewerinputData.checker2Name
    );
    if (ArrayResult?.length !== 0) {
      ArrayResult?.map((j) => {
        if (j) {
          Selectedvalues.push(j.label);
        }
      });

      Selectedvalues?.map((i) => {
        FilterArray = FilterArray.filter((j) => j.label !== i);
      });

      setNewReviewersList(FilterArray);
    }
    if (ArrayResult1?.length !== 0) {
      ArrayResult1?.map((j) => {
        if (j) {
          Selectedvalues1.push(j.label);
        }
      });

      Selectedvalues1?.map((i) => {
        NewFilterArray = NewFilterArray.filter((j) => j.label !== i);
      });
      setAdminReviewersList(NewFilterArray);
    }
  };

  /* Inactive users integration */
  useEffect(() => {
    setInactiveNewReviewersList(inactivenewreviewersList);
    setInactiveChecker1ArrayList(inactivenewreviewersList);
    setInactiveChecker2ArrayList(inactivenewreviewersList);
    setInactiveConsultant1ArrayList(inactivenewreviewersList);
    setInactiveConsultant2ArrayList(inactivenewreviewersList);
    setInactiveApprover1ArrayList(inactivenewreviewersList);
    setInactiveApprover2ArrayList(inactivenewreviewersList);
  }, [inactivenewreviewersList]);

  useEffect(() => {
    setInactiveAdminReviewersList(inactiveadminreviewersList);
    setInactiveAuthorList(inactiveadminreviewersList);
  }, [inactiveadminreviewersList]);

  useEffect(() => {
    GetInactiveDropdownList();
  }, [inactivereviewervalueChanged]);

  const GetInactiveDropdownList = () => {
    let Array1 = inactivenewreviewersList;
    let Array2 = inactiveadminreviewersList;
    let Selectedvalues = [];
    let Selectedvalues1 = [];
    let Checker1Value = [];
    let AuthorValue = [];
    let Checker2Value = [];
    let Consultant1Value = [];
    let Consultant2Value = [];
    let Approver1Value = [];
    let Approver2Value = [];
    let FinalApprover1Result = [];
    let FinalApprover2Result = [];
    let FinalChecker1Result = [];
    let FinalChecker2Result = [];
    let FinalConsultant1Result = [];
    let FinalConsultant2Result = [];

    let ArrayResult = [];
    let ArrayResult1 = [];

    let CheckerResult = [];
    let ConsultantResult = [];
    let ApproverResult = [];

    let SelectedCheckervalues = [];
    let SelectedConsultantvalues = [];
    let SelectedApprovervalues = [];

    let FilterCheckerArray = inactivenewreviewersList;
    let FilterConsultantArray = inactivenewreviewersList;
    let FilterApproverArray = inactivenewreviewersList;

    let FilterArray = inactivenewreviewersList;
    let NewFilterArray = inactiveadminreviewersList;

    CheckerResult.push(
      inactivereviewerinputData.approver1Name,
      inactivereviewerinputData.approver2Name,
      inactivereviewerinputData.consultant1Name,
      inactivereviewerinputData.consultant2Name,
      inactivereviewerinputData.authorName,
      inactivereviewerinputData.adminName,
      inactivereviewerinputData.reviewer1,
      inactivereviewerinputData.reviewer2
    );
    ConsultantResult.push(
      inactivereviewerinputData.approver1Name,
      inactivereviewerinputData.approver2Name,
      inactivereviewerinputData.checker1Name,
      inactivereviewerinputData.checker2Name,
      inactivereviewerinputData.authorName,
      inactivereviewerinputData.adminName,
      inactivereviewerinputData.reviewer1,
      inactivereviewerinputData.reviewer2
    );
    ApproverResult.push(
      inactivereviewerinputData.consultant1Name,
      inactivereviewerinputData.consultant2Name,
      inactivereviewerinputData.checker1Name,
      inactivereviewerinputData.checker2Name,
      inactivereviewerinputData.authorName,
      inactivereviewerinputData.adminName,
      inactivereviewerinputData.reviewer1,
      inactivereviewerinputData.reviewer2
    );

    ArrayResult.push(
      inactivereviewerinputData.approver1Name,
      inactivereviewerinputData.approver2Name,
      inactivereviewerinputData.consultant1Name,
      inactivereviewerinputData.consultant2Name,
      inactivereviewerinputData.checker1Name,
      inactivereviewerinputData.checker2Name,
      inactivereviewerinputData.authorName,
      inactivereviewerinputData.adminName,
      inactivereviewerinputData.reviewer1,
      inactivereviewerinputData.reviewer2
    );
    ArrayResult1.push(
      inactivereviewerinputData.approver1Name,
      inactivereviewerinputData.approver2Name,
      inactivereviewerinputData.consultant1Name,
      inactivereviewerinputData.consultant2Name,
      inactivereviewerinputData.checker1Name,
      inactivereviewerinputData.checker2Name
    );

    if (CheckerResult?.length !== 0) {
      CheckerResult?.map((j) => {
        if (j) {
          SelectedCheckervalues.push(j.label);
        }
      });

      SelectedCheckervalues?.map((i) => {
        FilterCheckerArray = FilterCheckerArray.filter((j) => j.label !== i);
      });
      if (isSecondReviewer === false) {
        FinalChecker1Result = [...FilterCheckerArray];
        FinalChecker2Result = [...FilterCheckerArray];
      } else if (isSecondReviewer === true && reviewerRole === "checker1") {
        FilterCheckerArray = FilterCheckerArray.filter(
          (j) => j.label !== inactivereviewerinputData.checker2Name.label
        );
        FinalChecker1Result = [...FilterCheckerArray];
        FinalChecker2Result = [...FilterCheckerArray];
      } else if (isSecondReviewer === true && reviewerRole === "checker2") {
        FilterCheckerArray = FilterCheckerArray.filter(
          (j) => j.label !== inactivereviewerinputData.checker1Name.label
        );
        FinalChecker1Result = [...FilterCheckerArray];
        FinalChecker2Result = [...FilterCheckerArray];
      }

      setInactiveChecker1ArrayList(FinalChecker1Result);
      setInactiveChecker2ArrayList(FinalChecker2Result);
    }
    if (ConsultantResult?.length !== 0) {
      ConsultantResult?.map((j) => {
        if (j) {
          SelectedConsultantvalues.push(j.label);
        }
      });

      SelectedConsultantvalues?.map((i) => {
        FilterConsultantArray = FilterConsultantArray.filter(
          (j) => j.label !== i
        );
      });
      if (isSecondReviewer === false) {
        FinalConsultant1Result = [...FilterConsultantArray];
        FinalConsultant2Result = [...FilterConsultantArray];
      } else if (isSecondReviewer === true && reviewerRole === "consultant1") {
        FilterConsultantArray = FilterConsultantArray.filter(
          (j) => j.label !== inactivereviewerinputData.consultant2Name.label
        );
        FinalConsultant1Result = [...FilterConsultantArray];
        FinalConsultant2Result = [...FilterConsultantArray];
      } else if (isSecondReviewer === true && reviewerRole === "consultant2") {
        FilterConsultantArray = FilterConsultantArray.filter(
          (j) => j.label !== inactivereviewerinputData.consultant1Name.label
        );
        FinalConsultant1Result = [...FilterConsultantArray];
        FinalConsultant2Result = [...FilterConsultantArray];
      }
      setInactiveConsultant1ArrayList(FinalConsultant1Result);
      setInactiveConsultant2ArrayList(FinalConsultant2Result);
    }

    if (ApproverResult?.length !== 0) {
      ApproverResult?.map((j) => {
        if (j) {
          SelectedApprovervalues.push(j.label);
        }
      });

      SelectedApprovervalues?.map((i) => {
        FilterApproverArray = FilterApproverArray.filter((j) => j.label !== i);
      });
      if (isSecondReviewer === false) {
        FinalApprover1Result = [...FilterApproverArray];
        FinalApprover2Result = [...FilterApproverArray];
      } else if (isSecondReviewer === true && reviewerRole === "approver1") {
        FilterApproverArray = FilterApproverArray.filter(
          (j) => j.label !== inactivereviewerinputData.approver2Name.label
        );
        FinalApprover1Result = [...FilterApproverArray];
        FinalApprover2Result = [...FilterApproverArray];
      } else if (isSecondReviewer === true && reviewerRole === "approver2") {
        FilterApproverArray = FilterApproverArray.filter(
          (j) => j.label !== inactivereviewerinputData.approver1Name.label
        );
        FinalApprover1Result = [...FilterApproverArray];
        FinalApprover2Result = [...FilterApproverArray];
      }
      setInactiveApprover1ArrayList(FinalApprover1Result);
      setInactiveApprover2ArrayList(FinalApprover2Result);
    }

    if (ArrayResult1?.length !== 0) {
      ArrayResult1?.map((j) => {
        if (j) {
          Selectedvalues1.push(j.label);
        }
      });

      Selectedvalues1?.map((i) => {
        NewFilterArray = NewFilterArray.filter((j) => j.label !== i);
      });
      setInactiveAdminReviewersList(NewFilterArray);
      setInactiveAuthorList(NewFilterArray);
    }
  };

  const handleInactiveReviewerSelectChange = (value, field) => {
    ReviewerValue2 = true;
    if (value) {
      setInactiveReviewerInputData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
      setInactiveReviewerValueChanged(!inactivereviewervalueChanged);
    } else {
      setInactiveReviewerInputData((prevData) => ({
        ...prevData,
        [field]: "",
      }));
      setInactiveReviewerValueChanged(!inactivereviewervalueChanged);
    }
  };
  const InactiveReviewerSubmitRequest = () => {
    let inputs;
    if (approvalStatus?.toLowerCase() === "pending with admin") {
      inputs = inactivereviewerinputData.reviewer1 ? true : false;
    } else if (approvalStatus?.toLowerCase() === "pending with author") {
      inputs = inactivereviewerinputData.reviewer1 ? true : false;
    } else if (approvalStatus?.toLowerCase() === "pending with checker") {
      if (isSecondReviewer === false) {
        inputs = inactivereviewerinputData.reviewer1
          ? true
          : false && inactivereviewerinputData.reviewer2
            ? true
            : false;
      } else {
        if (reviewerRole === "checker1") {
          inputs = inactivereviewerinputData.reviewer1 ? true : false;
        }
        if (reviewerRole === "checker2") {
          inputs = inactivereviewerinputData.reviewer1 ? true : false;
        }
      }
    } else if (approvalStatus?.toLowerCase() === "pending with approver") {
      if (isSecondReviewer === false) {
        inputs = inactivereviewerinputData.reviewer1
          ? true
          : false && inactivereviewerinputData.reviewer2
            ? true
            : false;
      } else {
        if (reviewerRole === "approver1") {
          inputs = inactivereviewerinputData.reviewer1 ? true : false;
        }
        if (reviewerRole === "approver2") {
          inputs = inactivereviewerinputData.reviewer1 ? true : false;
        }
      }
    } else if (approvalStatus?.toLowerCase() === "pending with consultant") {
      if (isSecondReviewer === false) {
        inputs = inactivereviewerinputData.reviewer1
          ? true
          : false && inactivereviewerinputData.reviewer2
            ? true
            : false;
      } else {
        if (reviewerRole === "consultant1") {
          inputs = inactivereviewerinputData.reviewer1 ? true : false;
        }
        if (reviewerRole === "consultant2") {
          inputs = inactivereviewerinputData.reviewer1 ? true : false;
        }
      }
    }
    if (inputs) {
      setispendingLoader(true);
      let InactiveReviewerDetails = {
        id: dataDocumentId,
        documentName: dataDocumentName,
        documentNo: dataDocumentNumber,
        reviewer1Id: inactivereviewerinputData.reviewer1.value,
        reviewer2Id: inactivereviewerinputData.reviewer2.value,
        reason: " ",
      };
      let apiUrl = `${POST_INACTIVE_REVIEWER_DOCUMENT}?userId=${userId}`;
      axios({
        method: "POST",
        url: apiUrl,
        data: InactiveReviewerDetails,
      })
        .then((response) => {
          if (response?.status === 200) {
            setispendingLoader(false);
            ClearDataList();
            toast.success("Reassigned successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            });
            GetPendingTaskList("reviewDate", "asc");
          }
        })
        .catch((err) => {
          setispendingLoader(false);
          logoutFunction(err?.response?.status);
        });
    } else {
      if (approvalStatus?.toLowerCase() === "pending with admin") {
        authorError = false;
        adminError = true;
        category1Error = false;
        category2Error = false;
        approver1Error = false;
        approver2Error = false;
        checker1Error = false;
        checker2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (approvalStatus?.toLowerCase() === "pending with author") {
        authorError = true;
        adminError = false;
        category1Error = false;
        category2Error = false;
        approver1Error = false;
        approver2Error = false;
        checker1Error = false;
        checker2Error = false;
        consultant1Error = false;
        consultant2Error = false;
      } else if (approvalStatus?.toLowerCase() === "pending with checker") {
        if (isSecondReviewer === false) {
          if (
            inactivereviewerinputData.reviewer1 === "" &&
            inactivereviewerinputData.reviewer2 === ""
          ) {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = false;
            checker1Error = true;
            checker2Error = true;
            consultant1Error = false;
            consultant2Error = false;
          } else if (inactivereviewerinputData.reviewer1 === "") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = false;
            checker1Error = true;
            checker2Error = false;
            consultant1Error = false;
            consultant2Error = false;
          } else if (inactivereviewerinputData.reviewer2 == "") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = false;
            checker1Error = false;
            checker2Error = true;
            consultant1Error = false;
            consultant2Error = false;
          }
        } else {
          if (reviewerRole === "checker1") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = false;
            checker1Error = true;
            checker2Error = false;
            consultant1Error = false;
            consultant2Error = false;
          }
          if (reviewerRole === "checker2") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = false;
            checker1Error = false;
            checker2Error = true;
            consultant1Error = false;
            consultant2Error = false;
          }
        }
      } else if (approvalStatus?.toLowerCase() === "pending with approver") {
        if (isSecondReviewer === false) {
          if (
            inactivereviewerinputData.reviewer1 === "" &&
            inactivereviewerinputData.reviewer2 === ""
          ) {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = true;
            approver2Error = true;
            checker1Error = false;
            checker2Error = false;
            consultant1Error = false;
            consultant2Error = false;
          } else if (inactivereviewerinputData.reviewer1 === "") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = true;
            approver2Error = false;
            checker1Error = false;
            checker2Error = false;
            consultant1Error = false;
            consultant2Error = false;
          } else if (inactivereviewerinputData.reviewer2 == "") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = true;
            checker1Error = false;
            checker2Error = false;
            consultant1Error = false;
            consultant2Error = false;
          }
        } else {
          if (reviewerRole === "approver1") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = true;
            approver2Error = false;
            checker1Error = false;
            checker2Error = false;
            consultant1Error = false;
            consultant2Error = false;
          }
          if (reviewerRole === "approver2") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = true;
            checker1Error = false;
            checker2Error = false;
            consultant1Error = false;
            consultant2Error = false;
          }
        }
      } else if (approvalStatus?.toLowerCase() === "pending with consultant") {
        if (isSecondReviewer === false) {
          if (
            inactivereviewerinputData.reviewer1 === "" &&
            inactivereviewerinputData.reviewer2 === ""
          ) {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = false;
            checker1Error = false;
            checker2Error = false;
            consultant1Error = true;
            consultant2Error = true;
          } else if (inactivereviewerinputData.reviewer1 === "") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = false;
            checker1Error = false;
            checker2Error = false;
            consultant1Error = true;
            consultant2Error = false;
          } else if (inactivereviewerinputData.reviewer2 == "") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = false;
            checker1Error = false;
            checker2Error = false;
            consultant1Error = false;
            consultant2Error = true;
          }
        } else {
          if (reviewerRole === "consultant1") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = false;
            checker1Error = false;
            checker2Error = false;
            consultant1Error = true;
            consultant2Error = false;
          }
          if (reviewerRole === "consultant2") {
            authorError = false;
            adminError = false;
            category1Error = false;
            category2Error = false;
            approver1Error = false;
            approver2Error = false;
            checker1Error = false;
            checker2Error = false;
            consultant1Error = false;
            consultant2Error = true;
          }
        }
      }
    }
  };
  const CancelrequestAgainInactive = () => {
    let cancelPopup = new window.bootstrap.Modal(
      document.getElementById("CancelRequestScreen")
    );
    cancelPopup.show();
    $("body").addClass("scrollhide");
  };
  /* Search functionality */
  const handleChange = (e, field) => {
    if (field === "expiryDate") {
      const inputDate = e;
      setSearchInputData((prevData) => ({
        ...prevData,
        ["expiryDate"]: inputDate,
      }));
    } else {
      setSearchInputData((prevData) => ({
        ...prevData,
        [field]: e.target.value,
      }));
    }
  };

  const handleSearchSelectChange = (value, field) => {
    if (field === "category1") {
      if (value) {
        setSearchInputData((prevData) => ({
          ...prevData,
          [field]: value,
          category2: "",
        }));
        if (value?.value) {
          GetCategory2(value.value);
        }
      } else {
        setSearchInputData((prevData) => ({
          ...prevData,
          [field]: "",
        }));
      }
    } else {
      if (value) {
        setSearchInputData((prevData) => ({
          ...prevData,
          [field]: value,
        }));
      } else {
        setSearchInputData((prevData) => ({
          ...prevData,
          [field]: "",
        }));
      }
    }
  };

  const OpenPendingSearch = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("pendingSearchScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    const viewbar = document.getElementById("viewbar8");
    viewbar?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setAtleastFieldMandatory(false);
    setIsFormValid(false);
  };
  const clearSearch = () => {
    setSearchInputData({
      docNo: "",
      docName: "",
      category1: "",
      category1Id: 0,
      category2: "",
      category2Id: 0,
      author: "",
      authorId: 0,
      documentStatus: "",
      approvalStatus: "",
      expiryDate: "",
      assignedFor: "",
    });
    closeNewSearch = true;
    submitSearch();
  };
  const closeSearch = () => {
    $("#pendingSearchScreen").removeClass("show");
    $("body").removeClass("scrollhide");
  };
  const validatesubmitSearch = () => {
    const inputs = document.querySelectorAll(".my-input-class[required]");
    const filledInputs = Array.from(inputs).filter(
      (input) => input.value !== ""
    );
    const isInputValid = filledInputs?.length > 0;
    var category1Input = searchInputData.category1 ? true : false;
    var category2Input = searchInputData.category2 ? true : false;
    var authorInput = searchInputData.author ? true : false;

    var isDateInput = false;
    if (searchInputData.expiryDate === "") {
      isDateInput = false;
    } else {
      isDateInput = true;
    }
    const isValid =
      isInputValid ||
      isDateInput ||
      category2Input ||
      category1Input ||
      authorInput;
    if (isValid) {
      setAtleastFieldMandatory(false);
      submitSearch();
    } else {
      setAtleastFieldMandatory(true);
    }
  };
  const submitSearch = () => {
    setispendingLoader(true);
    let order = sortOrder === "asc" ? true : false;
    var searchDetails = "";
    if (closeNewSearch) {
      searchDetails = {
        pageNumber: 1,
        pagesize: perPage,
        documentId: 0,
        documentName: null,
        documentNo: null,
        category1Id: 0,
        category1Name: null,
        category2Id: 0,
        category2Name: null,
        documentStatus: null,
        approvalStatus: null,
        assignedFor: null,
        fileId: 0,
        fileName: null,
        fileType: null,
        authorId: 0,
        authorName: null,
        fromDate: null,
        toDate: null,
        publishedDate: null,
        expiryDate: null,
        requestedDate: null,
      };
    } else {
      searchDetails = {
        pageNumber: 1,
        pagesize: perPage,
        documentId: 0,
        documentName: searchInputData.docName ? searchInputData.docName : null,
        documentNo: searchInputData.docNo ? searchInputData.docNo : null,
        category1Id: searchInputData.category1
          ? searchInputData.category1.value
          : 0,
        category1Name: searchInputData.category1
          ? searchInputData.category1.label
          : null,
        category2Id: searchInputData.category2
          ? searchInputData.category2.value
          : 0,
        category2Name: searchInputData.category2
          ? searchInputData.category2.label
          : null,
        documentStatus: searchInputData.documentStatus
          ? searchInputData.documentStatus
          : null,
        approvalStatus: searchInputData.approvalStatus
          ? searchInputData.approvalStatus
          : null,
        fileId: 0,
        fileName: null,
        fileType: null,
        authorId: searchInputData.author ? searchInputData.author.value : 0,
        authorName: searchInputData.author
          ? searchInputData.author.label
          : null,
        assignedFor: searchInputData.assignedFor
          ? searchInputData.assignedFor
          : null,
        fromDate: null,
        toDate: null,
        publishedDate: null,
        expiryDate: searchInputData.expiryDate
          ? moment(searchInputData.expiryDate).format("YYYY-MM-DD")
          : null,
        requestedDate: null,
      };
    }
    let apiUrl = `${API.GET_ALL_PENDINGTASKS}?userId=${userId}&sortBy=${sortName}&isSortAscending=${order}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: searchDetails,
    })
      .then((res) => {
        if (res.status === 200) {
          setCurrentPage(1);
          closeNewSearch = false;
          sethasPrevious(res.data.hasPrevious);
          sethasNext(res.data.hasNext);
          setPageCount(res.data?.totalCount);
          setpendingCount(res.data?.totalCount);
          setpendingtaskList(res.data.values);
          $("body").removeClass("scrollhide");
          setispendingLoader(false);
          setIsFormValid(true);
          document.getElementById("CloseSearch").click();
        }
      })
      .catch((error) => {
        if (error.response.status === 400 || error.response.status === 500) {
          toast.error("Failed to search. Please try again", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
        }
        setispendingLoader(false);
        logoutFunction(error?.response?.status);
      });
  };

  const handleCheckboxChange = (event) => {
    setIsPasswordProtected(event.target.checked);
  };

  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);

  const HandleFileOpen = (id) => {
    const fileInput = document.getElementById(id);
    fileInput.click();
  }

  const changePassword = () => {
    setIsChangePassword(true);
    setIsPasswordProtected(documentIsPasswordProtected);
    setNewPasswordValue("");
    setConfirmPasswordValue("");
    setTimeout(() => {
      if (documentIsPasswordProtected == true) {
        $('.password-checkbox').prop('checked', true);
      } else {
        $('.password-checkbox').prop('checked', false);
      }
    }, 10)
  };

  const handleCancelUpdatePassword = () => {
    setIsChangePassword(false);
    setNewPasswordValue("");
    setIsPasswordProtected(documentIsPasswordProtected);
    setDocumentPassword(documentPassword);
  };

  return (
    <>
      {$("#pendingCheckerScreen").hasClass("show") ||
        $("#pendingSearchScreen").hasClass("show") ||
        $("#AuthorSubmissionScreen").hasClass("show") ||
        $("#AuthorReSubmissionScreen").hasClass("show") ||
        $("#pendingAdminScreen").hasClass("show") ||
        $("#resubmitScreen").hasClass("show") ||
        $("#obsoleteScreen").hasClass("show") ||
        $("#archiveScreen").hasClass("show") ||
        $("#renewScreen").hasClass("show") ? (
        <div className="viewbar-overlay" id="closeCanvas"></div>
      ) : (
        <></>
      )}
      <div
        className={`${isMobile
            ? "main-body-mobile table-responsive-xl"
            : menuToggle
              ? "menu-main-body table-responsive-xl"
              : "main-body table-responsive-xl"
          } ${pendingCommonSearchResult === true &&
            window.location.pathname === "/pendingtasks"
            ? "displaynone"
            : ""
          }`}
      // style={{ height: windowHeight - 1 }}
      >
        {ispendingLoader && (
          <div className="spinner_overlay">
            <div className="loader">
              <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
            </div>
          </div>
        )}

        {ispendingFailed && (
          <div className="spinner_overlay">
            <div className="loader">
              <span>Loading failed</span>
            </div>
          </div>
        )}
        {isMobile == true ? (
          <div
            className="head-fixed"
          //style={{ height: "123px"}}
          >
            <div
              className="mobile-head border-bottom w-100"
              style={{ top: "46px" }}
            >
              <div className="col-12 mobile-title d-flex align-items-center">
                <span>My pending tasks</span>
                <span className="d-flex">
                  <span className="rejectedstatus-color title-count ms-1">
                    &#40;
                  </span>
                  <span
                    id="title-count-style"
                    className="rejectedstatus-color title-count pending1"
                  >
                    {pendingCount}
                  </span>
                  <span className="rejectedstatus-color title-count">
                    &#41;
                  </span>
                </span>
                {/* My pending tasks{" "}
                <label className="rejectedstatus-color">
                  {"(" + pendingCount + ")"}
                </label> */}
              </div>
            </div>
            <div
              className={`${isMobile ? "common-mobiletable-style" : "common-table-style"
                }`}
            >
              <div
                className={`col-12 d-flex justify-content-start border-bottom table-responsive ${isMobile ? "pl-1" : isSmallMobile ? "" : "pl-10"
                  } `}
              >
                <table width="100%">
                  <tbody>
                    <tr>
                      <td width="100%" className="text-end">
                        <button
                          className={`displaybutton ${isSmallMobile ? "pl-0" : ""
                            }`}
                          id="displaybuttoncolor"
                          onClick={OpenPendingSearch}
                        >
                          <img src={Filter} style={{ marginTop: "-4px" }}></img>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <div className="head-fixed">
            <div id="PendingTaskTitle">
              <img alt="" src={PendingTaskIcon} />
              <span className="pl-10 head-span mt-11 title-span d-flex">
                My pending tasks
                <span className="d-flex">
                  <span className="rejectedstatus-color title-count ms-1">
                    &#40;
                  </span>
                  <span
                    id="title-count-style"
                    className="rejectedstatus-color title-count pending1"
                  >
                    {pendingCount}
                  </span>
                  <span className="rejectedstatus-color title-count ">
                    &#41;
                  </span>
                </span>
              </span>
            </div>
            {/* <div className="title">
              <img alt="" src={PendingTaskIcon} />
              <span className="pl-10 head-span mt-10">
                My pending tasks{" "}
                <label className="rejectedstatus-color">
                  {"(" + pendingCount + ")"}
                </label>
              </span>
            </div> */}
            <div
              className={`${isMobile
                  ? "mobile-search"
                  : menuToggle
                    ? " sidemenu-search"
                    : "web-search"
                }`}
            >
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="100%" className="text-end">
                      <button
                        className={`displaybutton ${isRadioMobile ? "pr-0" : ""
                          } ${isSmallMobile ? "pl-0" : ""}`}
                        id="displaybuttoncolor"
                        onClick={OpenPendingSearch}
                      >
                        <img src={Filter} style={{ marginTop: "-4px" }}></img>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
        <ToastContainer limit={1} />
        <div
          className={`${isMobile ? "pending-mobile-table " : "pending-table1 "
            } table-responsive  table-fixed-header table-responsive-height`}
        >
          {/* <div
            className="table-responsive common-table-bottom"
            style={{ width: "100%" }}
          > */}
          <table className="table fileListTable2 table-borderless table-hover">
            <thead className="thead-sticky  thead-color">
              <tr>
                <td></td>
                <td
                  className="cursor-pointer"
                  onClick={() => sortTable("documentNo")}
                >
                  {" "}
                  Document no.{" "}
                  {sortName === "documentNo" && (
                    <img
                      src={sortOrder === "asc" ? UpArrowIcon : DownArrowIcon}
                      alt=""
                    />
                  )}
                </td>
                <td
                  className="cursor-pointer"
                  onClick={() => sortTable("documentName")}
                >
                  {" "}
                  Document name{" "}
                  {sortName === "documentName" && (
                    <img
                      src={sortOrder === "asc" ? UpArrowIcon : DownArrowIcon}
                      alt=""
                    />
                  )}
                </td>
                <td
                  className="cursor-pointer"
                  onClick={() => sortTable("authorName")}
                >
                  Author{" "}
                  {sortName === "authorName" && (
                    <img
                      src={sortOrder === "asc" ? UpArrowIcon : DownArrowIcon}
                      alt=""
                    />
                  )}
                </td>
                <td
                  className="cursor-pointer"
                  onClick={() => sortTable("category1Name")}
                >
                  Category 1{" "}
                  {sortName === "category1Name" && (
                    <img
                      src={sortOrder === "asc" ? UpArrowIcon : DownArrowIcon}
                      alt=""
                    />
                  )}
                </td>
                <td
                  className="cursor-pointer"
                  onClick={() => sortTable("category2Name")}
                >
                  Category 2{" "}
                  {sortName === "category2Name" && (
                    <img
                      src={sortOrder === "asc" ? UpArrowIcon : DownArrowIcon}
                      alt=""
                    />
                  )}
                </td>
                {userRole === role.ADMIN ? (
                  <>
                    <td
                      className="cursor-pointer"
                      onClick={() => sortTable("documentStatus")}
                    >
                      {" "}
                      Document status{" "}
                      {sortName === "documentStatus" && (
                        <img
                          src={
                            sortOrder === "asc" ? UpArrowIcon : DownArrowIcon
                          }
                          alt=""
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => sortTable("approvalStatus")}
                    >
                      {" "}
                      Approval status{" "}
                      {sortName === "approvalStatus" && (
                        <img
                          src={
                            sortOrder === "asc" ? UpArrowIcon : DownArrowIcon
                          }
                          alt=""
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => sortTable("reviewDate")}
                    >
                      {" "}
                      Expiry date/time{" "}
                      {sortName === "reviewDate" && (
                        <img
                          src={
                            sortOrder === "asc" ? UpArrowIcon : DownArrowIcon
                          }
                          alt=""
                        />
                      )}
                    </td>
                  </>
                ) : (
                  ""
                )}
                {userRole === role.REVIEWER ? (
                  <>
                    <td
                      className="cursor-pointer"
                      onClick={() => sortTable("assignedFor")}
                    >
                      {" "}
                      Assigned for{" "}
                      {sortName === "assignedFor" && (
                        <img
                          src={
                            sortOrder === "asc" ? UpArrowIcon : DownArrowIcon
                          }
                          alt=""
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => sortTable("assignedDate")}
                    >
                      {" "}
                      Assigned date/time{" "}
                      {sortName === "assignedDate" && (
                        <img
                          src={
                            sortOrder === "asc" ? UpArrowIcon : DownArrowIcon
                          }
                          alt=""
                        />
                      )}
                    </td>
                  </>
                ) : (
                  ""
                )}
                <td></td>
              </tr>
            </thead>
            <tbody>
              {userRole === role.ADMIN &&
                pendingtaskList?.map((item, index) => (
                  <tr id={"active" + item.id} className="ledgerRadioSelect">
                    <td></td>
                    <td
                      onClick={(e) =>
                        handleDcocumentNo(
                          e,
                          item.id,
                          item.assignedFor,
                          item.documentStatus,
                          "Admin",
                          item.approvalStatus
                        )
                      }
                    >
                      <a
                        className="properties-view tableoverflowNo hoverUnderline"
                        title={item.documentNo}
                      >
                        {item.documentNo}
                      </a>{" "}
                    </td>
                    <td>
                      <span
                        className="tableoverflowNo"
                        title={item.documentName}
                      >
                        {item.documentName}
                      </span>{" "}
                    </td>
                    <td>
                      <span className="tableoverflow1" title={item.authorName}>
                        {item.authorName}
                      </span>
                    </td>
                    <td>
                      <span
                        className="tableoverflow1"
                        title={item.category1Name}
                      >
                        {item.category1Name}
                      </span>
                    </td>
                    <td>
                      <span
                        className="tableoverflow1"
                        title={item.category2Name}
                      >
                        {item.category2Name}
                      </span>
                    </td>
                    <td
                      className={`${item.documentStatus === "Expired"
                          ? "rejectedstatus-color"
                          : item.documentStatus == "Not started"
                            ? "rejectedstatus-color"
                            : "expire20-color"
                        }`}
                    >
                      <span
                        className="tableoverflow1"
                        title={item.documentStatus}
                      >
                        {item.documentStatus}
                      </span>
                    </td>
                    <td
                      className={`${item.approvalStatus === "Expired"
                          ? "rejectedstatus-color"
                          : item.approvalStatus == "Not started"
                            ? "rejectedstatus-color"
                            : "expire20-color"
                        }`}
                    >
                      {" "}
                      <span
                        className="tableoverflowStatus"
                        title={item.approvalStatus}
                      >
                        {item.approvalStatus}
                      </span>
                    </td>
                    <td>
                      <span className="tableoverflowDate">
                        {item.reviewDate
                          ? Moment(
                            new Date(Date.parse(item.reviewDate))
                          ).format("DD-MMM-YYYY h:mm A")
                          : ""}
                      </span>
                    </td>
                    <td></td>
                  </tr>
                ))}

              {userRole === role.REVIEWER &&
                pendingtaskList?.map((item, index) => (
                  <tr id={"active" + item.id} className="ledgerRadioSelect">
                    <td></td>
                    {item.assignedFor === "Approval" && (
                      <td
                        className="cursor-pointer"
                        onClick={(e) =>
                          handleDcocumentNo(
                            e,
                            item.id,
                            item.assignedFor,
                            "",
                            "Checker"
                          )
                        }
                      >
                        <a
                          className="properties-view tableoverflowNo"
                          title={item.documentNo}
                        >
                          {item.documentNo}
                        </a>
                      </td>
                    )}
                    {item.assignedFor === "Submission" && (
                      <td
                        className="cursor-pointer"
                        onClick={(e) =>
                          handleDcocumentNo(
                            e,
                            item.id,
                            item.assignedFor,
                            "",
                            "Submit"
                          )
                        }
                      >
                        <a
                          className="properties-view tableoverflowNo"
                          title={item.documentNo}
                        >
                          {item.documentNo}
                        </a>
                      </td>
                    )}
                    {item.assignedFor === "Resubmission" && (
                      <td
                        className="cursor-pointer"
                        onClick={(e) =>
                          handleDcocumentNo(
                            e,
                            item.id,
                            item.assignedFor,
                            "",
                            "Resubmit"
                          )
                        }
                      >
                        <a
                          className="properties-view tableoverflowNo"
                          title={item.documentNo}
                        >
                          {item.documentNo}
                        </a>
                      </td>
                    )}
                    <td>
                      <span
                        className="tableoverflowNo"
                        title={item.documentName}
                      >
                        {item.documentName}
                      </span>
                    </td>
                    <td>
                      <span className="tableoverflow1" title={item.authorName}>
                        {item.authorName}
                      </span>
                    </td>
                    <td>
                      <span
                        className="tableoverflow1"
                        title={item.category1Name}
                      >
                        {item.category1Name}
                      </span>
                    </td>
                    <td>
                      <span
                        className="tableoverflow1"
                        title={item.category2Name}
                      >
                        {item.category2Name}
                      </span>
                    </td>
                    <td>
                      <span className="tableoverflow1" title={item.assignedFor}>
                        {item.assignedFor}
                      </span>
                    </td>
                    <td>
                      <span className="tableoverflowDate">
                        {item.assignedDate
                          ? Moment(
                            new Date(Date.parse(item.assignedDate))
                          ).format("DD-MMM-YYYY h:mm A")
                          : ""}
                      </span>
                    </td>
                    <td></td>
                  </tr>
                ))}
              {pendingCount == 0 && (
                <tr className="ledgerRadioSelect">
                  <td
                    colspan="9"
                    style={{ textAlign: "center" }}
                    className="fw-400"
                  >
                    {pendingtaskList && "No record found"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {/* </div> */}
        </div>
        <div
          className={`${isMobile
              ? "common-mobilesubmenu mobile-pagination"
              : menuToggle
                ? "common-submenu sidemenu-pagination"
                : "common-submenu web-pagination"
            } pb-2 pt-2`}
        >
          {pendingtaskList?.length > 0 ? (
            <table width="100%">
              <tbody>
                <tr>
                  <td width="8%" className="p-3">
                    <div
                      className={`${iswebMobile ? "mobilePageSelect" : "webpageSelect"
                        }`}
                    >
                      <Select
                        options={paginglist}
                        defaultValue={paginglistDefault}
                        classNamePrefix="paging"
                        isSearchable={false}
                        menuPlacement={"top"}
                        menuPosition={"fixed"}
                        onChange={(e) => find(e)}
                      />
                    </div>
                  </td>
                  <td
                    width="92%"
                    className={`text-end ${isCancelMobile ? "pagination-padd" : "p-3"
                      }`}
                  >
                    {isMobile ? (
                      <Pagination
                        prevPageText={
                          <>
                            {" "}
                            <img src={LeftArrowIcon} />
                          </>
                        }
                        nextPageText={
                          <>
                            <img src={RightArrowIcon} />{" "}
                          </>
                        }
                        linkClassNext="nextArrow"
                        linkClassPrev="prevArrow"
                        itemClass={`page-item`}
                        linkClass="page-link"
                        pageRangeDisplayed={1}
                        onChange={(e) => handlePageChange(e)}
                        className="shadow-none"
                        activePage={currentPage}
                        totalItemsCount={pageCount}
                        itemsCountPerPage={perPage}
                        onBlur={(e) => e.target.focus()}
                      />
                    ) : (
                      <Pagination
                        prevPageText={
                          <>
                            {" "}
                            <img src={LeftArrowIcon} />
                          </>
                        }
                        nextPageText={
                          <>
                            <img src={RightArrowIcon} />{" "}
                          </>
                        }
                        linkClassNext="nextArrow"
                        linkClassPrev="prevArrow"
                        itemClass={`page-item`}
                        linkClass="page-link"
                        pageRangeDisplayed={4}
                        onChange={(e) => handlePageChange(e)}
                        activePage={currentPage}
                        totalItemsCount={pageCount}
                        itemsCountPerPage={perPage}

                      // onBlur={e => e.target.focus()}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          ) : null}
        </div>
      </div>

      {/* Common search */}
      <div
        className="offcanvas offcanvas-end offcanvaspendingStyle"
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="pendingSearchScreen"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div
          className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}
        >
          <h6 id="offcanvasRightLabel" className="modal-title">
            Search
          </h6>
          <button
            id="CloseSearch"
            onClick={closeSearch}
            className={`text-reset offcavasclose ${classes.button} ${isMobile ? "pr-0" : "pr-0"
              }`}
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            style={{ backgroundColor: "white" }}
          >
            <img
              alt=""
              src={CrossIcon}
              className="cursor-pointer app-image-hover"
            />
          </button>{" "}
        </div>
        <div className="offcanvas-body px-4 pt-0" id="viewbar8">
          <div className="row">
            <div className="col-sm-6 col-12 d-flex flex-column mt-2 mb-2">
              <div className="inputTitle commonsearch-field">
                <span>
                  <img
                    style={{ position: "relative", top: "-1px" }}
                    src={infoBlack}
                    alt=""
                  />{" "}
                  Document no.
                </span>
              </div>
              <input
                style={{ fontSize: "12px" }}
                value={searchInputData.docNo}
                onChange={(e) => handleChange(e, "docNo")}
                className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                maxLength={255}
                required
              />
            </div>
            <div className="col-sm-6 col-12 mt-2 mb-2">
              <div className="inputTitle commonsearch-field">
                <img src={file} alt="" />
                <span> Document name</span>
              </div>
              <input
                style={{ fontSize: "12px" }}
                value={searchInputData.docName}
                onChange={(e) => handleChange(e, "docName")}
                maxLength={255}
                className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                required
              />
            </div>
            <div className="col-sm-6 col-12 mt-2 mb-2">
              <div className="inputTitle mb-2 commonsearch-field">
                <img src={SubCategoryIcon} alt="" />
                <span> Category 1</span>
              </div>
              <Select
                // onInputChange={(e) => {
                //   console.log(e);
                // }}
                name={searchInputData.category1}
                className="text-12-normal"
                classNamePrefix="assigngroups"
                value={searchInputData.category1}
                options={category1List}
                defaultValue={searchInputData.category1 || "Select"}
                isMulti={false}
                isSearchable={true}
                isClearable={true}
                onChange={(value) => {
                  handleSearchSelectChange(value, "category1");
                }}
              />
            </div>

            <div className="col-sm-6 col-12 mt-2 mb-2">
              <div className="inputTitle mb-2 commonsearch-field">
                <img src={SubCategoryIcon} alt="" />
                <span> Category 2</span>
              </div>
              <Select
                className="text-12-normal"
                classNamePrefix="assigngroups"
                value={searchInputData.category2}
                options={category2List}
                isDisabled={!searchInputData.category1}
                defaultValue={searchInputData.category2 || "Select"}
                isMulti={false}
                isSearchable={true}
                isClearable={true}
                onChange={(value) =>
                  handleSearchSelectChange(value, "category2")
                }
              />
            </div>

            <div className="col-sm-6 col-12 mt-2 mb-2">
              <div className="inputTitle mb-2 commonsearch-field">
                <img src={AssignIcon} alt="" />
                <span> Author</span>
              </div>
              <Select
                className={`text-12-normal`}
                classNamePrefix="assigngroups"
                value={searchInputData.author}
                options={searchAuthorList}
                defaultValue={searchInputData.author || "Select"}
                isMulti={false}
                isSearchable
                isClearable
                onChange={(value) => handleSearchSelectChange(value, "author")}
              />
            </div>
            {userRole === role.ADMIN && (
              <>
                <div className="col-sm-6 col-12 mt-2 mb-2">
                  <div className="inputTitle commonsearch-field">
                    <img src={infoBlack} alt="" />
                    <span> Document status</span>
                  </div>
                  <input
                    style={{ fontSize: "12px", height: "35px" }}
                    value={searchInputData.documentStatus}
                    onChange={(e) => handleChange(e, "documentStatus")}
                    maxLength={255}
                    className="form-control my-input-class border-radius shiptype-select mt-2" //dropdown-height
                    required
                  />
                </div>
                <div className="col-sm-6 col-12 mt-2 mb-2">
                  <div className="inputTitle commonsearch-field">
                    <img src={infoBlack} alt="" />
                    <span> Approval status</span>
                  </div>
                  <input
                    style={{ fontSize: "12px" }}
                    value={searchInputData.approvalStatus}
                    maxLength={255}
                    onChange={(e) => handleChange(e, "approvalStatus")}
                    className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                    required
                  />
                </div>
              </>
            )}
            {userRole === role.REVIEWER && (
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle commonsearch-field">
                  <img src={infoBlack} alt="" />
                  <span>Assigned For</span>
                </div>
                <input
                  style={{ fontSize: "12px" }}
                  value={searchInputData.assignedFor}
                  onChange={(e) => handleChange(e, "assignedFor")}
                  maxLength={255}
                  className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                  required
                />
              </div>
            )}
            <div
              className="col-sm-6 col-12 mt-2 mb-2"
              style={{ marginTop: "12px" }}
            >
              <div className="inputTitle date-bottom3 commonsearch-field">
                <img src={calender} alt="" />
                <span>Expiry date </span>
              </div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  className="form-control f-12 mt-1 expiry-date-height"
                  emptyLabel="dd-mmm-yyyy"
                  keyboardIcon={<img src={dateIcon} />}
                  format="dd-MMM-yyyy"
                  value={
                    searchInputData.expiryDate
                      ? searchInputData.expiryDate
                      : null
                  }
                  size="small"
                  onChange={(e) => handleChange(e, "expiryDate")}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>

          {AtleastFieldMandatory && (
            <p style={{ color: "red" }}>At least one field is mandatory</p>
          )}

          <div className="button" style={{ display: "flex" }}>
            <button
              id="edit2"
              data-bs-dismiss={isFormValid && "offcanvas"}
              onClick={clearSearch}
            >
              <span className="clear-icon-position">✕</span>
              <span>Clear</span>
            </button>
            <button
              id="edit"
              data-bs-dismiss={isFormValid && "offcanvas"}
              onClick={validatesubmitSearch}
            >
              <img
                style={{ marginTop: "-4px", marginRight: "4px", width: "14px" }}
                src={search}
                alt=""
              />
              Search
            </button>
          </div>
        </div>
      </div>

      {/* If click a document name following code is display */}
      <div
        className="offcanvas offcanvas-end offcanvaspendingStyle"
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="pendingCheckerScreen"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div
          className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}
        >
          <h6 id="offcanvasRightLabel" className="modal-title">
            {dataDocumentNo}
          </h6>
          <button
            onClick={ClearDataList}
            className={`text-reset offcavasclose ${classes.button} ${isMobile ? "pr-0" : ""
              }`}
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            style={{ backgroundColor: "white", alignSelf: "self-start" }}
          >
            <img
              alt=""
              src={CrossIcon}
              className="cursor-pointer app-image-hover"
            />
          </button>
        </div>
        <div className="offcanvas-body px-4 pt-0" id="viewbar">
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img "
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-7 properties-span">Document no.</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentNo}
                >
                  {dataDocumentNo}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={SearchFileIcon} />{" "}
                  <span className="pl-7 properties-span mt-1">
                    Document name
                  </span>
                  &nbsp;
                </label>
                <label
                  className={` Propertiestext-overflow fS ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentName}
                >
                  {dataDocumentName ? dataDocumentName : " - "}
                </label>
              </div>
            </div>

            <div
              className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={AssignIcon} />{" "}
                  <span className="pl-7 properties-span">Author</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataAuthor?.label}
                >
                  {selectcommonfield.dataAuthor?.label
                    ? selectcommonfield.dataAuthor?.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-7 properties-span">Version</span>&nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataVersion}
                >
                  {dataVersion ? dataVersion : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-7 properties-span">Category 1</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory1.label}
                >
                  {selectcommonfield.dataCategory1.label
                    ? selectcommonfield.dataCategory1.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-7 properties-span">Category 2</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  tiltle={selectcommonfield.dataCategory2.label}
                >
                  {" "}
                  {selectcommonfield.dataCategory2?.label
                    ? selectcommonfield.dataCategory2.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={NotesIcon} />{" "}
                  <span className="pl-7 properties-span">Notes</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataRemarks ? dataRemarks : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Registered date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataCreatedDate ? dataCreatedDate : " - "}
                </label>
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Expiry date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataExpiryDate ? dataExpiryDate : " - "}
                </label>
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={SearchFileIcon} />{" "}
                  <span className="pl-7 properties-span">Files</span>
                </label>
                <div className="row">
                  {approvedocumentsList?.map((j, index) => (
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 pr-0">
                      {j.fileType !== "url" ? (
                        <label
                          className={`cursor-pointer url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                            }`}
                          onClick={() => openFileDocument(j.id)}
                        >
                          <FileIcon
                            fileName={j.fileName}
                            style={{ width: "15px" }}
                          />
                          <span className="pl-7 text-center urlspan">
                            {j.fileName}
                          </span>
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={URLIcon} />{" "}
                  <span className="pl-7 properties-span">URLs</span>
                </label>
                <div className="row">
                  {approvedocumentsList?.map((j, index) => (
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                      {j.fileType === "url" ? (
                        <label
                          className={`cursor-pointer url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                            }`}
                          onClick={() => openURL(j.fileName)}
                        >
                          <img
                            alt=""
                            src={URLworldIcon}
                            style={{ width: "17px" }}
                          />
                          <span className="pl-7 text-center urlspan">
                            {j.fileName}
                          </span>
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={RemarkIcon} />{" "}
                  <span className="pl-10 properties-span">Comments</span>
                </label>
                <textarea
                  onChange={(e) => handleRemorkInputChange(e)}
                  value={pendingreasontext.remark}
                  id="checkerSendBack"
                  className="form-control border-radius mt-2"
                  style={{
                    width: "100%",
                    height: "70px",
                    fontSize: "12px",
                    maxHeight: "70px",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row mt-1">
            <div
              // className={`${
              //   iswebMobile ? "col-12" : "col-5"
              // } col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3  ${
              //   isMobile ? "mt-4" : "mt-2"
              // }`}
              className={`col-12 ${iswebMobile
                  ? "mt-3 d-flex flex-column gap-1"
                  : "d-flex gap-1 mt-3"
                }`}
            >
              <button
                className={`btn btn-light input-group offcavasclose filter-reworkbtn p-2`}
                onClick={() => openCheckerSendBack()}
              >
                <img alt="" src={ButtonReworkIcon} className="modal-img"></img>
                <span className="send-rework-label pl-5">Send for rework</span>
              </button>
              <button
                className={`btn btn-light input-group offcavasclose filter-nextbtn2 p-2`}
                onClick={() => UpdateApprovePendingtask()}
              >
                <img alt="" src={ButtonApproveIcon} className="modal-img"></img>
                <span style={{ marginTop: "3px" }} className="model-label pl-5">Approve</span>
              </button>
            </div>
            {/* <div
              className={`${isRadioMobile ?"ps-2" : ""} ${
                iswebMobile ? "col-12 pl-10" : "col-7"
              } col-sm-8 col-md-8 col-lg-8 col-xl-8 mb-3 ${
                iswebMobile ? "mt-2" : isMobile ? "mt-4 pl-0" : "mt-2 pl-20"
              }`}
            >
              <button
                className={`btn btn-light input-group offcavasclose filter-nextbtn2 p-2`}
                onClick={() => UpdateApprovePendingtask()}
              >
                <img alt="" src={ButtonApproveIcon} className="modal-img"></img>
                <span className="model-label pl-5">Approve</span>
              </button>
            </div> */}
          </div>
          <div className="row mt-2">
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={VersionIcon} />{" "}
                  <span className="pl-10 properties-span">History log</span>
                </label>
                <div className="table-responsive mb-4 mt-3">
                  <table id="historyTable" style={{ width: "100%" }}>
                    <tbody>
                      {historyLogList?.map((i, index) => (
                        <>
                          <tr id={index}>
                            <th className="title-width">{i.status}</th>
                            <td
                              className={`history-date ${isRadioMobile ? "date-width" : ""
                                }`}
                            >
                              {i.createdDate
                                ? Moment(
                                  new Date(Date.parse(i.createdDate))
                                ).format("DD-MMM-YYYY h:mm A")
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <th colSpan={2}>
                              {i.reviewer + " " + "(" + i.type + ")"}
                            </th>
                          </tr>
                          <tr>
                            <td colSpan={2} className="history-comment">
                              {i.comments}
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*Author Submit documents */}
      <div
        className="offcanvas offcanvas-end offcanvaspendingStyle"
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="AuthorSubmissionScreen"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div
          className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}
        >
          <h6 id="offcanvasRightLabel" className="modal-title">
            Submit documents
          </h6>
          <button
            onClick={ClearDataList}
            className={`text-reset offcavasclose ${classes.button} ${isMobile ? "pr-0" : ""
              }`}
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            style={{ backgroundColor: "white" }}
          >
            <img
              alt=""
              src={CrossIcon}
              className="cursor-pointer app-image-hover"
            />
          </button>{" "}
        </div>
        <div className="offcanvas-body px-4 pt-0" id="viewbar1">
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Document no.</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentNo}
                >
                  {dataDocumentNo}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={SearchFileIcon} />{" "}
                  <span className="pl-10 properties-span">Document name</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow fS ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentName}
                >
                  {dataDocumentName ? dataDocumentName : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                  <span className="pl-10 properties-span">Author</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataAuthor?.label}
                >
                  {selectcommonfield.dataAuthor?.label
                    ? selectcommonfield.dataAuthor?.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Version</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataVersion}
                >
                  {dataVersion ? dataVersion : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 1</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory1.label}
                >
                  {selectcommonfield.dataCategory1.label
                    ? selectcommonfield.dataCategory1.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 2</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory2.label}
                >
                  {selectcommonfield.dataCategory2.label
                    ? selectcommonfield.dataCategory2.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Registered date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataCreatedDate ? dataCreatedDate : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Expiry date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataExpiryDate ? dataExpiryDate : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={NotesIcon} />{" "}
                  <span className="pl-10 properties-span">Notes</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataRemarks ? dataRemarks : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${isSmallMobile ? "" : "mt-2"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-search-img"
                    src={SearchFileIcon}
                  />{" "}
                  <span className="pl-10 properties-search-span">
                    Document 1
                  </span>
                  &nbsp;
                </label>
                {document1selected == "1" ? (
                  <>
                    <div class="input-group attach-style mt-2">
                      <div class="d-flex w-100">
                        <label
                          class={`file-label-style mb-2 ${document1Name.uniqueId != "" ? "file-select" : ""
                            }`}
                          aria-describedby="inputGroupFileAddon"
                        >
                          {document1Name.uniqueId != "" && (
                            <>
                              {" "}
                              <i className="FileIcon-img">
                                {" "}
                                <FileIcon fileName={document1Name.uniqueId} />
                              </i>
                              <span>{document1Name.uniqueId}</span>
                              <i onClick={deletefiles1}>
                                <img
                                  alt=""
                                  class="mx-auto FileIcon-cross"
                                  src={AttchCloseIcon}
                                />
                              </i>{" "}
                            </>
                          )}
                        </label>
                        <div class="custom-file-input" onClick={() => HandleFileOpen("inputGroupFile1")}>
                          <input
                            type="file"
                            id="inputGroupFile1"
                            hidden
                            onChange={(e) =>
                              upload_document1(e, "uniqueId", "Submit")
                            }
                          />
                          <img
                            alt=""
                            class="attchement-icon mx-auto"
                            src={AttchementIcon}
                          ></img>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <input
                    type="text"
                    class="form-control input-style mt-2"
                    value={document1Name.fileUrl}
                    maxLength={255}
                    onChange={(e) =>
                      handleUrlTextchanges(e, "document1", "fileUrl", "Submit")
                    }
                  />
                )}

                <div className="toggle-btn-grp mt-2">
                  {toggleItems?.map((item, index) => (
                    <>
                      <input
                        type="radio"
                        className="btn-check"
                        name="options-outlined"
                        id={`toggleItem${index}`}
                        value={item.value}
                        checked={document1selected == item.value}
                        autocomplete="off"
                        onClick={(e) => handleToggle(e)}
                      />
                      <label
                        className={`btn toggle-btn mb-0 ${document1selected == item.value ? "toggle-active" : ""
                          }`}
                        for={`toggleItem${index}`}
                      >
                        <img
                          alt=""
                          className="toggle-img"
                          src={
                            document1selected == item.value
                              ? item.name1
                              : item.name
                          }
                        />
                      </label>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${isSmallMobile ? "" : "mt-2"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-search-img"
                    src={SearchFileIcon}
                  />{" "}
                  <span className="pl-10 properties-search-span">
                    Document 2
                  </span>
                  &nbsp;
                </label>
                {document2selected == "1" ? (
                  <div class="input-group attach-style mt-2">
                    <div class="d-flex w-100">
                      <label
                        class={`file-label-style mb-2 ${document2Name.uniqueId != "" ? "file-select" : ""
                          }`}
                        aria-describedby="inputGroupFileAddon"
                      >
                        {document2Name.uniqueId != "" && (
                          <>
                            {" "}
                            <i className="FileIcon-img">
                              <FileIcon fileName={document2Name.uniqueId} />
                            </i>
                            <span>{document2Name.uniqueId}</span>
                            <i onClick={deletefiles2}>
                              <img
                                alt=""
                                class="mx-auto FileIcon-cross"
                                src={AttchCloseIcon}
                              ></img>
                            </i>{" "}
                          </>
                        )}
                      </label>
                      <div class="custom-file-input" onClick={() => HandleFileOpen("inputGroupFile2")}>
                        <input
                          type="file"
                          id="inputGroupFile2"
                          hidden
                          onChange={(e) =>
                            upload_document2(e, "uniqueId", "Submit")
                          }
                        />
                        <img
                          alt=""
                          class="attchement-icon mx-auto"
                          src={AttchementIcon}
                        ></img>
                      </div>
                    </div>
                  </div>
                ) : (
                  <input
                    type="text"
                    class="form-control input-style mt-2"
                    value={document2Name.fileUrl}
                    maxLength={255}
                    onChange={(e) =>
                      handleUrlTextchanges(e, "document2", "fileUrl", "Submit")
                    }
                  />
                )}
                <div className="toggle-btn-grp mt-2">
                  {toggleItems?.map((item, index) => (
                    <>
                      <input
                        type="radio"
                        className="btn-check"
                        name="options-outlined"
                        id={`toggleItem1${index}`}
                        value={item.value}
                        checked={document2selected == item.value}
                        autocomplete="off"
                        onClick={(e) => handleToggle1(e)}
                      />
                      <label
                        className={`btn toggle-btn mb-0 ${document2selected == item.value ? "toggle-active" : ""
                          }`}
                        for={`toggleItem1${index}`}
                      >
                        <img
                          alt=""
                          className="toggle-img"
                          src={
                            document2selected == item.value
                              ? item.name1
                              : item.name
                          }
                        />
                      </label>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${isSmallMobile ? "" : "mt-2"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-search-img"
                    src={SearchFileIcon}
                  />{" "}
                  <span className="pl-10 properties-search-span">
                    Document 3
                  </span>
                  &nbsp;
                </label>
                {document3selected == "1" ? (
                  <div class="input-group attach-style mt-2">
                    <div class="d-flex w-100">
                      <label
                        class={`file-label-style mb-2 ${document3Name.uniqueId != "" ? "file-select" : ""
                          }`}
                        aria-describedby="inputGroupFileAddon"
                      >
                        {document3Name.uniqueId != "" && (
                          <>
                            {" "}
                            <i className="FileIcon-img">
                              <FileIcon fileName={document3Name.uniqueId} />
                            </i>
                            <span>{document3Name.uniqueId}</span>
                            <i onClick={deletefiles3}>
                              <img
                                alt=""
                                class="mx-auto FileIcon-cross"
                                src={AttchCloseIcon}
                              ></img>
                            </i>{" "}
                          </>
                        )}
                      </label>
                      <div class="custom-file-input" onClick={() => HandleFileOpen("inputGroupFile3")}>
                        <input
                          type="file"
                          id="inputGroupFile3"
                          hidden
                          onChange={(e) =>
                            upload_document3(e, "uniqueId", "Submit")
                          }
                        />
                        <img
                          alt=""
                          class="attchement-icon mx-auto"
                          src={AttchementIcon}
                        ></img>
                      </div>
                    </div>
                  </div>
                ) : (
                  <input
                    type="text"
                    maxLength={255}
                    class="form-control input-style mt-2"
                    value={document3Name.fileUrl}
                    onChange={(e) =>
                      handleUrlTextchanges(e, "document3", "fileUrl", "Submit")
                    }
                  />
                )}
                <div className="toggle-btn-grp mt-2">
                  {toggleItems?.map((item, index) => (
                    <>
                      <input
                        type="radio"
                        className="btn-check"
                        name="options-outlined"
                        id={`toggleItem2${index}`}
                        value={item.value}
                        checked={document3selected == item.value}
                        autocomplete="off"
                        onClick={(e) => handleToggle2(e)}
                      />
                      <label
                        className={`btn toggle-btn mb-0 ${document3selected == item.value ? "toggle-active" : ""
                          }`}
                        for={`toggleItem2${index}`}
                      >
                        <img
                          alt=""
                          className="toggle-img"
                          src={
                            document3selected == item.value
                              ? item.name1
                              : item.name
                          }
                        />
                      </label>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${isSmallMobile ? "" : "mt-2"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-search-img"
                    src={SearchFileIcon}
                  />{" "}
                  <span className="pl-10 properties-search-span">
                    Document 4
                  </span>
                  &nbsp;
                </label>
                {document4selected == "1" ? (
                  <div class="input-group attach-style mt-2">
                    <div class="d-flex w-100">
                      <label
                        class={`file-label-style mb-2 ${document4Name.uniqueId != "" ? "file-select" : ""
                          }`}
                        aria-describedby="inputGroupFileAddon"
                      >
                        {document4Name.uniqueId != "" && (
                          <>
                            {" "}
                            <i className="FileIcon-img">
                              <FileIcon fileName={document4Name.uniqueId} />
                            </i>
                            <span>{document4Name.uniqueId}</span>
                            <i onClick={deletefiles4}>
                              <img
                                alt=""
                                class="mx-auto FileIcon-cross"
                                src={AttchCloseIcon}
                              ></img>
                            </i>{" "}
                          </>
                        )}
                      </label>
                      <div class="custom-file-input" onClick={() => HandleFileOpen("inputGroupFile4")}>
                        <input
                          type="file"
                          hidden
                          id="inputGroupFile4"
                          onChange={(e) =>
                            upload_document4(e, "uniqueId", "Submit")
                          }
                        />
                        <img
                          alt=""
                          class="attchement-icon mx-auto"
                          src={AttchementIcon}
                        ></img>
                      </div>
                    </div>
                  </div>
                ) : (
                  <input
                    type="text"
                    maxLength={255}
                    class="form-control input-style mt-2"
                    value={document4Name.fileUrl}
                    onChange={(e) =>
                      handleUrlTextchanges(e, "document4", "fileUrl", "Submit")
                    }
                  />
                )}
                <div className="toggle-btn-grp mt-2">
                  {toggleItems?.map((item, index) => (
                    <>
                      <input
                        type="radio"
                        className="btn-check"
                        name="options-outlined upload-document-class"
                        id={`toggleItem3${index}`}
                        value={item.value}
                        checked={document4selected == item.value}
                        autocomplete="off"
                        onClick={(e) => handleToggle3(e)}
                        required
                      />
                      <label
                        className={`btn toggle-btn mb-0 ${document4selected == item.value ? "toggle-active" : ""
                          }`}
                        for={`toggleItem3${index}`}
                      >
                        <img
                          alt=""
                          className="toggle-img"
                          src={
                            document4selected == item.value
                              ? item.name1
                              : item.name
                          }
                        />
                      </label>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${isSmallMobile ? "" : "mt-2"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-search-img"
                    src={SearchFileIcon}
                  />{" "}
                  <span className="pl-10 properties-search-span">
                    Document 5
                  </span>
                  &nbsp;
                </label>
                {document5selected == "1" ? (
                  <div class="input-group attach-style mt-2">
                    <div class="d-flex w-100">
                      <label
                        class={`file-label-style ${document5Name.uniqueId != "" ? "file-select" : ""
                          }`}
                        aria-describedby="inputGroupFileAddon"
                      >
                        {document5Name.uniqueId != "" && (
                          <>
                            {" "}
                            <i className="FileIcon-img">
                              <FileIcon fileName={document5Name.uniqueId} />
                            </i>
                            <span>{document5Name.uniqueId}</span>
                            <i onClick={deletefiles5}>
                              <img
                                alt=""
                                class="mx-auto FileIcon-cross"
                                src={AttchCloseIcon}
                              ></img>
                            </i>{" "}
                          </>
                        )}
                      </label>
                      <div class="custom-file-input" onClick={() => HandleFileOpen("inputGroupFile5")}>
                        <input
                          type="file"
                          id="inputGroupFile5"
                          hidden
                          onChange={(e) =>
                            upload_document5(e, "uniqueId", "Submit")
                          }
                        />
                        <img
                          alt=""
                          class="attchement-icon mx-auto"
                          src={AttchementIcon}
                        ></img>
                      </div>
                    </div>
                  </div>
                ) : (
                  <input
                    type="text"
                    maxLength={255}
                    class="form-control input-style mt-2"
                    value={document5Name.fileUrl}
                    onChange={(e) =>
                      handleUrlTextchanges(e, "document5", "fileUrl", "Submit")
                    }
                  />
                )}
                <div className="toggle-btn-grp mt-2">
                  {toggleItems?.map((item, index) => (
                    <>
                      <input
                        type="radio"
                        className="btn-check"
                        name="options-outlined"
                        id={`toggleItem4${index}`}
                        value={item.value}
                        checked={document5selected == item.value}
                        autocomplete="off"
                        onClick={(e) => handleToggle4(e)}
                      />
                      <label
                        className={`btn toggle-btn mb-0 ${document5selected == item.value ? "toggle-active" : ""
                          }`}
                        for={`toggleItem4${index}`}
                      >
                        <img
                          alt=""
                          className="toggle-img"
                          src={
                            document5selected == item.value
                              ? item.name1
                              : item.name
                          }
                        />
                      </label>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group"></div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={RemarkIcon} />{" "}
                  <span className="pl-10 properties-span">Comments</span>
                </label>
                <textarea
                  onChange={(e) => handleRemorkInputChange(e)}
                  value={pendingreasontext.remark}
                  className="form-control border-radius shiptype-select mt-2"
                  id="authorSendBack"
                  required
                  style={{
                    width: "100%",
                    height: "70px",
                    fontSize: "12px",
                    maxHeight: "70px",
                  }}
                />
              </div>
            </div>
          </div>
          <div className={`${isCancelMobile ? "col-12" : "d-flex"} mt-4`}>
            <button
              onClick={openAuthorSubmitSendBack}
              className={`btn btn-light input-group offcavasclose send-backbtn p-2`}
              id="displaybuttoncolor"
            >
              <img alt="" src={ButtonReworkIcon} className="modal-img"></img>
              <span className="send-rework-label pl-5">Send back</span>
            </button>
            <button
              onClick={uploadSubmitMessage}
              className={`btn btn-light input-group filter-nextbtn p-2 ml-2 ${isCancelMobile ? "mt-2" : "ml-10"
                } border border-3 border-red`}
            >
              <img alt="" src={ButtonSubmitIcon} className="modal-img"></img>
              <span style={{ marginTop: "2px" }} className="model-label pl-5">Submit</span>
            </button>
          </div>
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={VersionIcon} />{" "}
                  <span className="pl-10 properties-span">Versions</span>
                </label>
                <div className="table-responsive mb-4 mt-3">
                  <table id="versionTable" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Version
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Author
                        </th>
                        <th
                          className={`${isSmallMobile ? "Publisheddate-width" : ""
                            } no-wrap`}
                        >
                          Published date/time
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Checker
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Approver{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {versionLogList && versionLogList?.length !== 0 ? (
                        versionLogList?.map((i, index) => (
                          <tr id={index}>
                            <td className="no-wrap">{i.documentVersion}</td>
                            <td className="no-wrap">{i.authorName}</td>
                            <td className="no-wrap">
                              {i.publishedDate
                                ? Moment(
                                  new Date(Date.parse(i.publishedDate))
                                ).format("DD-MMM-YYYY h:mm A")
                                : ""}
                            </td>
                            <td className="no-wrap">{i.checkerName}</td>
                            <td className="no-wrap">{i.approverName}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="table-noversion" colSpan={5}>
                            No version history
                          </td>
                        </tr>
                      )}
                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={VersionIcon} />{" "}
                  <span className="pl-10 properties-span">History log</span>
                </label>
                <div className="table-responsive mb-4 mt-3">
                  <table id="historyTable" style={{ width: "100%" }}>
                    <tbody>
                      {historyLogList?.map((i, index) => (
                        <>
                          <tr id={index}>
                            <th className="title-width">{i.status}</th>
                            <td
                              className={`history-date ${isRadioMobile ? "date-width" : ""
                                }`}
                            >
                              {i.createdDate
                                ? Moment(
                                  new Date(Date.parse(i.createdDate))
                                ).format("DD-MMM-YYYY h:mm A")
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <th colSpan={2}>
                              {i.reviewer + " " + "(" + i.type + ")"}
                            </th>
                          </tr>
                          <tr>
                            <td colSpan={2} className="history-comment">
                              {i.comments}
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*Author Resubmit documents */}
      <div
        className="offcanvas offcanvas-end offcanvaspendingStyle"
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="AuthorReSubmissionScreen"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div
          className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}
        >
          <h6 id="offcanvasRightLabel" className="modal-title">
            Resubmit documents
          </h6>
          <button
            onClick={ClearDataList}
            className={`text-reset offcavasclose ${classes.button} ${isMobile ? "pr-0" : ""
              }`}
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            style={{ backgroundColor: "white" }}
          >
            <img
              alt=""
              src={CrossIcon}
              className="cursor-pointer app-image-hover"
            />
          </button>{" "}
        </div>
        <div className="offcanvas-body px-4 pt-0" id="viewbar2">
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Document no</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentNo}
                >
                  {dataDocumentNo}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={SearchFileIcon} />{" "}
                  <span className="pl-10 properties-span">Document name</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow fS ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentName}
                >
                  {dataDocumentName}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                  <span className="pl-10 properties-span">Author</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataAuthor?.label}
                >
                  {selectcommonfield.dataAuthor?.label
                    ? selectcommonfield.dataAuthor?.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Version</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataVersion}
                >
                  {dataVersion}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 1</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory1.label}
                >
                  {selectcommonfield.dataCategory1.label
                    ? selectcommonfield.dataCategory1.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 2</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory2.label}
                >
                  {selectcommonfield.dataCategory2.label
                    ? selectcommonfield.dataCategory2.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Registered date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataCreatedDate}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Expiry date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataExpiryDate}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={RemarkIcon} />{" "}
                  <span className="pl-10 properties-span">Notes</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataRemarks}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${isSmallMobile ? "" : "mt-2"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-search-img"
                    src={SearchFileIcon}
                  />{" "}
                  <span className="pl-10 properties-search-span">
                    Document 1
                  </span>
                  &nbsp;
                </label>
                {document1selected == "1" ? (
                  <div class="input-group attach-style mt-2">
                    <div class="d-flex w-100">
                      <label
                        class={`file-label-style mb-2 ${document1Name.uniqueId != "" ? "file-select" : ""
                          }`}
                        aria-describedby="inputGroupFileAddon"
                      >
                        {document1Name.uniqueId != "" && (
                          <>
                            {" "}
                            <i className="FileIcon-img">
                              <FileIcon fileName={document1Name.uniqueId} />
                            </i>
                            <span>{document1Name.uniqueId}</span>
                            <i onClick={deletefiles1}>
                              <img
                                alt=""
                                class="mx-auto FileIcon-cross"
                                src={AttchCloseIcon}
                              />
                            </i>{" "}
                          </>
                        )}
                      </label>
                      <div class="custom-file-input" onClick={() => HandleFileOpen("inputGroupFile1")}>
                        <input
                          type="file"
                          id="inputGroupFile1"
                          hidden
                          onChange={(e) =>
                            upload_document1(e, "uniqueId", "Resubmit")
                          }
                        />
                        <img
                          alt=""
                          class="attchement-icon mx-auto"
                          src={AttchementIcon}
                        ></img>
                      </div>
                    </div>
                  </div>
                ) : (
                  <input
                    type="text"
                    maxLength={255}
                    class="form-control input-style mt-2"
                    value={document1Name.fileUrl}
                    onChange={(e) =>
                      handleUrlTextchanges(
                        e,
                        "document1",
                        "fileUrl",
                        "Resubmit"
                      )
                    }
                  />
                )}

                <div className="toggle-btn-grp mt-2">
                  {toggleItems?.map((item, index) => (
                    <>
                      <input
                        type="radio"
                        className="btn-check"
                        name="options-outlined"
                        id={`toggleItem${index}`}
                        value={item.value}
                        checked={document1selected == item.value}
                        autocomplete="off"
                        onClick={(e) => handleToggle(e)}
                      />
                      <label
                        className={`btn toggle-btn mb-0 ${document1selected == item.value ? "toggle-active" : ""
                          }`}
                        for={`toggleItem${index}`}
                      >
                        <img
                          alt=""
                          className="toggle-img"
                          src={
                            document1selected == item.value
                              ? item.name1
                              : item.name
                          }
                        />
                      </label>
                    </>
                  ))}
                </div>
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${isSmallMobile ? "" : "mt-2"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-search-img"
                    src={SearchFileIcon}
                  />{" "}
                  <span className="pl-10 properties-search-span">
                    Document 2
                  </span>
                  &nbsp;
                </label>
                {document2selected == "1" ? (
                  <div class="input-group attach-style mt-2">
                    <div class="d-flex w-100">
                      <label
                        class={`file-label-style mb-2 ${document2Name.uniqueId != "" ? "file-select" : ""
                          }`}
                        aria-describedby="inputGroupFileAddon"
                      >
                        {document2Name.uniqueId != "" && (
                          <>
                            {" "}
                            <i className="FileIcon-img">
                              <FileIcon fileName={document2Name.uniqueId} />
                            </i>
                            <span>{document2Name.uniqueId}</span>
                            <i onClick={deletefiles2}>
                              <img
                                alt=""
                                class="mx-auto FileIcon-cross"
                                src={AttchCloseIcon}
                              ></img>
                            </i>{" "}
                          </>
                        )}
                      </label>
                      <div class="custom-file-input" onClick={() => HandleFileOpen("inputGroupFile2")}>
                        <input
                          type="file"
                          id="inputGroupFile2"
                          hidden
                          onChange={(e) =>
                            upload_document2(e, "uniqueId", "Resubmit")
                          }
                        />
                        <img
                          alt=""
                          class="attchement-icon mx-auto"
                          src={AttchementIcon}
                        ></img>
                      </div>
                    </div>
                  </div>
                ) : (
                  <input
                    type="text"
                    maxLength={255}
                    class="form-control input-style mt-2"
                    value={document2Name.fileUrl}
                    onChange={(e) =>
                      handleUrlTextchanges(
                        e,
                        "document2",
                        "fileUrl",
                        "Resubmit"
                      )
                    }
                  />
                )}
                <div className="toggle-btn-grp mt-2">
                  {toggleItems?.map((item, index) => (
                    <>
                      <input
                        type="radio"
                        className="btn-check"
                        name="options-outlined"
                        id={`toggleItem1${index}`}
                        value={item.value}
                        checked={document2selected == item.value}
                        autocomplete="off"
                        onClick={(e) => handleToggle1(e)}
                      />
                      <label
                        className={`btn toggle-btn mb-0 ${document2selected == item.value ? "toggle-active" : ""
                          }`}
                        for={`toggleItem1${index}`}
                      >
                        <img
                          alt=""
                          className="toggle-img"
                          src={
                            document2selected == item.value
                              ? item.name1
                              : item.name
                          }
                        />
                      </label>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${isSmallMobile ? "" : "mt-2"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-search-img"
                    src={SearchFileIcon}
                  />{" "}
                  <span className="pl-10 properties-search-span">
                    Document 3
                  </span>
                  &nbsp;
                </label>
                {document3selected == "1" ? (
                  <div class="input-group attach-style mt-2">
                    <div class="d-flex w-100">
                      <label
                        class={`file-label-style mb-2 ${document3Name.uniqueId != "" ? "file-select" : ""
                          }`}
                        aria-describedby="inputGroupFileAddon"
                      >
                        {document3Name.uniqueId != "" && (
                          <>
                            {" "}
                            <i className="FileIcon-img">
                              <FileIcon fileName={document3Name.uniqueId} />
                            </i>
                            <span>{document3Name.uniqueId}</span>
                            <i onClick={deletefiles3}>
                              <img
                                alt=""
                                class="mx-auto FileIcon-cross"
                                src={AttchCloseIcon}
                              ></img>
                            </i>{" "}
                          </>
                        )}
                      </label>
                      <div class="custom-file-input" onClick={() => HandleFileOpen("inputGroupFile3")}>
                        <input
                          type="file"
                          id="inputGroupFile3"
                          hidden
                          onChange={(e) =>
                            upload_document3(e, "uniqueId", "Resubmit")
                          }
                        />
                        <img
                          alt=""
                          class="attchement-icon mx-auto"
                          src={AttchementIcon}
                        ></img>
                      </div>
                    </div>
                  </div>
                ) : (
                  <input
                    type="text"
                    maxLength={255}
                    class="form-control input-style mt-2"
                    value={document3Name.fileUrl}
                    onChange={(e) =>
                      handleUrlTextchanges(
                        e,
                        "document3",
                        "fileUrl",
                        "Resubmit"
                      )
                    }
                  />
                )}
                <div className="toggle-btn-grp mt-2">
                  {toggleItems?.map((item, index) => (
                    <>
                      <input
                        type="radio"
                        className="btn-check"
                        name="options-outlined"
                        id={`toggleItem2${index}`}
                        value={item.value}
                        checked={document3selected == item.value}
                        autocomplete="off"
                        onClick={(e) => handleToggle2(e)}
                      />
                      <label
                        className={`btn toggle-btn mb-0 ${document3selected == item.value ? "toggle-active" : ""
                          }`}
                        for={`toggleItem2${index}`}
                      >
                        <img
                          alt=""
                          className="toggle-img"
                          src={
                            document3selected == item.value
                              ? item.name1
                              : item.name
                          }
                        />
                      </label>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${isSmallMobile ? "" : "mt-2"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-search-img"
                    src={SearchFileIcon}
                  />{" "}
                  <span className="pl-10 properties-search-span">
                    Document 4
                  </span>
                  &nbsp;
                </label>
                {document4selected == "1" ? (
                  <div class="input-group attach-style mt-2">
                    <div class="d-flex w-100">
                      <label
                        class={`file-label-style mb-2 ${document4Name.uniqueId != "" ? "file-select" : ""
                          }`}
                        aria-describedby="inputGroupFileAddon"
                      >
                        {document4Name.uniqueId != "" && (
                          <>
                            {" "}
                            <i className="FileIcon-img">
                              <FileIcon fileName={document4Name.uniqueId} />
                            </i>
                            <span>{document4Name.uniqueId}</span>
                            <i onClick={deletefiles4}>
                              <img
                                alt=""
                                class="mx-auto FileIcon-cross"
                                src={AttchCloseIcon}
                              ></img>
                            </i>{" "}
                          </>
                        )}
                      </label>
                      <div class="custom-file-input" onClick={() => HandleFileOpen("inputGroupFile4")}>
                        <input
                          type="file"
                          id="inputGroupFile4"
                          hidden
                          onChange={(e) =>
                            upload_document4(e, "uniqueId", "Resubmit")
                          }
                        />
                        <img
                          alt=""
                          class="attchement-icon mx-auto"
                          src={AttchementIcon}
                        ></img>
                      </div>
                    </div>
                  </div>
                ) : (
                  <input
                    type="text"
                    maxLength={255}
                    class="form-control input-style mt-2"
                    value={document4Name.fileUrl}
                    onChange={(e) =>
                      handleUrlTextchanges(
                        e,
                        "document4",
                        "fileUrl",
                        "Resubmit"
                      )
                    }
                  />
                )}
                <div className="toggle-btn-grp mt-2">
                  {toggleItems?.map((item, index) => (
                    <>
                      <input
                        type="radio"
                        className="btn-check"
                        name="options-outlined"
                        id={`toggleItem3${index}`}
                        value={item.value}
                        checked={document4selected == item.value}
                        autocomplete="off"
                        onClick={(e) => handleToggle3(e)}
                      />
                      <label
                        className={`btn toggle-btn mb-0 ${document4selected == item.value ? "toggle-active" : ""
                          }`}
                        for={`toggleItem3${index}`}
                      >
                        <img
                          alt=""
                          className="toggle-img"
                          src={
                            document4selected == item.value
                              ? item.name1
                              : item.name
                          }
                        />
                      </label>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mb-2 ${isSmallMobile ? "" : "mt-2"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-search-img"
                    src={SearchFileIcon}
                  />{" "}
                  <span className="pl-10 properties-search-span">
                    Document 5
                  </span>
                  &nbsp;
                </label>
                {document5selected == "1" ? (
                  <div class="input-group attach-style mt-2">
                    <div class="d-flex w-100">
                      <label
                        class={`file-label-style ${document5Name.uniqueId != "" ? "file-select" : ""
                          }`}
                        aria-describedby="inputGroupFileAddon"
                      >
                        {document5Name.uniqueId != "" && (
                          <>
                            {" "}
                            <i className="FileIcon-img">
                              <FileIcon fileName={document5Name.uniqueId} />
                            </i>
                            <span>{document5Name.uniqueId}</span>
                            <i onClick={deletefiles5}>
                              <img
                                alt=""
                                class="mx-auto FileIcon-cross"
                                src={AttchCloseIcon}
                              ></img>
                            </i>{" "}
                          </>
                        )}
                      </label>
                      <div class="custom-file-input" onClick={() => HandleFileOpen("inputGroupFile5")}>
                        <input
                          type="file"
                          id="inputGroupFile5"
                          hidden
                          onChange={(e) =>
                            upload_document5(e, "uniqueId", "Resubmit")
                          }
                        />
                        <img
                          alt=""
                          class="attchement-icon mx-auto"
                          src={AttchementIcon}
                        ></img>
                      </div>
                    </div>
                  </div>
                ) : (
                  <input
                    type="text"
                    maxLength={255}
                    class="form-control input-style mt-2"
                    value={document5Name.fileUrl}
                    onChange={(e) =>
                      handleUrlTextchanges(
                        e,
                        "document5",
                        "fileUrl",
                        "Resubmit"
                      )
                    }
                  />
                )}
                <div className="toggle-btn-grp mt-2">
                  {toggleItems?.map((item, index) => (
                    <>
                      <input
                        type="radio"
                        className="btn-check"
                        name="options-outlined"
                        id={`toggleItem4${index}`}
                        value={item.value}
                        checked={document5selected == item.value}
                        autocomplete="off"
                        onClick={(e) => handleToggle4(e)}
                      />
                      <label
                        className={`btn toggle-btn mb-0 ${document5selected == item.value ? "toggle-active" : ""
                          }`}
                        for={`toggleItem4${index}`}
                      >
                        <img
                          alt=""
                          className="toggle-img"
                          src={
                            document5selected == item.value
                              ? item.name1
                              : item.name
                          }
                        />
                      </label>
                    </>
                  ))}
                </div>
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group"></div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={RemarkIcon} />{" "}
                  <span className="pl-10 properties-span">Comments</span>
                </label>
                <textarea
                  onChange={(e) => handleRemorkInputChange(e)}
                  value={pendingreasontext.remark}
                  className="form-control border-radius shiptype-select mt-2"
                  id="AuthorResubmit"
                  style={{
                    width: "100%",
                    height: "70px",
                    fontSize: "12px",
                    maxHeight: "70px",
                  }}
                />
              </div>
            </div>
          </div>
          <div className={`${isCancelMobile ? "col-12" : "d-flex"} mt-4`}>
            <button
              onClick={openAuthorResubmitSendBack}
              className={`btn btn-light input-group offcavasclose send-backbtn p-2`}
              id="displaybuttoncolor"
            >
              <img alt="" src={ButtonReworkIcon} className="modal-img"></img>
              <span className="send-rework-label pl-5">Send back</span>
            </button>
            <button
              onClick={uploadReSubmitMessage}
              className={`btn btn-light input-group filter-nextbtn p-2 ml-2 ${isCancelMobile ? "mt-2" : "ml-10"
                }`} id="pending-resubmit-btn"
            // style={{width:"130px !important"}}
            >
              <img alt="" src={ButtonSubmitIcon} className="modal-img"></img>
              <span style={{ marginTop: "1px" }} className="model-label pl-5">Resubmit</span>
            </button>
          </div>
          <div className="row mt-2">
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={VersionIcon} />{" "}
                  <span className="pl-10 properties-span">History log</span>
                </label>
                <div className="table-responsive mb-4 mt-3">
                  <table id="historyTable" style={{ width: "100%" }}>
                    <tbody>
                      {historyLogList?.map((i, index) => (
                        <>
                          <tr id={index}>
                            <th className="title-width">{i.status}</th>
                            <td
                              className={`history-date ${isRadioMobile ? "date-width" : ""
                                }`}
                            >
                              {i.createdDate
                                ? Moment(
                                  new Date(Date.parse(i.createdDate))
                                ).format("DD-MMM-YYYY h:mm A")
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <th colSpan={2}>
                              {i.reviewer + " " + "(" + i.type + ")"}
                            </th>
                          </tr>
                          <tr>
                            <td colSpan={2} className="history-comment">
                              {i.comments}
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* admin side panle */}
      <div
        className="offcanvas offcanvas-end offcanvaspendingStyle"
        tabIndex={-1}
        data-bs-backdrop="false"
        data-bs-scroll="false"
        id="pendingAdminScreen"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div
          className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}
        >
          <h6 id="offcanvasRightLabel" className="modal-title">
            {dataDocumentNo}
          </h6>
          <button
            onClick={ClearDataList}
            className={`text-reset offcavasclose ${classes.button} ${isMobile ? "pr-0" : ""
              }`}
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            style={{ backgroundColor: "white" }}
          >
            <img
              alt=""
              src={CrossIcon}
              className="cursor-pointer app-image-hover"
            />
          </button>{" "}
        </div>

        <div className="offcanvas-body px-4 pt-0" id="viewbar3">
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Document no</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentNo}
                >
                  {dataDocumentNo}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={SearchFileIcon} />{" "}
                  <span className="pl-10 properties-span">Document name</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow fS ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentName}
                >
                  {dataDocumentName ? dataDocumentName : " - "}
                </label>
              </div>
            </div>
            {reviewerdocumentStatus.toLowerCase() === "pending for reassign" ? (
              <></>
            ) : (
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                  } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                    <span className="pl-10 properties-span">Author</span>
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    title={selectcommonfield.dataAuthor?.label}
                  >
                    {selectcommonfield.dataAuthor?.label
                      ? selectcommonfield.dataAuthor?.label
                      : " - "}
                  </label>
                </div>
              </div>
            )}
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Version</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataVersion}
                >
                  {dataVersion ? dataVersion : " - "}
                </label>
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 1</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory1.label}
                >
                  {selectcommonfield.dataCategory1.label
                    ? selectcommonfield.dataCategory1.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 2</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory2.label}
                >
                  {selectcommonfield.dataCategory2.label
                    ? selectcommonfield.dataCategory2.label
                    : " - "}
                </label>
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Published date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataPublishedDate ? dataPublishedDate : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Expiry date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataExpiryDate ? dataExpiryDate : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={NotesIcon} />{" "}
                  <span className="pl-10 properties-span">Notes</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataRemarks ? dataRemarks : " - "}
                </label>
              </div>
            </div>
          </div>

          {userRole === role.ADMIN &&
            reviewerdocumentStatus?.toLowerCase() === "pending for reassign" ? (
            <>
              {isInActiveUser === false ? (
                <div className="row">
                  {approvalStatus?.toLowerCase() === "pending with admin" &&
                    reviewerRole === "admin" ? (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="a">
                        <div className="inputTitle mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>
                            {" "}
                            Admin&nbsp;
                            <span style={{ color: "#ee192d" }}>*</span>
                          </span>
                        </div>
                        <div
                          className={`${adminError === true ? "border-red" : ""
                            }`}
                        >
                          <Select
                            className={`text-12-normal`}
                            classNamePrefix="assigngroups"
                            value={reviewerinputData.reviewer}
                            options={adminreviewersList}
                            defaultValue={
                              reviewerinputData.reviewer || "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                            onChange={(value) =>
                              handleReviewerSelectChange(value, "reviewer")
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span> Admin</span>
                      </div>

                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={reviewerinputData.adminName}
                        isDisabled={true}
                        options={adminreviewersList}
                        defaultValue={reviewerinputData.reviewer || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  )}
                  {approvalStatus?.toLowerCase() === "pending with author" &&
                    reviewerRole === "author" ? (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>
                          {" "}
                          Author&nbsp;
                          <span style={{ color: "#ee192d" }}>*</span>
                        </span>
                      </div>
                      <div
                        className={`${authorError === true ? "border-red" : ""
                          }`}
                      >
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={reviewerinputData.reviewer}
                          options={adminreviewersList}
                          defaultValue={reviewerinputData.reviewer || "Select"}
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleReviewerSelectChange(value, "reviewer")
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span> Author</span>
                      </div>
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={reviewerinputData.authorName}
                        options={adminreviewersList}
                        isDisabled={true}
                        defaultValue={reviewerinputData.authorName || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  )}
                  {approvalStatus?.toLowerCase() === "pending with checker" &&
                    reviewerRole === "checker1" ? (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>
                          Checker 1 &nbsp;
                          <span style={{ color: "#ee192d" }}>*</span>
                        </span>
                      </div>
                      <div
                        className={`${checker1Error === true ? "border-red" : ""
                          }`}
                      >
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={reviewerinputData.reviewer}
                          options={newreviewersList}
                          defaultValue={reviewerinputData.reviewer || "Select"}
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleReviewerSelectChange(value, "reviewer")
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>Checker 1</span>
                      </div>
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={reviewerinputData.checker1Name}
                        options={newreviewersList}
                        isDisabled={true}
                        defaultValue={
                          reviewerinputData.checker1Name || "Select"
                        }
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  )}

                  {approvalStatus?.toLowerCase() === "pending with checker" &&
                    reviewerRole === "checker2" ? (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>
                          Checker 2 &nbsp;
                          <span style={{ color: "#ee192d" }}>*</span>
                        </span>
                      </div>
                      <div
                        className={`${checker2Error === true ? "border-red" : ""
                          }`}
                      >
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={reviewerinputData.reviewer}
                          options={newreviewersList}
                          defaultValue={reviewerinputData.reviewer || "Select"}
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleReviewerSelectChange(value, "reviewer")
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>Checker 2</span>
                      </div>
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={reviewerinputData.checker2Name}
                        options={newreviewersList}
                        isDisabled={true}
                        defaultValue={
                          reviewerinputData.checker2Name || "Select"
                        }
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  )}
                  {approvalStatus?.toLowerCase() ===
                    "pending with consultant" &&
                    reviewerRole === "consultant1" ? (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>
                          Consultant 1 &nbsp;
                          <span style={{ color: "#ee192d" }}>*</span>
                        </span>
                      </div>
                      <div
                        className={`${consultant1Error === true ? "border-red" : ""
                          }`}
                      >
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={reviewerinputData.reviewer}
                          options={newreviewersList}
                          defaultValue={reviewerinputData.reviewer || "Select"}
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleReviewerSelectChange(value, "reviewer")
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>Consultant 1</span>
                      </div>
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={reviewerinputData.consultant1Name}
                        options={newreviewersList}
                        isDisabled={true}
                        defaultValue={
                          reviewerinputData.consultant1Name || "Select"
                        }
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  )}
                  {approvalStatus?.toLowerCase() ===
                    "pending with consultant" &&
                    reviewerRole === "consultant2" ? (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>
                          Consultant 2 &nbsp;
                          <span style={{ color: "#ee192d" }}>*</span>
                        </span>
                      </div>
                      <div
                        className={`${consultant2Error === true ? "border-red" : ""
                          }`}
                      >
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={reviewerinputData.reviewer}
                          options={newreviewersList}
                          defaultValue={reviewerinputData.reviewer || "Select"}
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleReviewerSelectChange(value, "reviewer")
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>Consultant 2</span>
                      </div>
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={reviewerinputData.consultant2Name}
                        options={newreviewersList}
                        isDisabled={true}
                        defaultValue={
                          reviewerinputData.consultant2Name || "Select"
                        }
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  )}
                  {approvalStatus?.toLowerCase() === "pending with approver" &&
                    reviewerRole === "approver1" ? (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>
                          Approver 1 &nbsp;
                          <span style={{ color: "#ee192d" }}>*</span>
                        </span>
                      </div>
                      <div
                        className={`${approver1Error === true ? "border-red" : ""
                          }`}
                      >
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={reviewerinputData.reviewer}
                          options={newreviewersList}
                          defaultValue={reviewerinputData.reviewer || "Select"}
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleReviewerSelectChange(value, "reviewer")
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>Approver 1</span>
                      </div>

                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={reviewerinputData.approver1Name}
                        options={newreviewersList}
                        isDisabled={true}
                        defaultValue={
                          reviewerinputData.approver1Name || "Select"
                        }
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  )}
                  {approvalStatus?.toLowerCase() === "pending with approver" &&
                    reviewerRole === "approver2" ? (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>
                          Approver 2 &nbsp;
                          <span style={{ color: "#ee192d" }}>*</span>
                        </span>
                      </div>
                      <div
                        className={`${approver2Error === true ? "border-red" : ""
                          }`}
                      >
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={reviewerinputData.reviewer}
                          options={newreviewersList}
                          defaultValue={reviewerinputData.reviewer || "Select"}
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleReviewerSelectChange(value, "reviewer")
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>Approver 2 </span>
                      </div>

                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={reviewerinputData.approver2Name}
                        options={newreviewersList}
                        isDisabled={true}
                        defaultValue={
                          reviewerinputData.approver2Name || "Select"
                        }
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  )}
                  {approvalStatus?.toLowerCase() === "pending with approver" ||
                    approvalStatus?.toLowerCase() === "pending with consultant" ||
                    approvalStatus?.toLowerCase() === "pending with checker" ||
                    approvalStatus?.toLowerCase() === "pending with author" ||
                    approvalStatus?.toLowerCase() === "pending with admin" ? (
                    <div
                      className={`${isCancelMobile ? "col-12" : "d-flex"} mt-4`}
                    >
                      <button
                        className={`btn btn-light input-group offcavasclose filter-reworkbtn p-2`}
                        onClick={CancelrequestAgain}
                      >
                        <img
                          src={ButtonCancelRequestIcon}
                          className="modal-img"
                        ></img>
                        <span className="send-rework-label pl-5">
                          Cancel request
                        </span>
                      </button>

                      <button
                        className={`btn btn-light input-group offcavasclose filter-nextbtn p-2 ml-2 ${isCancelMobile ? "mt-2" : "ml-10"
                          }`}
                        onClick={ReviewerSubmitRequest}
                      >
                        <img src={ButtonSubmitIcon} className="modal-img"></img>
                        <span style={{ marginTop: "3px" }} className="model-label pl-5">Submit</span>
                      </button>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div className="row">
                  {approvalStatus?.toLowerCase() === "pending with admin" &&
                    reviewerRole === "admin" ? (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>
                          {" "}
                          Admin&nbsp;<span style={{ color: "#ee192d" }}>*</span>
                        </span>
                      </div>
                      <div
                        className={`${adminError === true ? "border-red" : ""}`}
                      >
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.reviewer1}
                          options={inactiveadminreviewersList}
                          defaultValue={
                            inactivereviewerinputData.reviewer1 || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleInactiveReviewerSelectChange(
                              value,
                              "reviewer1"
                            )
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span> Admin</span>
                      </div>
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={inactivereviewerinputData.adminName}
                        options={inactiveadminreviewersList}
                        isDisabled={true}
                        defaultValue={
                          inactivereviewerinputData.adminName || "Select"
                        }
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  )}
                  {approvalStatus?.toLowerCase() === "pending with author" &&
                    reviewerRole === "author" ? (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span>
                          {" "}
                          Author&nbsp;
                          <span style={{ color: "#ee192d" }}>*</span>
                        </span>
                      </div>
                      <div
                        className={`${authorError === true ? "border-red" : ""
                          }`}
                      >
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.reviewer1}
                          options={inactiveAuthorList}
                          defaultValue={
                            inactivereviewerinputData.reviewer1 || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleInactiveReviewerSelectChange(
                              value,
                              "reviewer1"
                            )
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <div className={`col-sm-6 col-12 mt-1`}>
                      <div className="inputTitle  mb-2">
                        <img src={NewroleIcon} alt="" />
                        <span> Author</span>
                      </div>
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={inactivereviewerinputData.authorName}
                        options={inactiveAuthorList}
                        isDisabled={true}
                        defaultValue={
                          inactivereviewerinputData.authorName || "Select"
                        }
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  )}
                  {approvalStatus.toLowerCase() === "pending with checker" &&
                    isSecondReviewer === false ? (
                    <>
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle  mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>
                            Checker 1 &nbsp;
                            <span style={{ color: "#ee192d" }}>*</span>
                          </span>
                        </div>
                        <div
                          className={`${checker1Error === true ? "border-red" : ""
                            }`}
                        >
                          <Select
                            className={`text-12-normal`}
                            classNamePrefix="assigngroups"
                            value={inactivereviewerinputData.reviewer1}
                            options={inactiveChecker1ArrayList}
                            defaultValue={
                              inactivereviewerinputData.reviewer1 || "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                            onChange={(value) =>
                              handleInactiveReviewerSelectChange(
                                value,
                                "reviewer1"
                              )
                            }
                          />
                        </div>
                      </div>

                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle  mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Checker 2</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.reviewer2}
                          options={inactiveChecker2ArrayList}
                          defaultValue={
                            inactivereviewerinputData.reviewer2 || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleInactiveReviewerSelectChange(
                              value,
                              "reviewer2"
                            )
                          }
                        />
                      </div>
                    </>
                  ) : isSecondReviewer === true &&
                    reviewerRole === "checker1" ? (
                    approvalStatus?.toLowerCase() === "pending with checker" &&
                      reviewerRole === "checker1" ? (
                      <>
                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle  mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>
                              Checker 1 &nbsp;
                              <span style={{ color: "#ee192d" }}>*</span>
                            </span>
                          </div>
                          <div
                            className={`${checker1Error === true ? "border-red" : ""
                              }`}
                          >
                            <Select
                              className={`text-12-normal`}
                              classNamePrefix="assigngroups"
                              value={inactivereviewerinputData.reviewer1}
                              options={inactiveChecker1ArrayList}
                              defaultValue={
                                inactivereviewerinputData.reviewer1 || "Select"
                              }
                              isMulti={false}
                              isSearchable={true}
                              isClearable={true}
                            />
                          </div>
                        </div>

                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle  mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>Checker 2</span>
                          </div>
                          <Select
                            className={`text-12-normal`}
                            classNamePrefix="assigngroups"
                            value={inactivereviewerinputData.checker2Name}
                            options={inactiveChecker2ArrayList}
                            isDisabled={true}
                            defaultValue={
                              inactivereviewerinputData.checker2Name || "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                          />
                        </div>
                      </>
                    ) : (
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle  mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Checker 1</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.checker1Name}
                          options={inactiveChecker1ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.checker1Name || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                    )
                  ) : isSecondReviewer === true &&
                    reviewerRole === "checker2" ? (
                    approvalStatus?.toLowerCase() === "pending with checker" &&
                      reviewerRole === "checker2" ? (
                      <>
                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle  mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>Checker 1</span>
                          </div>
                          <Select
                            className={`text-12-normal`}
                            classNamePrefix="assigngroups"
                            value={inactivereviewerinputData.checker1Name}
                            options={inactiveChecker1ArrayList}
                            isDisabled={true}
                            defaultValue={
                              inactivereviewerinputData.checker1Name || "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                          />
                        </div>

                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle  mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>
                              Checker 2 &nbsp;
                              <span style={{ color: "#ee192d" }}>*</span>
                            </span>
                          </div>
                          <div
                            className={`${checker2Error === true ? "border-red" : ""
                              }`}
                          >
                            <Select
                              className={`text-12-normal`}
                              classNamePrefix="assigngroups"
                              value={inactivereviewerinputData.reviewer1}
                              options={inactiveChecker2ArrayList}
                              defaultValue={
                                inactivereviewerinputData.reviewer1 || "Select"
                              }
                              isMulti={false}
                              isSearchable={true}
                              isClearable={true}
                              onChange={(value) =>
                                handleInactiveReviewerSelectChange(
                                  value,
                                  "reviewer1"
                                )
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle  mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Checker 2</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.checker2Name}
                          options={inactiveChecker2ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.checker2Name || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                    )
                  ) : (
                    <>
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle  mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Checker 1</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.checker1Name}
                          options={inactiveChecker1ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.checker1Name || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle  mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Checker 2</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.checker2Name}
                          options={inactiveChecker2ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.checker2Name || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                    </>
                  )}

                  {approvalStatus?.toLowerCase() ===
                    "pending with consultant" && isSecondReviewer === false ? (
                    <>
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle  mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>
                            Consultant 1 &nbsp;
                            <span style={{ color: "#ee192d" }}>*</span>
                          </span>
                        </div>
                        <div
                          className={`${consultant1Error === true ? "border-red" : ""
                            }`}
                        >
                          <Select
                            className={`text-12-normal`}
                            classNamePrefix="assigngroups"
                            value={inactivereviewerinputData.reviewer1}
                            options={inactiveConsultant1ArrayList}
                            defaultValue={
                              inactivereviewerinputData.reviewer1 || "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                            onChange={(value) =>
                              handleInactiveReviewerSelectChange(
                                value,
                                "reviewer1"
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle  mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Consultant 2</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.reviewer2}
                          options={inactiveConsultant2ArrayList}
                          defaultValue={
                            inactivereviewerinputData.reviewer2 || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleInactiveReviewerSelectChange(
                              value,
                              "reviewer2"
                            )
                          }
                        />
                      </div>
                    </>
                  ) : isSecondReviewer === true &&
                    reviewerRole === "consultant1" ? (
                    approvalStatus?.toLowerCase() ===
                      "pending with consultant" &&
                      reviewerRole === "consultant1" ? (
                      <>
                        {" "}
                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle  mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>
                              Consultant 1 &nbsp;
                              <span style={{ color: "#ee192d" }}>*</span>
                            </span>
                          </div>
                          <div
                            className={`${consultant1Error === true ? "border-red" : ""
                              }`}
                          >
                            <Select
                              className={`text-12-normal`}
                              classNamePrefix="assigngroups"
                              value={inactivereviewerinputData.reviewer1}
                              options={inactiveConsultant1ArrayList}
                              defaultValue={
                                inactivereviewerinputData.reviewer1 || "Select"
                              }
                              isMulti={false}
                              isSearchable={true}
                              isClearable={true}
                              onChange={(value) =>
                                handleInactiveReviewerSelectChange(
                                  value,
                                  "reviewer1"
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle  mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>Consultant 2</span>
                          </div>
                          <Select
                            className={`text-12-normal`}
                            classNamePrefix="assigngroups"
                            value={inactivereviewerinputData.consultant2Name}
                            options={inactiveConsultant2ArrayList}
                            isDisabled={true}
                            defaultValue={
                              inactivereviewerinputData.consultant2Name ||
                              "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                          />
                        </div>
                      </>
                    ) : (
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Consultant 1</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.consultant1Name}
                          options={inactiveConsultant1ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.consultant1Name ||
                            "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                    )
                  ) : isSecondReviewer === true &&
                    reviewerRole === "consultant2" ? (
                    approvalStatus?.toLowerCase() ===
                      "pending with consultant" &&
                      reviewerRole === "consultant2" ? (
                      <>
                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>Consultant 1</span>
                          </div>
                          <Select
                            className={`text-12-normal`}
                            classNamePrefix="assigngroups"
                            value={inactivereviewerinputData.consultant1Name}
                            options={inactiveConsultant1ArrayList}
                            isDisabled={true}
                            defaultValue={
                              inactivereviewerinputData.consultant1Name ||
                              "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                          />
                        </div>
                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>
                              Consultant 2 &nbsp;
                              <span style={{ color: "#ee192d" }}>*</span>
                            </span>
                          </div>
                          <div
                            className={`${consultant2Error === true ? "border-red" : ""
                              }`}
                          >
                            <Select
                              className={`text-12-normal`}
                              classNamePrefix="assigngroups"
                              value={inactivereviewerinputData.reviewer1}
                              options={inactiveConsultant2ArrayList}
                              defaultValue={
                                inactivereviewerinputData.reviewer1 || "Select"
                              }
                              isMulti={false}
                              isSearchable={true}
                              isClearable={true}
                              onChange={(value) =>
                                handleInactiveReviewerSelectChange(
                                  value,
                                  "reviewer1"
                                )
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Consultant 2</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.consultant2Name}
                          options={inactiveConsultant2ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.consultant2Name ||
                            "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                    )
                  ) : (
                    <>
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Consultant 1</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.consultant1Name}
                          options={inactiveConsultant1ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.consultant1Name ||
                            "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Consultant 2</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.consultant2Name}
                          options={inactiveConsultant2ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.consultant2Name ||
                            "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                    </>
                  )}

                  {approvalStatus?.toLowerCase() === "pending with approver" &&
                    isSecondReviewer === false ? (
                    <>
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>
                            Approver 1 &nbsp;
                            <span style={{ color: "#ee192d" }}>*</span>
                          </span>
                        </div>
                        <div
                          className={`${approver1Error === true ? "border-red" : ""
                            }`}
                        >
                          <Select
                            className={`text-12-normal`}
                            classNamePrefix="assigngroups"
                            value={inactivereviewerinputData.reviewer1}
                            options={inactiveApprover1ArrayList}
                            defaultValue={
                              inactivereviewerinputData.reviewer1 || "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                            onChange={(value) =>
                              handleInactiveReviewerSelectChange(
                                value,
                                "reviewer1"
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Approver 2 </span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.reviewer2}
                          options={inactiveApprover2ArrayList}
                          defaultValue={
                            inactivereviewerinputData.reviewer2 || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          onChange={(value) =>
                            handleInactiveReviewerSelectChange(
                              value,
                              "reviewer2"
                            )
                          }
                        />
                      </div>
                    </>
                  ) : isSecondReviewer === true &&
                    reviewerRole === "approver1" ? (
                    approvalStatus?.toLowerCase() === "pending with approver" &&
                      reviewerRole === "approver1" ? (
                      <>
                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>
                              Approver 1 &nbsp;
                              <span style={{ color: "#ee192d" }}>*</span>
                            </span>
                          </div>
                          <div
                            className={`${approver1Error === true ? "border-red" : ""
                              }`}
                          >
                            <Select
                              className={`text-12-normal`}
                              classNamePrefix="assigngroups"
                              value={inactivereviewerinputData.reviewer1}
                              options={inactiveApprover1ArrayList}
                              defaultValue={
                                inactivereviewerinputData.reviewer1 || "Select"
                              }
                              isMulti={false}
                              isSearchable={true}
                              isClearable={true}
                              onChange={(value) =>
                                handleInactiveReviewerSelectChange(
                                  value,
                                  "reviewer1"
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>Approver 2 </span>
                          </div>
                          <Select
                            className={`text-12-normal`}
                            classNamePrefix="assigngroups"
                            value={inactivereviewerinputData.approver2Name}
                            options={inactiveApprover2ArrayList}
                            isDisabled={true}
                            defaultValue={
                              inactivereviewerinputData.approver2Name ||
                              "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                          />
                        </div>
                      </>
                    ) : (
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Approver 1</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.approver1Name}
                          options={inactiveApprover1ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.approver1Name || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                    )
                  ) : reviewerRole === "approver2" &&
                    isSecondReviewer === true ? (
                    approvalStatus?.toLowerCase() === "pending with approver" &&
                      reviewerRole === "approver2" ? (
                      <>
                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>Approver 1</span>
                          </div>
                          <Select
                            className={`text-12-normal`}
                            classNamePrefix="assigngroups"
                            value={inactivereviewerinputData.approver1Name}
                            options={inactiveApprover1ArrayList}
                            isDisabled={true}
                            defaultValue={
                              inactivereviewerinputData.approver1Name ||
                              "Select"
                            }
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                          />
                        </div>
                        <div className={`col-sm-6 col-12 mt-1`}>
                          <div className="inputTitle mb-2">
                            <img src={NewroleIcon} alt="" />
                            <span>
                              Approver 2 &nbsp;
                              <span style={{ color: "#ee192d" }}>*</span>
                            </span>
                          </div>
                          <div
                            className={`${approver2Error === true ? "border-red" : ""
                              }`}
                          >
                            <Select
                              className={`text-12-normal`}
                              classNamePrefix="assigngroups"
                              value={inactivereviewerinputData.reviewer1}
                              options={inactiveApprover2ArrayList}
                              defaultValue={
                                inactivereviewerinputData.reviewer1 || "Select"
                              }
                              isMulti={false}
                              isSearchable={true}
                              isClearable={true}
                              onChange={(value) =>
                                handleInactiveReviewerSelectChange(
                                  value,
                                  "reviewer1"
                                )
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Approver 2 </span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.approver2Name}
                          options={inactiveApprover2ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.approver2Name || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                    )
                  ) : (
                    <>
                      {" "}
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Approver 1</span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.approver1Name}
                          options={inactiveApprover1ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.approver1Name || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                      <div className={`col-sm-6 col-12 mt-1`}>
                        <div className="inputTitle  mb-2">
                          <img src={NewroleIcon} alt="" />
                          <span>Approver 2 </span>
                        </div>
                        <Select
                          className={`text-12-normal`}
                          classNamePrefix="assigngroups"
                          value={inactivereviewerinputData.approver2Name}
                          options={inactiveApprover2ArrayList}
                          isDisabled={true}
                          defaultValue={
                            inactivereviewerinputData.approver2Name || "Select"
                          }
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div>
                    </>
                  )}
                  {approvalStatus?.toLowerCase() === "pending with approver" ||
                    approvalStatus?.toLowerCase() === "pending with consultant" ||
                    approvalStatus?.toLowerCase() === "pending with checker" ||
                    approvalStatus?.toLowerCase() === "pending with author" ||
                    approvalStatus?.toLowerCase() === "pending with admin" ? (
                    <div
                      className={`${isCancelMobile ? "col-12" : "d-flex"} mt-4`}
                    >
                      <button
                        className={`btn btn-light input-group offcavasclose filter-reworkbtn p-2`}
                        onClick={CancelrequestAgainInactive}
                      >
                        <img
                          src={ButtonCancelRequestIcon}
                          className="modal-img"
                        ></img>
                        <span className="send-rework-label pl-5">
                          Cancel request
                        </span>
                      </button>

                      <button
                        className={`btn btn-light input-group offcavasclose filter-nextbtn p-2 ml-2 ${isCancelMobile ? "mt-2" : "ml-10"
                          }`}
                        onClick={InactiveReviewerSubmitRequest}
                      >
                        <img src={ButtonSubmitIcon} className="modal-img"></img>
                        <span style={{ marginTop: "3px" }} className="model-label pl-5">Submit</span>
                      </button>
                    </div>
                  ) : null}
                </div>
              )}
            </>
          ) : null}

          {dataAssignedFor === "Renew InProgress" ? (
            ""
          ) : (
            <>
              <div
                className={`row mt-1 ${isRadioMobile ? "d-flex" : ""}`}
                style={{ marginRight: "20px" }}
              >
                <div
                  className={`${iswebMobile ? "col-12" : "col-4"
                    } col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3 px-2 ${isMobile ? "mt-3" : "mt-2"
                    }`}
                >
                  {dataAssignedFor === "Renew Pending" && (
                    <button
                      onClick={GetDocumentFormat}
                      className={`btn btn-light input-group ${isRadioMobile
                          ? "col-4 bg-danger btnflex"
                          : "filter-archivekbtn"
                        } p-2`}
                    >
                      <img alt="" src={RenewIcon} className="modal-img"></img>
                      <span className="model-label pl-5">Renew</span>
                    </button>
                  )}
                  {(dataAssignedFor === "Resubmission" ||
                    dataAssignedFor === "Submission") && (
                      <button
                        className={`btn btn-light input-group filter-archivekbtn p-2 `}
                        onClick={handleOpenSubmitScreen}
                      >
                        <img
                          alt=""
                          src={ButtonSubmitIcon}
                          className="modal-img"
                        ></img>
                        <span className="model-label pl-5">Resubmit</span>
                      </button>
                    )}
                </div>
                {documentStatus === "Expired" && (
                  <>
                    <div
                      className={`${isRadioMobile ? "col-4" : " col-4"} ${iswebMobile ? "col-12" : "col-4"
                        } col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3 px-2 ${isMobile ? "mt-3" : "mt-2"
                        }`}
                    >
                      <button
                        className={`btn btn-light input-group ${isRadioMobile
                            ? "col-4 bg-danger btnflex"
                            : "filter-archivekbtn"
                          } p-2`}
                        onClick={handleOpenArchieveScreen}
                      >
                        <img
                          alt=""
                          src={ArchiveIcon}
                          className="modal-img"
                        ></img>
                        <span className="model-label pl-5">Archive</span>
                      </button>
                    </div>
                    <div
                      className={`${iswebMobile ? "col-12" : "col-4"
                        } col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3 px-2 ${isMobile ? "mt-3" : "mt-2"
                        }`}
                    >
                      <button
                        className={`btn btn-light input-group ${isRadioMobile
                            ? "col-4 bg-danger btnflex"
                            : "filter-archivekbtn"
                          } p-2`}
                        onClick={handleOpenObsoleteScreen}
                      >
                        <img
                          alt=""
                          src={obsoleteIcon}
                          className="modal-img"
                        ></img>
                        <span className="model-label pl-5">Obsolete</span>
                      </button>
                    </div>
                  </>
                )}
              </div>
            </>
          )}
          {/* Buttons for admin as checker/consultant/approver */}
          {dataAssignedFor === "Approval" && (
            <div className="row mb-2">
              <div
                className={`col-12 ${iswebMobile
                    ? "mt-3 d-flex flex-column gap-1"
                    : "d-flex gap-1 mt-3"
                  }`}
              >
                <button
                  className={`btn btn-light input-group offcavasclose filter-reworkbtn p-2`}
                  onClick={() => openCheckerSendBack()}
                >
                  <img alt="" src={ButtonReworkIcon} className="modal-img"></img>
                  <span className="send-rework-label pl-5">Send for rework</span>
                </button>
                <button
                  className={`btn btn-light input-group offcavasclose filter-nextbtn2 p-2`}
                  onClick={() => UpdateApprovePendingtask()}
                >
                  <img alt="" src={ButtonApproveIcon} className="modal-img"></img>
                  <span style={{ marginTop: "3px" }} className="model-label pl-5">Approve</span>
                </button>
              </div>
            </div>
          )}
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={VersionIcon} />{" "}
                  <span className="pl-10 properties-span">Versions</span>
                </label>
                <div className="table-responsive mb-4 mt-3">
                  <table id="versionTable" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Version
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Author
                        </th>
                        <th
                          className={`${isSmallMobile ? "Publisheddate-width" : ""
                            } no-wrap`}
                        >
                          Published date/time
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Checker
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Approver{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {versionLogList && versionLogList?.length > 0 ? (
                        versionLogList?.map((i, index) => (
                          <tr id={index}>
                            <td className="no-wrap">{i.documentVersion}</td>
                            <td className="no-wrap">{i.authorName}</td>
                            <td className="no-wrap">
                              {i.publishedDate
                                ? Moment(
                                  new Date(Date.parse(i.publishedDate))
                                ).format("DD-MMM-YYYY h:mm A")
                                : ""}
                            </td>
                            <td className="no-wrap">{i.checkerName}</td>
                            <td className="no-wrap">{i.approverName}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="table-noversion" colSpan={5}>
                            No version history
                          </td>
                        </tr>
                      )}
                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={VersionIcon} />{" "}
                  <span className="pl-10 properties-span">History log</span>
                </label>
                <div className="table-responsive mb-4 mt-3">
                  <table id="historyTable" style={{ width: "100%" }}>
                    <tbody>
                      {historyLogList?.map((i, index) => (
                        <>
                          <tr id={index}>
                            <th className="title-width">{i.status}</th>
                            <td
                              className={`history-date ${isRadioMobile ? "date-width" : ""
                                }`}
                            >
                              {i.createdDate
                                ? Moment(
                                  new Date(Date.parse(i.createdDate))
                                ).format("DD-MMM-YYYY h:mm A")
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <th colSpan={2}>
                              {i.reviewer + " " + "(" + i.type + ")"}
                            </th>
                          </tr>
                          <tr>
                            <td colSpan={2} className="history-comment">
                              {i.comments}
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Renew panle */}
      <div
        className="offcanvas offcanvas-end offcanvaspendingStyle"
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="renewScreen"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div
          className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}
        >
          <h6 id="offcanvasRightLabel" className="modal-title">
            Renew document
          </h6>
          <button
            onClick={ClearDataList}
            className={`text-reset offcavasclose ${classes.button} ${isMobile ? "pr-0" : ""
              }`}
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            style={{ backgroundColor: "white" }}
          >
            <img
              alt=""
              src={CrossIcon}
              className="cursor-pointer app-image-hover"
            />
          </button>{" "}
        </div>
        <div className="offcanvas-body px-4 pt-0" id="viewbar7">
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Document no</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataRevisedDocumentNo}
                >
                  {dataRevisedDocumentNo}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={SearchFileIcon} />{" "}
                  <span className="pl-10 properties-span">Document name</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label  Propertiestext-overflow fS ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentName}
                >
                  {dataDocumentName}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                  <span className="pl-10 properties-span">
                    Revised Document no.
                  </span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentNo}
                >
                  {dataDocumentNo}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 1</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory1.label}
                >
                  {selectcommonfield.dataCategory1.label
                    ? selectcommonfield.dataCategory1.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 2</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory2.label}
                >
                  {" "}
                  {selectcommonfield.dataCategory2.label
                    ? selectcommonfield.dataCategory2.label
                    : " - "}
                </label>
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Author</span>
                <span className="MuiFormHelperText-contained">*</span>
              </label>
              <div className={`${authorError === true ? "border-red" : ""}`}>
                <Select
                  className={`text-12-normal`}
                  classNamePrefix="assigngroups"
                  value={selectcommonfield.dataAuthor}
                  options={AuthorArrayList}
                  defaultValue={selectcommonfield.dataAuthor || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    handleRenewSelectChange(value, "dataAuthor")
                  }
                />
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Checker 1</span>
                <span className="MuiFormHelperText-contained">*</span>
              </label>
              <div className={`${checker1Error === true ? "border-red" : ""}`}>
                <Select
                  className={`text-12-normal`}
                  classNamePrefix="assigngroups"
                  value={selectcommonfield.checker1}
                  options={Checker1ArrayList}
                  defaultValue={selectcommonfield.checker1 || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    handleRenewSelectChange(value, "checker1")
                  }
                />
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Checker 2</span>
              </label>
              <Select
                className={`text-12-normal`}
                classNamePrefix="assigngroups"
                value={selectcommonfield.checker2}
                options={Checker2ArrayList}
                defaultValue={selectcommonfield.checker2 || "Select"}
                isMulti={false}
                isSearchable={true}
                isClearable={true}
                onChange={(value) => handleRenewSelectChange(value, "checker2")}
              />
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Consultant 1</span>
              </label>
              <Select
                className={`text-12-normal`}
                classNamePrefix="assigngroups"
                value={selectcommonfield.consultant1}
                options={Consultant1ArrayList}
                defaultValue={selectcommonfield.consultant1 || "Select"}
                isMulti={false}
                isSearchable={true}
                isClearable={true}
                onChange={(value) =>
                  handleRenewSelectChange(value, "consultant1")
                }
              />
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Consultant 2</span>
              </label>
              <Select
                className={`text-12-normal`}
                classNamePrefix="assigngroups"
                value={selectcommonfield.consultant2}
                options={Consultant2ArrayList}
                defaultValue={selectcommonfield.consultant2 || "Select"}
                isMulti={false}
                isSearchable={true}
                isClearable={true}
                onChange={(value) =>
                  handleRenewSelectChange(value, "consultant2")
                }
              />
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Approver 1</span>
                <span className="MuiFormHelperText-contained">*</span>
              </label>
              <div className={`${approver1Error === true ? "border-red" : ""}`}>
                <Select
                  className={`text-12-normal`}
                  classNamePrefix="assigngroups"
                  value={selectcommonfield.approver1}
                  options={Approver1ArrayList}
                  defaultValue={selectcommonfield.approver1 || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    handleRenewSelectChange(value, "approver1")
                  }
                />
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Approver 2</span>
              </label>
              <Select
                className={`text-12-normal`}
                classNamePrefix="assigngroups"
                value={selectcommonfield.approver2}
                options={Approver2ArrayList}
                defaultValue={selectcommonfield.approver2 || "Select"}
                isMulti={false}
                isSearchable={true}
                isClearable={true}
                onChange={(value) =>
                  handleRenewSelectChange(value, "approver2")
                }
              />
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 renew-style ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text date-bottom1 ${isMobile ? "pt-2" : ""
                    }`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Expiry date</span>
                </label>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    className="form-control"
                    emptyLabel="dd-mmm-yyyy"
                    keyboardIcon={<img src={dateIcon} />}
                    format="dd-MMM-yyyy"
                    value={expiryDate ? expiryDate : null}
                    size="small"
                    onChange={(e) => handleExpiryDateChange(e)}
                  />
                </MuiPickersUtilsProvider>
              </div>
              {expiryError === true ? (
                <span className="send-rework-label">
                  The expiry date must be greater than today
                </span>
              ) : (
                <></>
              )}
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={NotesIcon} />{" "}
                  <span className="pl-10 properties-span">Notes</span>
                </label>
                <textarea
                  value={renewNotes}
                  onChange={handlerenewNotesChange}
                  className="form-control border-radius shiptype-select mt-2"
                  style={{
                    width: "100%",
                    height: "70px",
                    fontSize: "12px",
                    maxHeight: "70px",
                  }}
                />
              </div>
            </div>
            <div className={`${isMobile ? "mt-4" : ""} col-12 mt-2 pb-3`}>
              <div className="inputTitle commonsearch-field">
                <input
                  type="checkbox"
                  className="password-checkbox"
                  name="request"
                  onChange={(e) => handleCheckboxChange(e)}
                />
                <span className="password-text">Is password protected?</span>
              </div>
            </div>
            {isPasswordProtected && (<>
              <div className="col-12 mt-2 pb-3">
                <div className="inputTitle commonsearch-field">
                  <img src={lock} className="password-icon" alt="" />
                  <span>
                    {" "}
                    New password&nbsp;
                    <span style={{ color: "#ee192d" }}>*</span>
                  </span>
                </div>
                <FormControl
                  variant="outlined"
                  className="w-100 mt-2"
                >
                  <OutlinedInput
                    className="password-inputs newdoc-newpassword"
                    id="newdoc-newpasswordid"
                    value={newPasswordValue}
                    onChange={(e) => setNewPasswordValue(e.target.value)}
                    type={showNewPassword ? "text" : "password"}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowNewPassword}
                          edge="end"
                        >
                          {showNewPassword ? (
                            <VisibilityOff className="eye-password-icon" />
                          ) : (
                            <Visibility className="eye-password-icon" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <div className="mt-0 font-13">
                  <span className="required-color font-weight400 newPasswordErrorText" id="newPasswordErrorText">

                  </span>
                </div>
              </div>
              <div className="col-12 mt-2 pb-3">
                <div className="inputTitle commonsearch-field">
                  <img src={lock} className="password-icon" alt="" />
                  <span>
                    {" "}
                    Confirm password&nbsp;
                    <span style={{ color: "#ee192d" }}>*</span>
                  </span>
                </div>
                <FormControl
                  variant="outlined"
                  className="w-100 mt-2"
                >
                  <OutlinedInput
                    className="password-inputs newdoc-confirmpassword"
                    id="newdoc-confirmpasswordid"
                    value={confirmPasswordValue}
                    onChange={(e) => setConfirmPasswordValue(e.target.value)}
                    type={showConfirmPassword ? "text" : "password"}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowConfirmPassword}
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <VisibilityOff className="eye-password-icon" />
                          ) : (
                            <Visibility className="eye-password-icon" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <div className="mt-0 font-13">
                  <span className="required-color font-weight400 confirmPasswordErrorText" id="confirmPasswordErrorText">

                  </span>
                </div>
              </div>
            </>)}
          </div>
          {hasError && (
            <div className="mt-1">
              <span style={{ color: "red" }}>Input values has duplicates</span>
            </div>
          )}

          <div className={`${isCancelMobile ? "col-12" : "d-flex"} mt-2`}>
            <button
              onClick={handleOpenAdminScreen}
              className={`btn btn-light input-group filter-backbtn`}
            >
              <img alt="" src={ButtonBackIcon} className="modal-img"></img>
              <span className="model-backlabel pl-5 backbtn">Back</span>
            </button>
            <button
              id="displaybuttoncolor"
              className={`btn btn-light input-group filter-archivekbtn p-2 ml-2 filter-nextbtn border border-2 border-danger ${isCancelMobile ? "mt-2" : "ml-10"
                }`}
              onClick={SubmitDocumentValidate}
            >
              <img alt="" src={ButtonSubmitIcon} className="modal-img"></img>
              <span className="model-label pl-5">Submit</span>
            </button>
          </div>
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={VersionIcon} />{" "}
                  <span className="pl-10 properties-span">Versions</span>
                </label>
                <div className="table-responsive mb-4 mt-3">
                  <table id="versionTable" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Version
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Author
                        </th>
                        <th
                          className={`${isSmallMobile ? "Publisheddate-width" : ""
                            } no-wrap`}
                        >
                          Published date/time
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Checker
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Approver{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {versionLogList && versionLogList?.length > 0 ? (
                        versionLogList?.map((i, index) => (
                          <tr id={index}>
                            <td className="no-wrap">{i.documentVersion}</td>
                            <td className="no-wrap">{i.authorName}</td>
                            <td className="no-wrap">
                              {i.publishedDate
                                ? Moment(
                                  new Date(Date.parse(i.publishedDate))
                                ).format("DD-MMM-YYYY h:mm A")
                                : ""}
                            </td>
                            <td className="no-wrap">{i.checkerName}</td>
                            <td className="no-wrap">{i.approverName}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="table-noversion" colSpan={5}>
                            No version history
                          </td>
                        </tr>
                      )}
                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Resubmit panle */}
      <div
        className="offcanvas offcanvas-end offcanvaspendingStyle"
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="resubmitScreen"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div
          className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}
        >
          <h6 id="offcanvasRightLabel" className="modal-title">
            Resubmit Document
          </h6>
          <button
            onClick={ClearDataList}
            className={`text-reset offcavasclose ${classes.button} ${isMobile ? "pr-0" : ""
              }`}
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            style={{ backgroundColor: "white" }}
          >
            <img
              alt=""
              src={CrossIcon}
              className="cursor-pointer app-image-hover"
            />
          </button>{" "}
        </div>
        <div className="offcanvas-body px-4 pt-0" id="viewbar4">
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Document no</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentNo}
                >
                  {dataDocumentNo}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={SearchFileIcon} />{" "}
                  <span className="pl-10 properties-span">Document name</span>
                </label>
                <input
                  type="text"
                  maxLength={255}
                  class="form-control resubmit-input-class border-radius mt-2 fS"
                  required
                  value={dataDocumentName}
                  onChange={handlenewDocumentName}
                />
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={SubCategoryIcon} />{" "}
                <span className="pl-10 properties-span">Category 1</span>
                <span className="MuiFormHelperText-contained">*</span>
              </label>
              <div className={`${category1Error === true ? "border-red" : ""}`}>
                <Select
                  className={`text-12-normal`}
                  classNamePrefix="assigngroups"
                  value={selectcommonfield.dataCategory1}
                  options={category1List}
                  defaultValue={selectcommonfield.dataCategory1 || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    handleResubmitSelectCategoryChange(value, "dataCategory1")
                  }
                />
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={SubCategoryIcon} />{" "}
                <span className="pl-10 properties-span">Category 2</span>
                <span className="MuiFormHelperText-contained">*</span>
              </label>
              <div className={`${category2Error === true ? "border-red" : ""}`}>
                <Select
                  className={`text-12-normal`}
                  classNamePrefix="assigngroups"
                  value={selectcommonfield.dataCategory2}
                  options={category2List}
                  defaultValue={selectcommonfield.dataCategory2 || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    handleResubmitSelectCategoryChange(value, "dataCategory2")
                  }
                />
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Author</span>
                <span className="MuiFormHelperText-contained">*</span>
              </label>
              <div className={`${authorError === true ? "border-red" : ""}`}>
                <Select
                  className={`text-12-normal`}
                  classNamePrefix="assigngroups"
                  value={selectcommonfield.dataAuthor}
                  options={AuthorArrayList}
                  defaultValue={selectcommonfield.dataAuthor || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    handleResubmitSelectChange(value, "dataAuthor")
                  }
                />
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Checker 1</span>
                <span className="MuiFormHelperText-contained">*</span>
              </label>
              <div className={`${checker1Error === true ? "border-red" : ""}`}>
                <Select
                  className={`text-12-normal`}
                  classNamePrefix="assigngroups"
                  value={selectcommonfield.checker1}
                  options={Checker1ArrayList}
                  defaultValue={selectcommonfield.checker1 || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    handleResubmitSelectChange(value, "checker1")
                  }
                />
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Checker 2</span>
              </label>
              <Select
                className={`text-12-normal`}
                classNamePrefix="assigngroups"
                value={selectcommonfield.checker2}
                options={Checker2ArrayList}
                defaultValue={selectcommonfield.checker2 || "Select"}
                isMulti={false}
                isSearchable={true}
                isClearable={true}
                onChange={(value) =>
                  handleResubmitSelectChange(value, "checker2")
                }
              />
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Consultant 1</span>
              </label>
              <Select
                className={`text-12-normal`}
                classNamePrefix="assigngroups"
                value={selectcommonfield.consultant1}
                options={Consultant1ArrayList}
                defaultValue={selectcommonfield.consultant1 || "Select"}
                isMulti={false}
                isSearchable={true}
                isClearable={true}
                onChange={(value) =>
                  handleResubmitSelectChange(value, "consultant1")
                }
              />
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Consultant 2</span>
              </label>
              <Select
                className={`text-12-normal`}
                classNamePrefix="assigngroups"
                value={selectcommonfield.consultant2}
                options={Consultant2ArrayList}
                defaultValue={selectcommonfield.consultant2 || "Select"}
                isMulti={false}
                isSearchable={true}
                isClearable={true}
                onChange={(value) =>
                  handleResubmitSelectChange(value, "consultant2")
                }
              />
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Approver 1</span>
                <span className="MuiFormHelperText-contained">*</span>
              </label>
              <div className={`${approver1Error === true ? "border-red" : ""}`}>
                <Select
                  className={`text-12-normal`}
                  classNamePrefix="assigngroups"
                  value={selectcommonfield.approver1}
                  options={Approver1ArrayList}
                  defaultValue={selectcommonfield.approver1 || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    handleResubmitSelectChange(value, "approver1")
                  }
                />
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <label
                className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                  }`}
              >
                <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                <span className="pl-10 properties-span">Approver 2</span>
              </label>
              <Select
                className={`text-12-normal`}
                classNamePrefix="assigngroups"
                value={selectcommonfield.approver2}
                options={Approver2ArrayList}
                defaultValue={selectcommonfield.approver2 || "Select"}
                isMulti={false}
                isSearchable={true}
                isClearable={true}
                onChange={(value) =>
                  handleResubmitSelectChange(value, "approver2")
                }
              />
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 renew-style mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text date-bottom2 ${isMobile ? "pt-2" : ""
                    }`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Expiry date</span>
                </label>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    className="form-control"
                    emptyLabel="dd-mmm-yyyy"
                    keyboardIcon={<img src={dateIcon} />}
                    format="dd-MMM-yyyy"
                    value={expiryDate ? expiryDate : null}
                    size="small"
                    onChange={(e) => handleExpiryDateChange(e)}
                  />
                </MuiPickersUtilsProvider>
              </div>
              {expiryError === true ? (
                <span className="send-rework-label">
                  The expiry date must be greater than today
                </span>
              ) : (
                <></>
              )}
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={NotesIcon} />{" "}
                  <span className="pl-10 properties-span">Notes</span>
                </label>
                <textarea
                  value={renewNotes}
                  onChange={handlerenewNotesChange}
                  className={`form-control border-radius properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  style={{
                    width: "100%",
                    height: "70px",
                    fontSize: "12px",
                    maxHeight: "70px",
                  }}
                />
              </div>
            </div>
            {/* Password Updation for Resubmit documents */}
            <div
              className={
                isChangePassword == false
                  ? "col-12 password-rowspace"
                  : "col-12 password-rowspace"
              }
            >
              <div className="inputTitle">
                {isChangePassword == false ? (
                  <img src={lock} className="password-icon" alt="" />
                ) : (
                  <input
                    type="checkbox"
                    className="password-checkbox margin-top4"
                    name="request"
                    onChange={(e) => handleCheckboxChange(e)}
                  />
                )}
                <span
                  className={
                    isChangePassword == false
                      ? "text-14-bold"
                      : "text-14-bold password-text "
                  }
                >
                  Is password protected?
                </span>
              </div>
              {isChangePassword == false && (
                <span className="view-answer">
                  {isPasswordProtected == true ? "Yes" : "No"}
                </span>
              )}
            </div>
            {isChangePassword == false &&
              isPasswordProtected == true &&
              userRole == UserRole.ADMIN && (
                <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 pb-2">
                  <div className="inputTitle">
                    <img src={lock} className="password-icon" alt="" />
                    <span className="text-14-bold"> Password</span>
                  </div>
                  <span className="view-answer">
                    {documentPassword && window.atob(documentPassword)}
                  </span>
                </div>
              )}
            {isPasswordProtected == true && isChangePassword == true && (
              <>
                <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 pb-3">
                  <div className="inputTitle">
                    <img src={lock} className="password-icon" alt="" />
                    <span className="text-14-bold">
                      {" "}
                      New password
                      <span className="required-color padding-left2">
                        *
                      </span>
                    </span>
                  </div>
                  <FormControl variant="outlined" className="w-100 mt-2">
                    <OutlinedInput
                      type={showNewPassword ? "text" : "password"}
                      className="password-inputs newdoc-newpassword"
                      id="newdoc-newpasswordid"
                      value={newPasswordValue}
                      onChange={(e) => setNewPasswordValue(e.target.value)}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowNewPassword}
                            edge="end"
                          >
                            {showNewPassword ? (
                              <VisibilityOff className="eye-password-icon" />
                            ) : (
                              <Visibility className="eye-password-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  <div className="mt-0 font-13">
                    <span
                      className="required-color font-weight400 newPasswordErrorText"
                      id="newPasswordErrorText"
                    ></span>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 pb-3">
                  <div className="inputTitle">
                    <img src={lock} className="password-icon" alt="" />
                    <span className="text-14-bold">
                      {" "}
                      Confirm password
                      <span className="required-color padding-left2">
                        *
                      </span>
                    </span>
                  </div>
                  <FormControl variant="outlined" className="w-100 mt-2">
                    <OutlinedInput
                      type={showConfirmPassword ? "text" : "password"}
                      className="password-inputs newdoc-confirmpassword"
                      id="newdoc-confirmpasswordid"
                      value={confirmPasswordValue}
                      onChange={(e) =>
                        setConfirmPasswordValue(e.target.value)
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowConfirmPassword}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff className="eye-password-icon" />
                            ) : (
                              <Visibility className="eye-password-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  <div className="mt-0 font-13">
                    <span
                      className="required-color font-weight400 confirmPasswordErrorText"
                      id="confirmPasswordErrorText"
                    ></span>
                  </div>
                </div>
              </>
            )}
          </div>

          {hasError2 && (
            <div className="mt-1">
              <span style={{ color: "red" }}>Input values has duplicates</span>
            </div>
          )}

          <div className={`${isCancelMobile ? "col-12" : "d-flex"} mt-2 mb-2`}>
            {isChangePassword == false && userRole == UserRole.ADMIN &&
              <button
                id=""
                onClick={() => changePassword()}
                className={`btn btn-light input-group filter-archivekbtn p-2 ml-2 ${""
                  }`}
              >
                <img alt="" src={RenewIcon} className="modal-img pt-1"></img>
                <span className="model-label pl-5">Change</span>
              </button>}
            {isChangePassword == true && userRole == UserRole.ADMIN &&
              <button
                id=""
                onClick={() => handleCancelUpdatePassword()}
                className={`btn btn-light input-group filter-backbtn p-2 ml-2`}
              >
                <img alt="" src={ButtonBackIcon} className="modal-img"></img>
                <span className="model-backlabel pl-5">Cancel</span>
              </button>}
            <button
              onClick={handleOpenAdminScreen}
              className={`btn btn-light input-group filter-backbtn ${isCancelMobile ? "mt-2" : "ml-10"}`}
            >
              <img alt="" src={ButtonBackIcon} className="modal-img"></img>
              <span className="model-backlabel pl-5 backbtn">Back</span>
            </button>
            <button
              id="displaybuttoncolor"
              onClick={ResubmitDocumentValidate}
              className={`btn btn-light input-group filter-archivekbtn p-2 ml-2 ${isCancelMobile ? "mt-2" : "ml-10"
                }`}
            >
              <img alt="" src={ButtonSubmitIcon} className="modal-img"></img>
              <span className="model-label pl-5">Submit</span>
            </button>
          </div>
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={VersionIcon} />{" "}
                  <span className="pl-10 properties-span">Versions</span>
                </label>
                <div className="table-responsive mb-4 mt-3">
                  <table id="versionTable" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Version
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Author
                        </th>
                        <th
                          className={`${isSmallMobile ? "Publisheddate-width" : ""
                            } no-wrap`}
                        >
                          Published date/time
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Checker
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Approver{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {versionLogList && versionLogList?.length > 0 ? (
                        versionLogList?.map((i, index) => (
                          <tr id={index}>
                            <td className="no-wrap">{i.documentVersion}</td>
                            <td className="no-wrap">{i.authorName}</td>
                            <td className="no-wrap">
                              {i.publishedDate
                                ? Moment(
                                  new Date(Date.parse(i.publishedDate))
                                ).format("DD-MMM-YYYY h:mm a")
                                : ""}
                            </td>
                            <td className="no-wrap">{i.checkerName}</td>
                            <td className="no-wrap">{i.approverName}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="table-noversion" colSpan={5}>
                            No version history
                          </td>
                        </tr>
                      )}
                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Obsolete panle */}
      <div
        className="offcanvas offcanvas-end offcanvaspendingStyle"
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="obsoleteScreen"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div
          className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}
        >
          <h6 id="offcanvasRightLabel" className="modal-title">
            Obsolete
          </h6>
          <button
            onClick={ClearDataList}
            className={`text-reset offcavasclose ${classes.button} ${isMobile ? "pr-0" : ""
              }`}
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            style={{ backgroundColor: "white" }}
          >
            <img
              alt=""
              src={CrossIcon}
              className="cursor-pointer app-image-hover"
            />
          </button>{" "}
        </div>

        <div className="offcanvas-body px-4 pt-0" id="viewbar5">
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Document no</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentNo}
                >
                  {dataDocumentNo}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={SearchFileIcon} />{" "}
                  <span className="pl-10 properties-span">Document name</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow fS ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentName}
                >
                  {dataDocumentName ? dataDocumentName : " - "}{" "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                  <span className="pl-10 properties-span">Author</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataAuthor.label}
                >
                  {selectcommonfield.dataAuthor.label
                    ? selectcommonfield.dataAuthor.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Version</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataVersion}
                >
                  {" "}
                  {dataVersion ? dataVersion : " - "}
                </label>
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 1</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory1.label}
                >
                  {selectcommonfield.dataCategory1.label
                    ? selectcommonfield.dataCategory1.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 2</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory2.label}
                >
                  {" "}
                  {selectcommonfield.dataCategory2.label
                    ? selectcommonfield.dataCategory2.label
                    : " - "}
                </label>
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Published date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataPublishedDate ? dataPublishedDate : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Expiry date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataExpiryDate ? dataExpiryDate : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={RemarkIcon} />{" "}
                  <span className="pl-10 properties-span">
                    Reason to obsolete
                  </span>
                  <span className="MuiFormHelperText-contained">*</span>
                </label>
                <textarea
                  onChange={handleReasonObsoleteChange}
                  value={reasonObsolete}
                  className="form-control border-radius shiptype-select mt-2"
                  id="obsoleteMessage"
                  style={{
                    width: "100%",
                    height: "70px",
                    fontSize: "12px",
                    maxHeight: "70px",
                  }}
                />
              </div>
            </div>
          </div>
          <div className={`${isCancelMobile ? "col-12" : "d-flex"} mt-4`}>
            <button
              onClick={handleOpenAdminScreen}
              className={`btn btn-light input-group filter-backbtn`}
            >
              <img alt="" src={ButtonBackIcon} className="modal-img"></img>
              <span className="model-backlabel pl-5 backbtn">Back</span>
            </button>
            <button
              id="displaybuttoncolor"
              onClick={handleObsoleteModalOpen}
              className={`btn btn-light input-group filter-archivekbtn p-2 ml-2 border border-3 border-danger ${isCancelMobile ? "mt-2" : "ml-10"
                }`}
            >
              <img alt="" src={obsoleteIcon} className="modal-img"></img>
              <span className="model-label pl-5 obsoletebtn">obsolete</span>
            </button>
          </div>
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={VersionIcon} />{" "}
                  <span className="pl-10 properties-span">Versions</span>
                </label>
                <div className="table-responsive mb-4 mt-3">
                  <table id="versionTable" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Version
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Author
                        </th>
                        <th
                          className={`${isSmallMobile ? "Publisheddate-width" : ""
                            } no-wrap`}
                        >
                          Published date/time
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Checker
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Approver{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {versionLogList && versionLogList?.length > 0 ? (
                        versionLogList?.map((i, index) => (
                          <tr id={index}>
                            <td className="no-wrap">{i.documentVersion}</td>
                            <td className="no-wrap">{i.authorName}</td>
                            <td className="no-wrap">
                              {i.publishedDate
                                ? Moment(
                                  new Date(Date.parse(i.publishedDate))
                                ).format("DD-MMM-YYYY h:mm A")
                                : ""}
                            </td>
                            <td className="no-wrap">{i.checkerName}</td>
                            <td className="no-wrap">{i.approverName}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="table-noversion" colSpan={5}>
                            No version history
                          </td>
                        </tr>
                      )}
                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Archive panle */}
      <div
        className="offcanvas offcanvas-end offcanvaspendingStyle"
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="archiveScreen"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div
          className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}
        >
          <h6 id="offcanvasRightLabel" className="modal-title">
            Archive
          </h6>
          <button
            onClick={ClearDataList}
            className={`text-reset offcavasclose ${classes.button} ${isMobile ? "pr-0" : ""
              }`}
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            style={{ backgroundColor: "white" }}
          >
            <img
              alt=""
              src={CrossIcon}
              className="cursor-pointer app-image-hover"
            />
          </button>{" "}
        </div>

        <div className="offcanvas-body px-4 pt-0" id="viewbar6">
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Document no</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentNo}
                >
                  {dataDocumentNo}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                }`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={SearchFileIcon} />{" "}
                  <span className="pl-10 properties-span">Document name</span>
                  &nbsp;
                </label>
                <label
                  className={`properties-label Propertiestext-overflow fS ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataDocumentName}
                >
                  {dataDocumentName ? dataDocumentName : " - "}{" "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={AuthorIcon} />{" "}
                  <span className="pl-10 properties-span">Author</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataAuthor.label}
                >
                  {selectcommonfield.dataAuthor.label
                    ? selectcommonfield.dataAuthor.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={NewPropertiesIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Version</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={dataVersion}
                >
                  {" "}
                  {dataVersion ? dataVersion : " - "}
                </label>
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 1</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory1.label}
                >
                  {" "}
                  {selectcommonfield.dataCategory1.label
                    ? selectcommonfield.dataCategory1.label
                    : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img
                    alt=""
                    className="properties-img"
                    src={SubCategoryIcon}
                  />{" "}
                  <span className="pl-10 properties-span">Category 2</span>
                </label>
                <label
                  className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  title={selectcommonfield.dataCategory2.label}
                >
                  {" "}
                  {selectcommonfield.dataCategory2.label
                    ? selectcommonfield.dataCategory2.label
                    : " - "}
                </label>
              </div>
            </div>

            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Published date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataPublishedDate ? dataPublishedDate : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={DateIcon} />{" "}
                  <span className="pl-10 properties-span">Expiry date</span>
                </label>
                <label
                  className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                >
                  {dataExpiryDate ? dataExpiryDate : " - "}
                </label>
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                } `}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={RemarkIcon} />{" "}
                  <span className="pl-10 properties-span">
                    Reason to Archive
                  </span>
                  <span className="MuiFormHelperText-contained">*</span>
                </label>
                <textarea
                  onChange={handleReasonArchiveChange}
                  value={reasonArchive}
                  className="form-control border-radius shiptype-select mt-2"
                  id="archviveMessage"
                  style={{
                    width: "100%",
                    height: "70px",
                    fontSize: "12px",
                    maxHeight: "70px",
                  }}
                />
              </div>
            </div>
          </div>

          <div className={`${isCancelMobile ? "col-12" : "d-flex"} mt-4`}>
            <button
              onClick={handleOpenAdminScreen}
              className={`btn btn-light input-group filter-backbtn`}
            >
              <img alt="" src={ButtonBackIcon} className="modal-img"></img>
              <span className="model-backlabel pl-5 backbtn">Back</span>
            </button>
            <button
              id="displaybuttoncolor"
              onClick={handleArchiveModalOpen}
              className={`btn btn-light input-group filter-archivekbtn p-2 ml-2 border border-3 border-danger ${isCancelMobile ? "mt-2" : "ml-10"
                }`}
            >
              <img alt="" src={ArchiveIcon} className="modal-img"></img>
              <span className="model-label pl-5">Archive</span>
            </button>
          </div>
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
            >
              <div className="form-group">
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <img alt="" className="properties-img" src={VersionIcon} />{" "}
                  <span className="pl-10 properties-span">Versions</span>
                </label>
                <div className="table-responsive mb-4 mt-3">
                  <table id="versionTable" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Version
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          Author
                        </th>
                        <th
                          className={`${isSmallMobile ? "Publisheddate-width" : ""
                            } no-wrap`}
                        >
                          Published date/time
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Checker
                        </th>
                        <th
                          className={`${isSmallMobile ? "Author-width" : ""}`}
                        >
                          {" "}
                          Approver{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {versionLogList && versionLogList?.length > 0 ? (
                        versionLogList?.map((i, index) => (
                          <tr id={index}>
                            <td className="no-wrap">{i.documentVersion}</td>
                            <td className="no-wrap">{i.authorName}</td>
                            <td className="no-wrap">
                              {i.publishedDate
                                ? Moment(
                                  new Date(Date.parse(i.publishedDate))
                                ).format("DD-MMM-YYYY h:mm A")
                                : ""}
                            </td>
                            <td className="no-wrap">{i.checkerName}</td>
                            <td className="no-wrap">{i.approverName}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="table-noversion" colSpan={5}>
                            No version history
                          </td>
                        </tr>
                      )}
                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*popup renew document */}
      <div
        className="modal fade modal-style"
        id="RenewPopupScreen"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pb-2 pl-20">
              <h5
                className="modal-title d-flex pl-10"
                id="exampleModalLongTitle"
              >
                <img alt="" src={WarningIcon} />
                &nbsp;<span className="mt-1 pl-5"></span>Warning
              </h5>
            </div>
            <div className="modal-body pl-20">
              <h5 className="warning-text">
                {" "}
                Are you sure you want to renew the document?
              </h5>
              <span className="app-label">
                All the information about the document will be renewed.
              </span>
            </div>
            <div className="modal-footer border-top-none justify-content-center pb-3">
              <button
                className={`btn btn-light input-group  d-flex ${isMobile ? "warning-btn-mobile p-1" : "warning-btn"
                  } `}
                data-bs-dismiss="modal"
              >
                <span className="rejectedstatus-color pl-10">No</span>{" "}
              </button>
              <button
                onClick={SubmitRenewDocument}
                className={`btn btn-light input-group d-flex ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                  }`}
                data-bs-dismiss="modal"
              >
                <span style={{ fontSize: "14px" }} className="model-label pl-10">Yes</span>{" "}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*popup obsolete document */}
      <div
        className="modal fade modal-style"
        id="ObsoletePopupScreen"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pb-2 pl-20">
              <h5
                className="modal-title d-flex pl-10"
                id="exampleModalLongTitle"
              >
                <img alt="" src={WarningIcon} />
                &nbsp;<span className="mt-1 pl-5"></span>Warning
              </h5>
            </div>
            <div className="modal-body pl-20">
              <h5 className="warning-text">
                {" "}
                Are you sure you want to obsolete the document?
              </h5>
              <span className="app-label"> Document will be hidden.</span>
            </div>
            <div className="modal-footer border-top-none justify-content-center pb-3">
              <button
                className={`btn btn-light input-group  d-flex ${isMobile ? "warning-btn-mobile p-1" : "warning-btn"
                  } `}
                data-bs-dismiss="modal"
              >
                <span className="rejectedstatus-color pl-10">No</span>{" "}
              </button>
              <button
                onClick={SubmitObsoleteDocument}
                className={`btn btn-light input-group d-flex ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                  }`}
                data-bs-dismiss="modal"
              >
                <span style={{ fontSize: "14px" }} className="model-label pl-10">Yes</span>{" "}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*archive  document */}
      <div
        className="modal fade modal-style"
        id="ArchivePopupScreen"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pb-2 pl-20">
              <h5
                className="modal-title d-flex pl-10"
                id="exampleModalLongTitle"
              >
                <img alt="" src={WarningIcon} />
                &nbsp;<span className="mt-1 pl-5"></span>Warning
              </h5>
            </div>
            <div className="modal-body pl-20">
              <h5 className="warning-text">
                {" "}
                Are you sure you want to archive the document?
              </h5>
              <span className="app-label">
                {" "}
                The document will be removed permanently
              </span>
            </div>
            <div className="modal-footer border-top-none justify-content-center pb-3">
              <button
                className={`btn btn-light input-group  d-flex ${isMobile ? "warning-btn-mobile p-1" : "warning-btn"
                  } `}
                data-bs-dismiss="modal"
              >
                <span className="rejectedstatus-color pl-10">No</span>{" "}
              </button>
              <button
                onClick={SubmitArchiveDocument}
                className={`btn btn-light input-group d-flex ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                  }`}
                data-bs-dismiss="modal"
              >
                <span style={{ fontSize: "14px" }} className="model-label pl-10">Yes</span>{" "}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*popup resubmit document */}
      <div
        className="modal fade modal-style"
        id="ResubmitPopupScreen"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pb-2 pl-20">
              <h5
                className="modal-title d-flex pl-10"
                id="exampleModalLongTitle"
              >
                <img alt="" src={WarningIcon} />
                &nbsp;<span className="mt-1 pl-5"></span>Warning
              </h5>
            </div>
            <div className="modal-body pl-20">
              <h5 className="warning-text">
                {" "}
                Are you sure you want to resubmit the document?
              </h5>
              <span className="app-label">
                All the information about the document will be resubmitted.
              </span>
            </div>
            <div className="modal-footer border-top-none justify-content-center pb-3">
              <button
                className={`btn btn-light input-group  d-flex ${isMobile ? "warning-btn-mobile  p-1" : "warning-btn"
                  }`}
                data-bs-dismiss="modal"
              >
                <span className="rejectedstatus-color pl-10">No</span>{" "}
              </button>
              <button
                onClick={ResubmitDocument}
                className={`btn btn-light input-group d-flex ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                  }`}
                data-bs-dismiss="modal"
              >
                <span style={{ fontSize: "14px" }} className="model-label pl-10">Yes</span>{" "}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*popup send back document */}
      <div
        className="modal fade modal-style"
        id="SendbackPopupScreen"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pb-2 pl-20">
              <h5
                className="modal-title d-flex pl-10"
                id="exampleModalLongTitle"
              >
                <img alt="" src={WarningIcon} />
                &nbsp;<span className="mt-1 pl-5"></span>Warning
              </h5>
            </div>
            <div className="modal-body pl-20">
              <h5 className="warning-text">
                {" "}
                Are you sure you want to send back the document?
              </h5>
              <span className="app-label">
                All the information about the document will be sent back.
              </span>
            </div>
            <div className="modal-footer border-top-none justify-content-center pb-3">
              <button
                className={`btn btn-light input-group  d-flex ${isMobile ? "warning-btn-mobile  p-1" : "warning-btn"
                  }`}
                data-bs-dismiss="modal"
              >
                <span className="rejectedstatus-color pl-10">No</span>{" "}
              </button>
              <button
                onClick={UpdateSendforReworkDocument}
                className={`btn btn-light input-group d-flex ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                  }`}
                data-bs-dismiss="modal"
              >
                <span style={{ fontSize: "14px" }} className="model-label pl-10">Yes</span>{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade modal-style"
        id="CancelRequestScreen"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pb-2 pl-20">
              <h5
                className="modal-title d-flex pl-10"
                id="exampleModalLongTitle"
              >
                <img src={WarningIcon} />
                &nbsp;<span className="mt-1 pl-5"></span>Warning
              </h5>
            </div>
            <div className="modal-body pl-20">
              <h5 className="warning-text">
                {" "}
                Are you sure you want to cancel the request ?
              </h5>
              <span className="app-label">
                {" "}
                The information about the request will be removed.
              </span>
            </div>
            <div className="modal-footer border-top-none justify-content-center pb-3">
              <button
                className={`btn btn-light input-group  d-flex ${isMobile ? "warning-btn-mobile  p-1" : "warning-btn"
                  }`}
                data-bs-dismiss="modal"
                onClick={ClearDataList}
              >
                <span className="rejectedstatus-color pl-10">No</span>{" "}
              </button>
              <button
                className={`btn btn-light input-group d-flex ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                  }`}
                data-bs-dismiss="modal"
                onClick={CancelReviewerrequest}
              >
                <span style={{ fontSize: "14px" }} className="model-label pl-10">Yes</span>{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyPendingTask;
